/* JapanSolved™ Site-wide Icon Pre-Ponder Page Intent Map — v1
   2026-07-07 update: purged icon references removed; morphology/double-frame doctrine added where relevant.
*/
window.JapanSolvedIconPageIntentMapSitewide = {
  "japan-art-antiques-gallery-guided-shopping": {
    "title": "Japan Art, Antiques & Gallery Guided Shopping Desk™",
    "page_wing": "art-antique-gallery-guided-shopping",
    "narrative_role": "in-person guided acquisition, gallery-route interpretation, dealer conversation support, object caution before commitment",
    "style_mood": "quiet gallery guidance, provenance caution, collector/editorial restraint",
    "icon_strategy_summary": "Use elegant free/ghost icons for gallery/dealer/acquisition zones, exact object/proof icons for caution cards, contained utility stamps only for payment/product steps. Avoid over-boxing because the page already carries gallery-card borders.",
    "zones": [
      {
        "section_key": "guided-acquisition-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-92px",
        "exact_icon_needs": [
          "gallery route",
          "provenance",
          "object judgment",
          "collector caution"
        ],
        "clickable": false,
        "notes": "One strong compass/lens/collector emblem can anchor the thesis if the section has horizontal breathing room.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0100",
            "label": "Collectors Diamond",
            "handle": "13-js-icon-collectors-13",
            "primary_category": "luxury-collectibles",
            "rotation_group": "collectors-diamond-13",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0134",
            "label": "Horse Knight",
            "handle": "horse",
            "primary_category": "strategy-movement",
            "rotation_group": "strategy-movement-horse-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0082",
            "label": "Decision Clarity Mono",
            "handle": "js-icon-micro-decision-clarity-mono-bw-v1",
            "primary_category": "advisory-intelligence",
            "rotation_group": "micro-decision-clarity-01",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "guided-acquisition-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading-copy",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "72-92px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "dealer-risk-pain-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "38-48px",
        "exact_icon_needs": [
          "dealer language",
          "seller claim",
          "condition proof",
          "export concern"
        ],
        "clickable": false,
        "notes": "Exact icons should match each pain sentence, not generic art.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0035",
            "label": "Value Driven Target Precision",
            "handle": "icon-15-japansolved-values-results-driven-target-precision",
            "primary_category": "results-outcomes",
            "rotation_group": "target-precision-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0047",
            "label": "Precision Target Monoline",
            "handle": "japansolved-solutions-icon-advisory-intelligence-precision-target-monoline",
            "primary_category": "results-outcomes",
            "rotation_group": "monoline-precision-target-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0100",
            "label": "Collectors Diamond",
            "handle": "13-js-icon-collectors-13",
            "primary_category": "luxury-collectibles",
            "rotation_group": "collectors-diamond-13",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "dealer-risk-pain-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "problem-signal",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "38-48px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "collector-route-cards",
        "hierarchy": "mid-high",
        "visual_owner": "card-border-title",
        "icon_role": "category-marker",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "44-58px",
        "exact_icon_needs": [
          "gallery",
          "antiques",
          "craft district",
          "private dealer",
          "art fair",
          "object handoff"
        ],
        "clickable": false,
        "notes": "Free icons work because cards already have borders.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0100",
            "label": "Collectors Diamond",
            "handle": "13-js-icon-collectors-13",
            "primary_category": "luxury-collectibles",
            "rotation_group": "collectors-diamond-13",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0161",
            "label": "Travel Access Cases 24a Airplane",
            "handle": "24a-js-case-library-vnext-icon-travel-access-cases-24a",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24a",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "collector-route-cards",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-visual-owner": "card-border-title",
          "data-jsi-role": "category-marker",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "44-58px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "route-reading-related",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "authentication provenance",
          "cultural asset",
          "private buyer",
          "cargo logistics"
        ],
        "clickable": true,
        "notes": "Clickable icons may follow the same destination as related cards; never self-link.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0100",
            "label": "Collectors Diamond",
            "handle": "13-js-icon-collectors-13",
            "primary_category": "luxury-collectibles",
            "rotation_group": "collectors-diamond-13",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0137",
            "label": "Airplane Jet 01",
            "handle": "airplane-jet-01",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "route-reading-related",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-size": "24-32px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "gallery-frame icon",
      "ceramic/lacquer/object icon",
      "dealer conversation icon"
    ],
    "content_id": "japan-art-antiques-gallery-guided-shopping",
    "canonical_handle": "japan-art-antiques-gallery-guided-shopping",
    "canonical_url": "https://japansolved.com/pages/japan-art-antiques-gallery-guided-shopping",
    "source_file": "Japan Art, Antiques & Gallery Guided Shopping Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 82552,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-art-antiques-authentication-provenance": {
    "title": "Japan Arts & Antiques Authentication & Provenance Intelligence Desk™",
    "page_wing": "arts-antiques-provenance",
    "narrative_role": "second-opinion due diligence for provenance, attribution, condition, seller claims, documentation, movement risk",
    "style_mood": "Provenance Noir / serious collector intelligence",
    "icon_strategy_summary": "Favor lens, document, proof-spine, diamond/collector, shield, and export-risk icons. High-level proof sections can use free centered icons; review/payment/boundary sections may use contained utility stamps.",
    "zones": [
      {
        "section_key": "provenance-before-purchase",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "76-96px",
        "exact_icon_needs": [
          "provenance",
          "proof spine",
          "review lens",
          "collector risk"
        ],
        "clickable": false,
        "notes": "Let one proof/lens/collector icon breathe; do not box it.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0100",
            "label": "Collectors Diamond",
            "handle": "13-js-icon-collectors-13",
            "primary_category": "luxury-collectibles",
            "rotation_group": "collectors-diamond-13",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0176",
            "label": "Verification Gap 30b Briefcase Lens",
            "handle": "30b-js-case-library-vnext-icon-verification-gap-30b",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0154",
            "label": "Sourcing Rare Assets Gem Box",
            "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
            "primary_category": "rare-asset-sourcing",
            "rotation_group": "case-library-sourcing-rare-assets-14",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "provenance-before-purchase",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "76-96px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "objects-of-consequence-grid",
        "hierarchy": "mid-high",
        "visual_owner": "category-title",
        "icon_role": "category-marker",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "44-56px",
        "exact_icon_needs": [
          "visual appetite",
          "proof spine",
          "movement risk"
        ],
        "clickable": false,
        "notes": "Three conceptual icons should be exact and unboxed.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0196",
            "label": "Elegant Branding Logo Design",
            "handle": "elegant-japansolved-branding-logo-design",
            "primary_category": "brand-logo",
            "rotation_group": "brand-logo-elegant-design",
            "priority": 58
          },
          {
            "registry_id": "JSICON-0210",
            "label": "JapanSolved Logo",
            "handle": "japansolved-logo",
            "primary_category": "brand-logo",
            "rotation_group": "brand-logo-japansolved-logo",
            "priority": 58
          },
          {
            "registry_id": "JSICON-0211",
            "label": "JapanSolved Logo VIP",
            "handle": "japansolved-logo-vip",
            "primary_category": "brand-logo",
            "rotation_group": "brand-logo-japansolved-logo-vip",
            "priority": 58
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0020",
            "label": "Capital Precision Flow",
            "handle": "icon-2-japansolved-solutions-investments-capital-precision-flow",
            "primary_category": "investments-capital",
            "rotation_group": "solution-capital-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "objects-of-consequence-grid",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-visual-owner": "category-title",
          "data-jsi-role": "category-marker",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "44-56px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "collector-lanes",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "object-category-marker",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "38-50px",
        "exact_icon_needs": [
          "textile",
          "prints paper art",
          "lacquer craft",
          "samurai armor",
          "ceramic sculpture"
        ],
        "clickable": false,
        "notes": "Registry coverage may be weak for exact object categories; use provenance/lens/collector fallbacks only until dedicated object icons exist.",
        "candidate_registry_ids": [],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "collector-lanes",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "object-category-marker",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "38-50px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "review-process-product-path",
        "hierarchy": "support",
        "visual_owner": "product-title-price",
        "icon_role": "utility-marker",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-38px",
        "exact_icon_needs": [
          "case review",
          "quotation estimate",
          "scope boundary",
          "payment terms"
        ],
        "clickable": false,
        "notes": "Utility contained icons are acceptable in commercial decision cards.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0128",
            "label": "How It Works Quotation Estimates",
            "handle": "08-js-how-it-works-vnext-icon-quotation-estimates-08",
            "primary_category": "quotation-estimate",
            "rotation_group": "how-it-works-quotation-estimates-08",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0095",
            "label": "Assess Checklist",
            "handle": "7-js-icon-assess",
            "primary_category": "case-review",
            "rotation_group": "assess-checklist-07",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0109",
            "label": "How It Works Wisdom-Led Assessment",
            "handle": "03-js-how-it-works-vnext-icon-wisdom-led-assessment-03",
            "primary_category": "advisory-intelligence",
            "rotation_group": "how-it-works-assessment-03",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0188",
            "label": "Scope Boundary Compass",
            "handle": "14-js-faq-vnext-icon-scope-boundary-compass-14",
            "primary_category": "faq-scope",
            "rotation_group": "faq-scope-boundary-compass-14",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "review-process-product-path",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "product-title-price",
          "data-jsi-role": "utility-marker",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-38px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "textile/kimono icon",
      "print/paper icon",
      "lacquer/craft icon",
      "armor/fittings icon",
      "ceramic icon"
    ],
    "content_id": "japan-art-antiques-authentication-provenance",
    "canonical_handle": "japan-art-antiques-authentication-provenance",
    "canonical_url": "https://japansolved.com/pages/japan-art-antiques-authentication-provenance",
    "source_file": "Japan Arts & Antiques Authentication & Provenance Intelligence Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 166949,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-beauty-longevity-product-sourcing-compliance": {
    "title": "Japan Beauty & Longevity Product Sourcing Compliance Desk™",
    "page_wing": "beauty-longevity-product-compliance",
    "narrative_role": "product sourcing review for beauty, wellness-adjacent, longevity-branded products where claims, labels, ingredients, shipping, and import rules matter",
    "style_mood": "clean compliance, soft beauty restraint, logistics caution",
    "icon_strategy_summary": "Use exact product-label, claim-risk, compliance, shelf-life, shipping, and supplier-route markers. Containers may work for compliance/payment cards, but product desire/route thesis should use freer icons or no icon.",
    "zones": [
      {
        "section_key": "product-sourcing-before-claims",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "68-88px",
        "exact_icon_needs": [
          "product label",
          "claim review",
          "compliance route",
          "sourcing caution"
        ],
        "clickable": false,
        "notes": "Major thesis should not receive a tiny badge.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0134",
            "label": "Horse Knight",
            "handle": "horse",
            "primary_category": "strategy-movement",
            "rotation_group": "strategy-movement-horse-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0154",
            "label": "Sourcing Rare Assets Gem Box",
            "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
            "primary_category": "rare-asset-sourcing",
            "rotation_group": "case-library-sourcing-rare-assets-14",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "product-sourcing-before-claims",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "68-88px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "normal-sourcing-failure-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "36-46px",
        "exact_icon_needs": [
          "marketplace listing risk",
          "personal use vs resale",
          "translation gap",
          "wrong first step"
        ],
        "clickable": false,
        "notes": "Exact risk icons: listing, split route, language gap, wrong step.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0173",
            "label": "Language Gap Chat Bubbles",
            "handle": "28-js-case-library-vnext-icon-language-gap-28",
            "primary_category": "language-gap",
            "rotation_group": "case-library-language-gap-28",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0199",
            "label": "Investment Capital Mono Line",
            "handle": "03-js-solutions-vnext-icon-investment-capital-mono-line-03",
            "primary_category": "investment-capital",
            "rotation_group": "solutions-investment-capital-mono-line-03",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0132",
            "label": "Creatives Transparent Pencil",
            "handle": "16c-js-icon-creatives-transparent",
            "primary_category": "creative-assets",
            "rotation_group": "creative-assets-pencil-16c",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "normal-sourcing-failure-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "problem-signal",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "36-46px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "route-logic-note",
        "hierarchy": "support",
        "visual_owner": "copy",
        "icon_role": "route-signal",
        "preferred_treatment": "inline-micro",
        "preferred_placement": "inline-left-micro",
        "preferred_container": "none",
        "size_range": "20-28px",
        "exact_icon_needs": [
          "route logic",
          "referral",
          "supplier search",
          "proxy QA",
          "logistics review"
        ],
        "clickable": false,
        "notes": "Small inline marker only.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0099",
            "label": "Layered Philosophy Compass 17",
            "handle": "17-js-icon-layered-philosophy-17",
            "primary_category": "advisory-intelligence",
            "rotation_group": "layered-philosophy-17",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0104",
            "label": "Japan Intelligence Globe Pin",
            "handle": "03b-js-icon-japan-intelligence-03b",
            "primary_category": "japan-intelligence",
            "rotation_group": "japan-intelligence-03b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "route-logic-note",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "copy",
          "data-jsi-role": "route-signal",
          "data-jsi-treatment": "inline-micro",
          "data-jsi-placement": "inline-left-micro",
          "data-jsi-container": "none",
          "data-jsi-size": "20-28px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "product-payment-cards",
        "hierarchy": "support",
        "visual_owner": "price-cta",
        "icon_role": "utility-marker",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-38px",
        "exact_icon_needs": [
          "case review",
          "supplier search",
          "shipping prep",
          "compliance review"
        ],
        "clickable": false,
        "notes": "Commercial cards may use contained stamps.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0095",
            "label": "Assess Checklist",
            "handle": "7-js-icon-assess",
            "primary_category": "case-review",
            "rotation_group": "assess-checklist-07",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0109",
            "label": "How It Works Wisdom-Led Assessment",
            "handle": "03-js-how-it-works-vnext-icon-wisdom-led-assessment-03",
            "primary_category": "advisory-intelligence",
            "rotation_group": "how-it-works-assessment-03",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0053",
            "label": "Engagement Preparedness Pencil",
            "handle": "icon-06-japansolved-engagementbrief-engagement-preparedness",
            "primary_category": "engagement-brief",
            "rotation_group": "engagement-preparedness-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0072",
            "label": "Risk Compliance Analysis Mono",
            "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
            "primary_category": "risk-compliance",
            "rotation_group": "footer-risk-compliance-01",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "product-payment-cards",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "price-cta",
          "data-jsi-role": "utility-marker",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-38px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "cosmetic bottle icon",
      "ingredient/label icon",
      "shelf-life/batch icon",
      "claim-risk icon"
    ],
    "content_id": "japan-beauty-longevity-product-sourcing-compliance",
    "canonical_handle": "japan-beauty-longevity-product-sourcing-compliance",
    "canonical_url": "https://japansolved.com/pages/japan-beauty-longevity-product-sourcing-compliance",
    "source_file": "Japan Beauty & Longevity Product Sourcing Compliance Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 80245,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-bespoke-experience-custom-itinerary": {
    "title": "Japan Bespoke Experience Design & Custom Itinerary Desk™",
    "page_wing": "travel-cultural-access-bespoke",
    "narrative_role": "custom experience architecture, Deep Japan Layer, twelve-door route design, program mixers, scheduling/payment path",
    "style_mood": "editorial route architecture, warm premium travel intelligence",
    "icon_strategy_summary": "Use equal boxed icons only when the chosen icon asset is a free-floating glyph with no intrinsic circle/box/badge frame. Avoid double framing. Twelve-door architecture cards are currently no-icon/number-led unless explicitly re-enabled. Hard overrides may be used for exact user taste, but morphology rules still prevent boxed-slot double frames.",
    "zones": [
      {
        "section_key": "deep-japan-layer",
        "hierarchy": "high",
        "visual_owner": "heading-card-concept",
        "icon_role": "concept-emblem",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "48-64px",
        "exact_icon_needs": [
          "local context",
          "human warmth",
          "scene-reading"
        ],
        "clickable": false,
        "notes": "Important emotional layer; icons should be free, larger, and human.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0021",
            "label": "Relocation Transition Move",
            "handle": "icon-3-japansolved-solutions-property-relocation-transition-move",
            "primary_category": "property-relocation",
            "rotation_group": "solution-relocation-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "deep-japan-layer",
          "data-jsi-hierarchy": "high",
          "data-jsi-visual-owner": "heading-card-concept",
          "data-jsi-role": "concept-emblem",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "48-64px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "twelve-architecture-doors",
        "hierarchy": "high",
        "visual_owner": "number-title",
        "icon_role": "ghost-category-marker",
        "preferred_treatment": "ghost",
        "preferred_placement": "upper-right-ghost",
        "preferred_container": "none",
        "size_range": "34-46px",
        "exact_icon_needs": [
          "culture craft",
          "social human experience",
          "movement nature",
          "food dining",
          "shopping style",
          "arts gallery",
          "technology future",
          "location route",
          "wellness reset",
          "seasonal festival",
          "family route",
          "collector hunt"
        ],
        "clickable": true,
        "notes": "Number/title own the card; icon whispers upper-right.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0104",
            "label": "Japan Intelligence Globe Pin",
            "handle": "03b-js-icon-japan-intelligence-03b",
            "primary_category": "japan-intelligence",
            "rotation_group": "japan-intelligence-03b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0134",
            "label": "Horse Knight",
            "handle": "horse",
            "primary_category": "strategy-movement",
            "rotation_group": "strategy-movement-horse-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0137",
            "label": "Airplane Jet 01",
            "handle": "airplane-jet-01",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0139",
            "label": "Airplane Jet 07",
            "handle": "airplane-jet-07",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-07",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "twelve-architecture-doors",
          "data-jsi-hierarchy": "high",
          "data-jsi-visual-owner": "number-title",
          "data-jsi-role": "ghost-category-marker",
          "data-jsi-treatment": "ghost",
          "data-jsi-placement": "upper-right-ghost",
          "data-jsi-container": "none",
          "data-jsi-size": "34-46px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "program-mixers",
        "hierarchy": "mid-high",
        "visual_owner": "card-title",
        "icon_role": "program-archetype-marker",
        "preferred_treatment": "top-left-free-or-ghost",
        "preferred_placement": "top-left-inline",
        "preferred_container": "none",
        "size_range": "32-44px",
        "exact_icon_needs": [
          "stylish tokyo weekend",
          "quiet cultural reset",
          "family without chaos",
          "collector hunt",
          "one month private retreat",
          "high discretion private japan"
        ],
        "clickable": false,
        "notes": "Treat as story archetypes, not generic service cards.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          },
          {
            "registry_id": "JSICON-0071",
            "label": "Key Inside Circle",
            "handle": "japansolved-key-inside-circle",
            "primary_category": "private-access",
            "rotation_group": "private-access-key-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0048",
            "label": "Restricted Access Monoline",
            "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
            "primary_category": "privacy-discretion",
            "rotation_group": "monoline-restricted-access-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0153",
            "label": "Visiting Japan Privately Keyhole",
            "handle": "16-js-case-library-vnext-icon-accessing-japan-privately-16",
            "primary_category": "private-japan-access",
            "rotation_group": "case-library-private-japan-16",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "program-mixers",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "program-archetype-marker",
          "data-jsi-treatment": "top-left-free-or-ghost",
          "data-jsi-placement": "top-left-inline",
          "data-jsi-container": "none",
          "data-jsi-size": "32-44px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "product-ladder",
        "hierarchy": "support",
        "visual_owner": "price-cta",
        "icon_role": "utility-marker",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-38px",
        "exact_icon_needs": [
          "design review",
          "design brief",
          "private program",
          "program consulting"
        ],
        "clickable": false,
        "notes": "Commercial decision layer; contained stamps are acceptable.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0081",
            "label": "Capital Program",
            "handle": "japansolved-capital-program",
            "primary_category": "investments-capital",
            "rotation_group": "capital-program-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0164",
            "label": "Travel Access Cases 24d Jet Path",
            "handle": "24d-js-case-library-vnext-icon-travel-access-cases-24d",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24d",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0132",
            "label": "Creatives Transparent Pencil",
            "handle": "16c-js-icon-creatives-transparent",
            "primary_category": "creative-assets",
            "rotation_group": "creative-assets-pencil-16c",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0133",
            "label": "Creatives Pencil",
            "handle": "16a-js-icon-creatives",
            "primary_category": "creative-assets",
            "rotation_group": "creative-assets-pencil-16a",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0196",
            "label": "Elegant Branding Logo Design",
            "handle": "elegant-japansolved-branding-logo-design",
            "primary_category": "brand-logo",
            "rotation_group": "brand-logo-elegant-design",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "product-ladder",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "price-cta",
          "data-jsi-role": "utility-marker",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-38px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "flow-rows",
        "hierarchy": "mid",
        "visual_owner": "number",
        "icon_role": "workflow-stage",
        "preferred_treatment": "centered-under-number-or-none",
        "preferred_placement": "centered-under-number",
        "preferred_container": "none",
        "size_range": "28-38px",
        "exact_icon_needs": [
          "choose themes",
          "feasibility route logic",
          "paid path",
          "doors open",
          "schedule window"
        ],
        "clickable": false,
        "notes": "If numbers already own hierarchy, some rows may stay icon-free.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0184",
            "label": "Structure Layer Stack",
            "handle": "18-js-faq-vnext-icon-structure-layer-stack-18",
            "primary_category": "faq-structure",
            "rotation_group": "faq-structure-layer-stack-18",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0126",
            "label": "How It Works Declined Redirected",
            "handle": "07-js-how-it-works-vnext-icon-declined-redirected-07",
            "primary_category": "routing-referral",
            "rotation_group": "how-it-works-declined-redirected-07",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0061",
            "label": "Engagement Brief Client Onboarding",
            "handle": "icon-10-japansolved-engagementbrief-client-onboarding",
            "primary_category": "client-onboarding",
            "rotation_group": "engagement-client-onboarding-01",
            "priority": 64
          },
          {
            "registry_id": "JSICON-0035",
            "label": "Value Driven Target Precision",
            "handle": "icon-15-japansolved-values-results-driven-target-precision",
            "primary_category": "results-outcomes",
            "rotation_group": "target-precision-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "flow-rows",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "number",
          "data-jsi-role": "workflow-stage",
          "data-jsi-treatment": "centered-under-number-or-none",
          "data-jsi-placement": "centered-under-number",
          "data-jsi-container": "none",
          "data-jsi-size": "28-38px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "food/dining icon",
      "fashion/style hanger icon",
      "gallery/museum icon",
      "technology/circuit icon",
      "onsen/wellness icon",
      "family route icon"
    ],
    "content_id": "japan-bespoke-experience-custom-itinerary",
    "canonical_handle": "japan-bespoke-experience-custom-itinerary",
    "canonical_url": "https://japansolved.com/pages/japan-bespoke-experience-custom-itinerary",
    "source_file": "Japan Bespoke Experience Design & Custom Itinerary Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 326810,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      },
      {
        "section_key": "twelve-architecture-doors-card-icons",
        "reason": "User judged architecture-card icons noisy on Bespoke; keep number-led unless later explicitly restored."
      }
    ],
    "priority_for_rebake": "high",
    "last_icon_morphology_update": "2026-07-07"
  },
  "japan-bonsai-export-compliance": {
    "title": "Japan Bonsai Export & Compliance Desk™",
    "page_wing": "bonsai-living-cargo-compliance",
    "narrative_role": "living plant export feasibility, nursery coordination, quarantine and movement review",
    "style_mood": "living cargo seriousness, calm compliance, fragile object logistics",
    "icon_strategy_summary": "Use plant/quarantine/document/logistics icons where available, but registry coverage likely lacks dedicated bonsai/plant symbols. Prefer free symbolic icon in thesis, utility stamps for quarantine/payment, logistics/truck for movement.",
    "zones": [
      {
        "section_key": "living-cargo-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "68-88px",
        "exact_icon_needs": [
          "living cargo",
          "plant quarantine",
          "export compliance",
          "nursery coordination"
        ],
        "clickable": false,
        "notes": "Needs a dedicated bonsai/plant icon eventually; use compliance/logistics fallback now.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0062",
            "label": "Execution Coordination Nodes",
            "handle": "icon-14-japansolved-execution-coordination",
            "primary_category": "execution-support",
            "rotation_group": "execution-coordination-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0134",
            "label": "Horse Knight",
            "handle": "horse",
            "primary_category": "strategy-movement",
            "rotation_group": "strategy-movement-horse-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0137",
            "label": "Airplane Jet 01",
            "handle": "airplane-jet-01",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "living-cargo-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "68-88px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "risk-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "36-46px",
        "exact_icon_needs": [
          "plant health",
          "quarantine documents",
          "nursery handoff",
          "export timing"
        ],
        "clickable": false,
        "notes": "Exact plant export risks.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0134",
            "label": "Horse Knight",
            "handle": "horse",
            "primary_category": "strategy-movement",
            "rotation_group": "strategy-movement-horse-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "risk-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "problem-signal",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "36-46px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "movement-plan",
        "hierarchy": "mid",
        "visual_owner": "step-title",
        "icon_role": "workflow-stage",
        "preferred_treatment": "centered-under-number",
        "preferred_placement": "centered-under-number",
        "preferred_container": "none",
        "size_range": "30-40px",
        "exact_icon_needs": [
          "document review",
          "carrier route",
          "packing handoff",
          "inspection timing"
        ],
        "clickable": false,
        "notes": "Process icon should match stage.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0157",
            "label": "Verification Gap Document",
            "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30a",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0174",
            "label": "Verification Gap 30c Magnifier",
            "handle": "30c-js-case-library-vnext-icon-verification-gap-30c",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30c",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0134",
            "label": "Horse Knight",
            "handle": "horse",
            "primary_category": "strategy-movement",
            "rotation_group": "strategy-movement-horse-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "movement-plan",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "step-title",
          "data-jsi-role": "workflow-stage",
          "data-jsi-treatment": "centered-under-number",
          "data-jsi-placement": "centered-under-number",
          "data-jsi-container": "none",
          "data-jsi-size": "30-40px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "payment-products",
        "hierarchy": "support",
        "visual_owner": "price-cta",
        "icon_role": "utility-marker",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-38px",
        "exact_icon_needs": [
          "case review",
          "export planning",
          "cargo handoff"
        ],
        "clickable": false,
        "notes": "Contained acceptable.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0095",
            "label": "Assess Checklist",
            "handle": "7-js-icon-assess",
            "primary_category": "case-review",
            "rotation_group": "assess-checklist-07",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0109",
            "label": "How It Works Wisdom-Led Assessment",
            "handle": "03-js-how-it-works-vnext-icon-wisdom-led-assessment-03",
            "primary_category": "advisory-intelligence",
            "rotation_group": "how-it-works-assessment-03",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0134",
            "label": "Horse Knight",
            "handle": "horse",
            "primary_category": "strategy-movement",
            "rotation_group": "strategy-movement-horse-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "payment-products",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "price-cta",
          "data-jsi-role": "utility-marker",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-38px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "bonsai tree icon",
      "plant quarantine icon",
      "nursery handoff icon",
      "phytosanitary document icon"
    ],
    "content_id": "japan-bonsai-export-compliance",
    "canonical_handle": "japan-bonsai-export-compliance",
    "canonical_url": "https://japansolved.com/pages/japan-bonsai-export-compliance",
    "source_file": "Japan Bonsai Export & Compliance Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 86255,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-celebrity-concierge-private-access": {
    "title": "Japan Celebrity Concierge & Private Access Desk™",
    "page_wing": "vip-private-access-discretion",
    "narrative_role": "low-profile Japan routing for executives, public figures, private families, visibility-sensitive guests",
    "style_mood": "quiet VIP, privacy, access, controlled movement",
    "icon_strategy_summary": "Use discretion/key/crown/eye-off/private-access icons sparingly. High-level sections should use free emblem or ghost, not boxed stamps. Clickable related route icons only when route cards link elsewhere.",
    "zones": [
      {
        "section_key": "private-access-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-92px",
        "exact_icon_needs": [
          "private access",
          "discretion",
          "low profile",
          "priority handling"
        ],
        "clickable": false,
        "notes": "Keyhole/shield/crown emblem, unboxed.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0071",
            "label": "Key Inside Circle",
            "handle": "japansolved-key-inside-circle",
            "primary_category": "private-access",
            "rotation_group": "private-access-key-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0024",
            "label": "Curated Access Gateway",
            "handle": "icon-6-japansolved-solutions-travel-cultural-access-curated-gateway",
            "primary_category": "travel-cultural-access",
            "rotation_group": "solution-cultural-access-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0165",
            "label": "Access Gap Doorway",
            "handle": "27-js-case-library-vnext-icon-access-gap-27",
            "primary_category": "access-gap",
            "rotation_group": "case-library-access-gap-27",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0203",
            "label": "Cultural Access Mono Line",
            "handle": "07-js-solutions-vnext-icon-travel-cultural-access-mono-line-07",
            "primary_category": "cultural-access",
            "rotation_group": "solutions-cultural-access-mono-line-07",
            "priority": 53
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "private-access-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "72-92px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "visibility-risk-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "risk-signal",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "38-50px",
        "exact_icon_needs": [
          "public visibility",
          "private rooms",
          "movement control",
          "discreet communication"
        ],
        "clickable": false,
        "notes": "Avoid loud icons; quiet line icons only.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0161",
            "label": "Travel Access Cases 24a Airplane",
            "handle": "24a-js-case-library-vnext-icon-travel-access-cases-24a",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24a",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0111",
            "label": "How It Works Scope Discipline",
            "handle": "20-js-how-it-works-vnext-icon-scope-discipline-20",
            "primary_category": "scope-discipline",
            "rotation_group": "how-it-works-scope-discipline-20",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "visibility-risk-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "risk-signal",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "38-50px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "tier-access-products",
        "hierarchy": "support",
        "visual_owner": "price-cta",
        "icon_role": "tier-badge",
        "preferred_treatment": "contained-or-free-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-40px",
        "exact_icon_needs": [
          "private access review",
          "discreet routing",
          "retainer priority"
        ],
        "clickable": false,
        "notes": "Use key/crown/shield with restraint.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0042",
            "label": "Access Retainer Priority Key A",
            "handle": "icon-17-a-japansolved-tiers-private-access-retainer-priority",
            "primary_category": "retainer-priority",
            "rotation_group": "retainer-priority-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0043",
            "label": "Access Retainer Priority Key B",
            "handle": "icon-17-b-japansolved-tiers-private-access-retainer-priority",
            "primary_category": "retainer-priority",
            "rotation_group": "retainer-priority-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0048",
            "label": "Restricted Access Monoline",
            "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
            "primary_category": "privacy-discretion",
            "rotation_group": "monoline-restricted-access-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          },
          {
            "registry_id": "JSICON-0171",
            "label": "Secret Professional 33 Tie Shield",
            "handle": "33-js-case-library-vnext-icon-discreet-professional-33",
            "primary_category": "secret-professional",
            "rotation_group": "case-library-secret-professional-33",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "tier-access-products",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "price-cta",
          "data-jsi-role": "tier-badge",
          "data-jsi-treatment": "contained-or-free-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-40px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "related-route-cards",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "vip navigation",
          "nightlife support",
          "private companion",
          "celebrity concierge"
        ],
        "clickable": true,
        "notes": "Icon click follows card destination.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0042",
            "label": "Access Retainer Priority Key A",
            "handle": "icon-17-a-japansolved-tiers-private-access-retainer-priority",
            "primary_category": "retainer-priority",
            "rotation_group": "retainer-priority-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0114",
            "label": "How It Works Private Intake",
            "handle": "01-js-how-it-works-vnext-icon-private-intake-01",
            "primary_category": "native-intake",
            "rotation_group": "how-it-works-private-intake-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0024",
            "label": "Curated Access Gateway",
            "handle": "icon-6-japansolved-solutions-travel-cultural-access-curated-gateway",
            "primary_category": "travel-cultural-access",
            "rotation_group": "solution-cultural-access-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-route-cards",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-size": "24-32px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "visibility-sensitive guest icon",
      "private-room icon",
      "low-profile movement icon"
    ],
    "content_id": "japan-celebrity-concierge-private-access",
    "canonical_handle": "japan-celebrity-concierge-private-access",
    "canonical_url": null,
    "source_file": "Japan Celebrity Concierge & Private Access Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 64914,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-cosmetic-surgery-image-route-review": {
    "title": "Japan Cosmetic Surgery & Image Solutions Desk™",
    "page_wing": "health-beauty-cosmetic-route",
    "narrative_role": "cosmetic surgery/image route review for clinic choice, timing, privacy, recovery logistics, identity goals",
    "style_mood": "sensitive beauty route, calm privacy, medical-adjacent discipline",
    "icon_strategy_summary": "Use clinic/protocol, privacy, calendar/recovery, decision-clarity, and image-route symbols. Avoid decorative beauty icons that imply medical recommendation. Contained utility stamps acceptable for submission/payment and boundaries.",
    "zones": [
      {
        "section_key": "cosmetic-route-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "68-88px",
        "exact_icon_needs": [
          "clinic protocol",
          "image route",
          "privacy",
          "recovery timing"
        ],
        "clickable": false,
        "notes": "Medical-adjacent but non-clinical: calm and precise.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0074",
            "label": "Clinic Protocol Review Mono",
            "handle": "js-icon-micro-clinic-protocol-review-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "micro-clinic-protocol-review-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          },
          {
            "registry_id": "JSICON-0049",
            "label": "Feasibility Assessment Globe",
            "handle": "icon-11-japansolved-feasibility-assessment",
            "primary_category": "feasibility-assessment",
            "rotation_group": "feasibility-assessment-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0102",
            "label": "Strategy Target",
            "handle": "02-js-icon-strategy-02",
            "primary_category": "strategy-alignment",
            "rotation_group": "strategy-target-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0103",
            "label": "Japan Intelligence Globe Shield",
            "handle": "03a-js-icon-japan-intelligence-03a",
            "primary_category": "japan-intelligence",
            "rotation_group": "japan-intelligence-03a",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "cosmetic-route-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "68-88px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "route-risk-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "risk-signal",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "36-48px",
        "exact_icon_needs": [
          "clinic choice",
          "before after claims",
          "recovery window",
          "privacy exposure"
        ],
        "clickable": false,
        "notes": "Must not look like treatment advice.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0044",
            "label": "Tier Maximum Discretion Eye",
            "handle": "icon-18-japansolved-tiers-discreet-confidential-maximum-discretion",
            "primary_category": "privacy-discretion",
            "rotation_group": "service-tier-discretion-01",
            "priority": 64
          },
          {
            "registry_id": "JSICON-0071",
            "label": "Key Inside Circle",
            "handle": "japansolved-key-inside-circle",
            "primary_category": "private-access",
            "rotation_group": "private-access-key-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0082",
            "label": "Decision Clarity Mono",
            "handle": "js-icon-micro-decision-clarity-mono-bw-v1",
            "primary_category": "advisory-intelligence",
            "rotation_group": "micro-decision-clarity-01",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "route-risk-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "risk-signal",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "36-48px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "submission-boundaries",
        "hierarchy": "support",
        "visual_owner": "copy",
        "icon_role": "utility-warning",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-36px",
        "exact_icon_needs": [
          "scope boundary",
          "no medical advice",
          "payment intake",
          "privacy"
        ],
        "clickable": false,
        "notes": "Contained warnings are appropriate.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0188",
            "label": "Scope Boundary Compass",
            "handle": "14-js-faq-vnext-icon-scope-boundary-compass-14",
            "primary_category": "faq-scope",
            "rotation_group": "faq-scope-boundary-compass-14",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0127",
            "label": "How It Works No Unpaid Strategy",
            "handle": "18-js-how-it-works-vnext-icon-no-unpaid-strategy-18",
            "primary_category": "paid-intake-boundary",
            "rotation_group": "how-it-works-no-unpaid-strategy-18",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0129",
            "label": "How It Works Scope Prepared",
            "handle": "09-js-how-it-works-vnext-icon-scope-prepared-09",
            "primary_category": "scope-preparation",
            "rotation_group": "how-it-works-scope-prepared-09",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0026",
            "label": "CurrentColor Protection Shield",
            "handle": "icon-8-japansolved-solutions-discreet-sensitive-confidential-protection-currentcolor",
            "primary_category": "privacy-discretion",
            "rotation_group": "solution-protection-01",
            "priority": 67
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "submission-boundaries",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "copy",
          "data-jsi-role": "utility-warning",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-36px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "after-submission-flow",
        "hierarchy": "mid",
        "visual_owner": "number",
        "icon_role": "workflow-stage",
        "preferred_treatment": "centered-under-number",
        "preferred_placement": "centered-under-number",
        "preferred_container": "none",
        "size_range": "28-38px",
        "exact_icon_needs": [
          "case review",
          "protocol review",
          "directional assessment",
          "quotation estimate"
        ],
        "clickable": false,
        "notes": "Process exactness.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0128",
            "label": "How It Works Quotation Estimates",
            "handle": "08-js-how-it-works-vnext-icon-quotation-estimates-08",
            "primary_category": "quotation-estimate",
            "rotation_group": "how-it-works-quotation-estimates-08",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0095",
            "label": "Assess Checklist",
            "handle": "7-js-icon-assess",
            "primary_category": "case-review",
            "rotation_group": "assess-checklist-07",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0109",
            "label": "How It Works Wisdom-Led Assessment",
            "handle": "03-js-how-it-works-vnext-icon-wisdom-led-assessment-03",
            "primary_category": "advisory-intelligence",
            "rotation_group": "how-it-works-assessment-03",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0074",
            "label": "Clinic Protocol Review Mono",
            "handle": "js-icon-micro-clinic-protocol-review-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "micro-clinic-protocol-review-01",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "after-submission-flow",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "number",
          "data-jsi-role": "workflow-stage",
          "data-jsi-treatment": "centered-under-number",
          "data-jsi-placement": "centered-under-number",
          "data-jsi-container": "none",
          "data-jsi-size": "28-38px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "image/identity route icon",
      "recovery hotel/window icon",
      "clinic privacy icon"
    ],
    "content_id": "japan-cosmetic-surgery-image-route-review",
    "canonical_handle": "japan-cosmetic-surgery-image-route-review",
    "canonical_url": "https://japansolved.com/pages/japan-cosmetic-surgery-image-route-review",
    "source_file": "Japan Cosmetic Surgery & Image Solutions Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 48236,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-cultural-asset-luxury-collectibles-intelligence": {
    "title": "Japan Cultural Asset & Luxury Collectibles Investment Intelligence Desk™",
    "page_wing": "unclassified",
    "narrative_role": "Needs manual page-body review.",
    "style_mood": "to-be-determined",
    "icon_strategy_summary": "Pending full page-specific icon intent mapping.",
    "zones": [],
    "missing_icon_needs": [],
    "content_id": "japan-cultural-asset-luxury-collectibles-intelligence",
    "canonical_handle": "japan-cultural-asset-luxury-collectibles-intelligence",
    "canonical_url": "https://japansolved.com/pages/japan-cultural-asset-luxury-collectibles-intelligence",
    "source_file": "Japan Cultural Asset & Luxury Collectibles Investment Intelligence Desk.txt",
    "content_type": "landing_page",
    "status": "content-mismatch-needs-real-body",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 64849,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "high"
  },
  "japan-disaster-preparedness-sourcing-setup": {
    "title": "Japan Disaster Preparedness Sourcing & Setup Desk™",
    "page_wing": "preparedness-sourcing-local-setup",
    "narrative_role": "Japan-side emergency supply sourcing, setup, property/family preparedness, local practical coordination",
    "style_mood": "practical calm, household readiness, local setup",
    "icon_strategy_summary": "Use preparedness, supply box, checklist, home/property, local execution, truck/logistics. Dedicated disaster icons may be missing; use practical utility icons rather than dramatic hazard imagery.",
    "zones": [
      {
        "section_key": "preparedness-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "68-88px",
        "exact_icon_needs": [
          "preparedness",
          "supply setup",
          "local execution",
          "household readiness"
        ],
        "clickable": false,
        "notes": "Calm practical symbol, not alarmist.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0152",
            "label": "Local Execution Cases Compass",
            "handle": "23-js-case-library-vnext-icon-local-execution-cases-23",
            "primary_category": "local-execution",
            "rotation_group": "case-library-local-execution-23",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0089",
            "label": "Operational Capability Briefcase",
            "handle": "4-js-icon-operational-capability",
            "primary_category": "execution-support",
            "rotation_group": "operational-capability-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0053",
            "label": "Engagement Preparedness Pencil",
            "handle": "icon-06-japansolved-engagementbrief-engagement-preparedness",
            "primary_category": "engagement-brief",
            "rotation_group": "engagement-preparedness-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "preparedness-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "68-88px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "what-this-desk-is-for",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "category-marker",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "38-50px",
        "exact_icon_needs": [
          "water food supply",
          "blackout kit",
          "pet elderly child needs",
          "property access"
        ],
        "clickable": false,
        "notes": "Exact household setup icons would improve future registry.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "what-this-desk-is-for",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "category-marker",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "38-50px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "setup-process",
        "hierarchy": "mid",
        "visual_owner": "step-number",
        "icon_role": "workflow-stage",
        "preferred_treatment": "centered-under-number",
        "preferred_placement": "centered-under-number",
        "preferred_container": "none",
        "size_range": "28-40px",
        "exact_icon_needs": [
          "request review",
          "sourcing list",
          "local purchase",
          "setup handoff"
        ],
        "clickable": false,
        "notes": "Process exact.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0134",
            "label": "Horse Knight",
            "handle": "horse",
            "primary_category": "strategy-movement",
            "rotation_group": "strategy-movement-horse-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0027",
            "label": "Structured Intake Request",
            "handle": "icon-9-japansolved-process-submit-request-structured-intake",
            "primary_category": "intake-request",
            "rotation_group": "process-intake-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0052",
            "label": "Engagement Brief Structured Intake",
            "handle": "icon-02-japansolved-engagementbrief-structured-intake",
            "primary_category": "intake-request",
            "rotation_group": "engagement-brief-intake-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "setup-process",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "step-number",
          "data-jsi-role": "workflow-stage",
          "data-jsi-treatment": "centered-under-number",
          "data-jsi-placement": "centered-under-number",
          "data-jsi-container": "none",
          "data-jsi-size": "28-40px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "product-path",
        "hierarchy": "support",
        "visual_owner": "price-cta",
        "icon_role": "utility-marker",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-38px",
        "exact_icon_needs": [
          "preparedness review",
          "case deposit",
          "retainer support"
        ],
        "clickable": false,
        "notes": "Contained practical stamps.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0035",
            "label": "Value Driven Target Precision",
            "handle": "icon-15-japansolved-values-results-driven-target-precision",
            "primary_category": "results-outcomes",
            "rotation_group": "target-precision-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0047",
            "label": "Precision Target Monoline",
            "handle": "japansolved-solutions-icon-advisory-intelligence-precision-target-monoline",
            "primary_category": "results-outcomes",
            "rotation_group": "monoline-precision-target-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0050",
            "label": "Strategic Alignment Target",
            "handle": "icon-12-japansolved-strategic-alignment",
            "primary_category": "strategy-alignment",
            "rotation_group": "strategic-alignment-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0155",
            "label": "Execution Gap Compass",
            "handle": "29b-js-case-library-vnext-icon-execution-gap-29b",
            "primary_category": "execution-gap",
            "rotation_group": "case-library-execution-gap-29b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0053",
            "label": "Engagement Preparedness Pencil",
            "handle": "icon-06-japansolved-engagementbrief-engagement-preparedness",
            "primary_category": "engagement-brief",
            "rotation_group": "engagement-preparedness-01",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "product-path",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "price-cta",
          "data-jsi-role": "utility-marker",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-38px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "emergency kit icon",
      "water/food supply icon",
      "blackout/battery icon",
      "pet/elderly/child household icon"
    ],
    "content_id": "japan-disaster-preparedness-sourcing-setup",
    "canonical_handle": "japan-disaster-preparedness-sourcing-setup",
    "canonical_url": "https://japansolved.com/pages/japan-disaster-preparedness-sourcing-setup",
    "source_file": "Japan Disaster Preparedness Sourcing & Setup Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 131531,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-ginza-luxury-brand-personal-shopping": {
    "title": "Japan Ginza Luxury Brand Personal Shopping Desk™",
    "page_wing": "luxury-shopping-ginza",
    "narrative_role": "in-person Ginza luxury shopping route, boutique appointment, purchase communication, handoff planning",
    "style_mood": "Provenance Noir / quiet luxury concierge",
    "icon_strategy_summary": "Use crown/diamond/private access/shopping-procurement icons sparingly. Major shopping thesis can use free luxury emblem; boutique route cards can use upper-right ghost or top-center free icons. Utility product cards may use contained stamps.",
    "zones": [
      {
        "section_key": "concierge-before-checkout",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-92px",
        "exact_icon_needs": [
          "luxury shopping",
          "boutique route",
          "concierge presence",
          "purchase control"
        ],
        "clickable": false,
        "notes": "Crown/diamond/briefcase with restraint.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0064",
            "label": "Priority Access Star",
            "handle": "icon-15-japansolved-priority-access",
            "primary_category": "priority-access",
            "rotation_group": "priority-access-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0137",
            "label": "Airplane Jet 01",
            "handle": "airplane-jet-01",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0139",
            "label": "Airplane Jet 07",
            "handle": "airplane-jet-07",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-07",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0145",
            "label": "Airplane Jet 03",
            "handle": "airplane-jet-03",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-03",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "concierge-before-checkout",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "72-92px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "service-menu",
        "hierarchy": "mid-high",
        "visual_owner": "card-title",
        "icon_role": "category-marker",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "42-56px",
        "exact_icon_needs": [
          "boutique appointment",
          "stock inquiry",
          "tax free handoff",
          "private shopping day",
          "gift shopping"
        ],
        "clickable": true,
        "notes": "Card icons may be clickable if card is clickable.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0161",
            "label": "Travel Access Cases 24a Airplane",
            "handle": "24a-js-case-library-vnext-icon-travel-access-cases-24a",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24a",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "service-menu",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "category-marker",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "42-56px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "luxury-route-risks",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "36-48px",
        "exact_icon_needs": [
          "availability timing",
          "staff communication",
          "payment flow",
          "handoff courier"
        ],
        "clickable": false,
        "notes": "Exact shopping mechanics.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0020",
            "label": "Capital Precision Flow",
            "handle": "icon-2-japansolved-solutions-investments-capital-precision-flow",
            "primary_category": "investments-capital",
            "rotation_group": "solution-capital-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0062",
            "label": "Execution Coordination Nodes",
            "handle": "icon-14-japansolved-execution-coordination",
            "primary_category": "execution-support",
            "rotation_group": "execution-coordination-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "luxury-route-risks",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "problem-signal",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "36-48px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "pricing-product-cards",
        "hierarchy": "support",
        "visual_owner": "price-cta",
        "icon_role": "utility-marker",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-38px",
        "exact_icon_needs": [
          "shopping review",
          "case deposit",
          "attendance day",
          "private shopping program"
        ],
        "clickable": false,
        "notes": "Contained stamps are fine in commerce layer.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0048",
            "label": "Restricted Access Monoline",
            "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
            "primary_category": "privacy-discretion",
            "rotation_group": "monoline-restricted-access-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0154",
            "label": "Sourcing Rare Assets Gem Box",
            "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
            "primary_category": "rare-asset-sourcing",
            "rotation_group": "case-library-sourcing-rare-assets-14",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0205",
            "label": "Sensitive Matters Mono Line",
            "handle": "09-js-solutions-vnext-icon-private-discreet-matters-mono-line-09",
            "primary_category": "sensitive-matters",
            "rotation_group": "solutions-sensitive-matters-mono-line-09",
            "priority": 52
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "pricing-product-cards",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "price-cta",
          "data-jsi-role": "utility-marker",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-38px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "shopping bag icon",
      "boutique appointment icon",
      "tax-free handoff icon",
      "gift route icon"
    ],
    "content_id": "japan-ginza-luxury-brand-personal-shopping",
    "canonical_handle": "japan-ginza-luxury-brand-personal-shopping",
    "canonical_url": null,
    "source_file": "Japan Ginza Luxury Brand Personal Shopping Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 113041,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-health-longevity-discreet-care-access": {
    "title": "Japan Health, Longevity & Discreet Care Access Wing™",
    "page_wing": "health-longevity-discreet-care-hub",
    "narrative_role": "health, longevity, recovery, cosmetic, wellness, and sensitive-care route-classification hub",
    "style_mood": "private care classification, calm medical-adjacent caution",
    "icon_strategy_summary": "Use clinic/protocol, privacy, decision clarity, structure, and route classification. Hub pages need architecture icons and may use top-center/free icons for pathway cards; warnings and boundaries should use contained utility markers.",
    "zones": [
      {
        "section_key": "care-access-classification-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "76-96px",
        "exact_icon_needs": [
          "care classification",
          "clinic access",
          "privacy",
          "route intelligence"
        ],
        "clickable": false,
        "notes": "One clean anchor, not medical cliché.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0083",
            "label": "Decision Intelligence Mono",
            "handle": "js-icon-footer-decision-ready-intelligence-mono-bw-v1",
            "primary_category": "advisory-intelligence",
            "rotation_group": "footer-decision-intelligence-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0037",
            "label": "Comprehensive Solutions Compass B",
            "handle": "icon-16-b-japansolved-tiers-standard-engagement-comprehensive-solutions",
            "primary_category": "comprehensive-solutions",
            "rotation_group": "comprehensive-solutions-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          },
          {
            "registry_id": "JSICON-0049",
            "label": "Feasibility Assessment Globe",
            "handle": "icon-11-japansolved-feasibility-assessment",
            "primary_category": "feasibility-assessment",
            "rotation_group": "feasibility-assessment-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0102",
            "label": "Strategy Target",
            "handle": "02-js-icon-strategy-02",
            "primary_category": "strategy-alignment",
            "rotation_group": "strategy-target-02",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "care-access-classification-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "76-96px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "door/pathway-cards",
        "hierarchy": "mid-high",
        "visual_owner": "card-title",
        "icon_role": "category-marker",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "42-56px",
        "exact_icon_needs": [
          "medical tourism",
          "cosmetic surgery",
          "stem cell longevity",
          "second opinion",
          "discreet care",
          "recovery stay"
        ],
        "clickable": true,
        "notes": "Clickable pathway icons should match child page destinations.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0115",
            "label": "How It Works Ongoing Stewardship",
            "handle": "15-js-how-it-works-vnext-icon-ongoing-stewardship-15",
            "primary_category": "stewardship-support",
            "rotation_group": "how-it-works-ongoing-stewardship-15",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0026",
            "label": "CurrentColor Protection Shield",
            "handle": "icon-8-japansolved-solutions-discreet-sensitive-confidential-protection-currentcolor",
            "primary_category": "privacy-discretion",
            "rotation_group": "solution-protection-01",
            "priority": 67
          },
          {
            "registry_id": "JSICON-0040",
            "label": "Comprehensive Solutions Star",
            "handle": "icon-16-e-japansolved-tiers-standard-engagement-comprehensive-solutions",
            "primary_category": "comprehensive-solutions",
            "rotation_group": "comprehensive-solutions-05",
            "priority": 65
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "door/pathway-cards",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "category-marker",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "42-56px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "privacy-boundary-notes",
        "hierarchy": "support",
        "visual_owner": "copy",
        "icon_role": "utility-warning",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-38px",
        "exact_icon_needs": [
          "privacy",
          "no medical advice",
          "records translation",
          "provider requirement"
        ],
        "clickable": false,
        "notes": "Contained warning/support icons OK.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0129",
            "label": "How It Works Scope Prepared",
            "handle": "09-js-how-it-works-vnext-icon-scope-prepared-09",
            "primary_category": "scope-preparation",
            "rotation_group": "how-it-works-scope-prepared-09",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0057",
            "label": "Engagement Brief Restricted Advisory",
            "handle": "icon-03-japansolved-engagementbrief-restricted-advisory",
            "primary_category": "advisory-intelligence",
            "rotation_group": "engagement-restricted-advisory-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0026",
            "label": "CurrentColor Protection Shield",
            "handle": "icon-8-japansolved-solutions-discreet-sensitive-confidential-protection-currentcolor",
            "primary_category": "privacy-discretion",
            "rotation_group": "solution-protection-01",
            "priority": 67
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "privacy-boundary-notes",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "copy",
          "data-jsi-role": "utility-warning",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-38px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "route-finder",
        "hierarchy": "mid",
        "visual_owner": "pill-label",
        "icon_role": "filter-signal",
        "preferred_treatment": "inline-micro",
        "preferred_placement": "inline-left-micro",
        "preferred_container": "inherited-pill",
        "size_range": "18-24px",
        "exact_icon_needs": [
          "clinic",
          "recovery",
          "beauty",
          "longevity",
          "sensitive matter"
        ],
        "clickable": true,
        "notes": "Tiny icon only.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0163",
            "label": "Sensitive Matters Door",
            "handle": "18-js-case-library-vnext-icon-sensitive-matters-18",
            "primary_category": "sensitive-matters",
            "rotation_group": "case-library-sensitive-matters-18",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0185",
            "label": "Discretion Shield",
            "handle": "16-js-faq-vnext-icon-discretion-shield-16",
            "primary_category": "faq-discretion",
            "rotation_group": "faq-discretion-shield-16",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0205",
            "label": "Sensitive Matters Mono Line",
            "handle": "09-js-solutions-vnext-icon-private-discreet-matters-mono-line-09",
            "primary_category": "sensitive-matters",
            "rotation_group": "solutions-sensitive-matters-mono-line-09",
            "priority": 52
          },
          {
            "registry_id": "JSICON-0074",
            "label": "Clinic Protocol Review Mono",
            "handle": "js-icon-micro-clinic-protocol-review-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "micro-clinic-protocol-review-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0080",
            "label": "Medical Due Diligence Mono",
            "handle": "js-icon-footer-medical-operational-due-diligence-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "footer-medical-due-diligence-01",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "route-finder",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "pill-label",
          "data-jsi-role": "filter-signal",
          "data-jsi-treatment": "inline-micro",
          "data-jsi-placement": "inline-left-micro",
          "data-jsi-container": "inherited-pill",
          "data-jsi-size": "18-24px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "longevity icon",
      "recovery stay icon",
      "records/translation medical document icon",
      "stem-cell/regenerative neutral icon"
    ],
    "content_id": "japan-health-longevity-discreet-care-access",
    "canonical_handle": "japan-health-longevity-discreet-care-access",
    "canonical_url": "https://japansolved.com/pages/japan-health-longevity-discreet-care-access",
    "source_file": "Japan Health, Longevity & Discreet Care Access Wing.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 70159,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-jdm-export-inspection": {
    "title": "Japan JDM Inspection, Export & Registration Desk™",
    "page_wing": "jdm-vehicle-export-inspection",
    "narrative_role": "vehicle inspection, auction sheet/seller verification, export paperwork, deregistration, destination registration risk",
    "style_mood": "mechanical due diligence, export route discipline",
    "icon_strategy_summary": "Use inspection/lens, document, logistics truck, target, risk/compliance. Registry lacks vehicle-specific icons, so missing car/wheel/chassis icons should be reported. Process steps can use centered-under-number or no-icon if numbers dominate.",
    "zones": [
      {
        "section_key": "inspection-before-export",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "70-90px",
        "exact_icon_needs": [
          "inspection",
          "export route",
          "vehicle paperwork",
          "risk review"
        ],
        "clickable": false,
        "notes": "Needs vehicle-specific icon eventually.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0134",
            "label": "Horse Knight",
            "handle": "horse",
            "primary_category": "strategy-movement",
            "rotation_group": "strategy-movement-horse-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0199",
            "label": "Investment Capital Mono Line",
            "handle": "03-js-solutions-vnext-icon-investment-capital-mono-line-03",
            "primary_category": "investment-capital",
            "rotation_group": "solutions-investment-capital-mono-line-03",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0154",
            "label": "Sourcing Rare Assets Gem Box",
            "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
            "primary_category": "rare-asset-sourcing",
            "rotation_group": "case-library-sourcing-rare-assets-14",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "inspection-before-export",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "70-90px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "risk-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "38-50px",
        "exact_icon_needs": [
          "auction sheet",
          "seller photos",
          "repair history",
          "deregistration",
          "destination rules"
        ],
        "clickable": false,
        "notes": "Exact vehicle due diligence risks. | Candidate list emptied by 2026-07-07 icon purge; brain should reselect from morphology-safe registry.",
        "candidate_registry_ids": [],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "risk-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "problem-signal",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "38-50px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "export-process",
        "hierarchy": "mid",
        "visual_owner": "number-title",
        "icon_role": "workflow-stage",
        "preferred_treatment": "centered-under-number",
        "preferred_placement": "centered-under-number",
        "preferred_container": "none",
        "size_range": "28-40px",
        "exact_icon_needs": [
          "inspection review",
          "paperwork check",
          "inland transport",
          "port handoff",
          "registration risk"
        ],
        "clickable": false,
        "notes": "Process icons match verbs.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0035",
            "label": "Value Driven Target Precision",
            "handle": "icon-15-japansolved-values-results-driven-target-precision",
            "primary_category": "results-outcomes",
            "rotation_group": "target-precision-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0047",
            "label": "Precision Target Monoline",
            "handle": "japansolved-solutions-icon-advisory-intelligence-precision-target-monoline",
            "primary_category": "results-outcomes",
            "rotation_group": "monoline-precision-target-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0050",
            "label": "Strategic Alignment Target",
            "handle": "icon-12-japansolved-strategic-alignment",
            "primary_category": "strategy-alignment",
            "rotation_group": "strategic-alignment-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0089",
            "label": "Operational Capability Briefcase",
            "handle": "4-js-icon-operational-capability",
            "primary_category": "execution-support",
            "rotation_group": "operational-capability-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "export-process",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "number-title",
          "data-jsi-role": "workflow-stage",
          "data-jsi-treatment": "centered-under-number",
          "data-jsi-placement": "centered-under-number",
          "data-jsi-container": "none",
          "data-jsi-size": "28-40px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "pricing-products",
        "hierarchy": "support",
        "visual_owner": "price-cta",
        "icon_role": "utility-marker",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-38px",
        "exact_icon_needs": [
          "inspection review",
          "case deposit",
          "export support"
        ],
        "clickable": false,
        "notes": "Contained ok.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0035",
            "label": "Value Driven Target Precision",
            "handle": "icon-15-japansolved-values-results-driven-target-precision",
            "primary_category": "results-outcomes",
            "rotation_group": "target-precision-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0047",
            "label": "Precision Target Monoline",
            "handle": "japansolved-solutions-icon-advisory-intelligence-precision-target-monoline",
            "primary_category": "results-outcomes",
            "rotation_group": "monoline-precision-target-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0050",
            "label": "Strategic Alignment Target",
            "handle": "icon-12-japansolved-strategic-alignment",
            "primary_category": "strategy-alignment",
            "rotation_group": "strategic-alignment-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0155",
            "label": "Execution Gap Compass",
            "handle": "29b-js-case-library-vnext-icon-execution-gap-29b",
            "primary_category": "execution-gap",
            "rotation_group": "case-library-execution-gap-29b",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "pricing-products",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "price-cta",
          "data-jsi-role": "utility-marker",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-38px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "car icon",
      "auction sheet icon",
      "chassis/fitment icon",
      "deregistration document icon"
    ],
    "content_id": "japan-jdm-export-inspection",
    "canonical_handle": "japan-jdm-export-inspection",
    "canonical_url": "https://japansolved.com/pages/japan-jdm-export-inspection",
    "source_file": "Japan JDM Inspection, Export & Registration Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 148214,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-jdm-parts-wheels-tuning-acquisition": {
    "title": "Japan JDM Parts, Wheels & Tuning Acquisition Desk™",
    "page_wing": "jdm-parts-procurement",
    "narrative_role": "rare JDM parts/wheels/tuning acquisition, fitment review, seller verification, freight planning",
    "style_mood": "builder/procurement intelligence, fitment caution, cargo reality",
    "icon_strategy_summary": "Use sourcing, verification, logistics, target, document/lens. Missing exact wheel/part/fitment icons are critical. Avoid generic box icons for every part card; use sentence-level fitment/condition/freight symbols.",
    "zones": [
      {
        "section_key": "parts-access-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-92px",
        "exact_icon_needs": [
          "rare parts",
          "fitment risk",
          "build protection",
          "acquisition path"
        ],
        "clickable": false,
        "notes": "Needs wheel/part icon eventually.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0081",
            "label": "Capital Program",
            "handle": "japansolved-capital-program",
            "primary_category": "investments-capital",
            "rotation_group": "capital-program-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0154",
            "label": "Sourcing Rare Assets Gem Box",
            "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
            "primary_category": "rare-asset-sourcing",
            "rotation_group": "case-library-sourcing-rare-assets-14",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0126",
            "label": "How It Works Declined Redirected",
            "handle": "07-js-how-it-works-vnext-icon-declined-redirected-07",
            "primary_category": "routing-referral",
            "rotation_group": "how-it-works-declined-redirected-07",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "parts-access-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "72-92px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "failure-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "38-50px",
        "exact_icon_needs": [
          "fitment mismatch",
          "condition damage",
          "seller claim",
          "freight shock"
        ],
        "clickable": false,
        "notes": "Exact risk matching.",
        "candidate_registry_ids": [],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "failure-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "problem-signal",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "38-50px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "parts-menu",
        "hierarchy": "mid-high",
        "visual_owner": "card-title",
        "icon_role": "category-marker",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "42-56px",
        "exact_icon_needs": [
          "wheels",
          "aero parts",
          "engine gearbox",
          "interior trim",
          "electronics harness",
          "rare oem"
        ],
        "clickable": true,
        "notes": "Clickable if category cards route.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0154",
            "label": "Sourcing Rare Assets Gem Box",
            "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
            "primary_category": "rare-asset-sourcing",
            "rotation_group": "case-library-sourcing-rare-assets-14",
            "priority": 61
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "parts-menu",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "category-marker",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "42-56px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "logistics-product-path",
        "hierarchy": "support",
        "visual_owner": "price-cta",
        "icon_role": "utility-marker",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-38px",
        "exact_icon_needs": [
          "parts review",
          "proxy acquisition",
          "consolidation",
          "cargo escalation"
        ],
        "clickable": false,
        "notes": "Contained support icons okay.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0134",
            "label": "Horse Knight",
            "handle": "horse",
            "primary_category": "strategy-movement",
            "rotation_group": "strategy-movement-horse-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0154",
            "label": "Sourcing Rare Assets Gem Box",
            "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
            "primary_category": "rare-asset-sourcing",
            "rotation_group": "case-library-sourcing-rare-assets-14",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "logistics-product-path",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "price-cta",
          "data-jsi-role": "utility-marker",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-38px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "wheel icon",
      "engine/gearbox icon",
      "aero/body panel icon",
      "ECU/electronics icon",
      "fitment caliper icon"
    ],
    "content_id": "japan-jdm-parts-wheels-tuning-acquisition",
    "canonical_handle": "japan-jdm-parts-wheels-tuning-acquisition",
    "canonical_url": "https://japansolved.com/pages/japan-jdm-parts-wheels-tuning-acquisition",
    "source_file": "Japan JDM Parts, Wheels & Tuning Acquisition Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 77763,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-jewelry-shopping-proxy-personal-shopper": {
    "title": "Japan Jewelry Shopping Proxy & Personal Shopper Desk™",
    "page_wing": "jewelry-shopping-proxy",
    "narrative_role": "hybrid jewelry personal shopper/proxy review, seller questions, purchase caution, handoff planning",
    "style_mood": "intimate luxury, technical sparkle caution, careful purchase path",
    "icon_strategy_summary": "Use diamond, magnifier, proof, private buyer/proxy, payment/handoff. Free icons for jewelry thesis and category cards; contained stamps only in product/payment cards.",
    "zones": [
      {
        "section_key": "jewelry-support-before-commitment",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-92px",
        "exact_icon_needs": [
          "jewelry",
          "diamond",
          "purchase caution",
          "local eyes"
        ],
        "clickable": false,
        "notes": "Diamond/lens icon should be free and elegant.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0100",
            "label": "Collectors Diamond",
            "handle": "13-js-icon-collectors-13",
            "primary_category": "luxury-collectibles",
            "rotation_group": "collectors-diamond-13",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "jewelry-support-before-commitment",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "72-92px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "risk-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "38-50px",
        "exact_icon_needs": [
          "stone description",
          "metal content",
          "seller explanation",
          "paperwork",
          "resizing"
        ],
        "clickable": false,
        "notes": "Need exact jewelry details; registry has diamond but not all technical sub-icons.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0132",
            "label": "Creatives Transparent Pencil",
            "handle": "16c-js-icon-creatives-transparent",
            "primary_category": "creative-assets",
            "rotation_group": "creative-assets-pencil-16c",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0133",
            "label": "Creatives Pencil",
            "handle": "16a-js-icon-creatives",
            "primary_category": "creative-assets",
            "rotation_group": "creative-assets-pencil-16a",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0186",
            "label": "General Scroll Question",
            "handle": "09-js-faq-vnext-icon-general-scroll-question-09",
            "primary_category": "faq-general",
            "rotation_group": "faq-general-scroll-question-09",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "risk-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "problem-signal",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "38-50px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "hybrid-route-cards",
        "hierarchy": "mid-high",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "42-54px",
        "exact_icon_needs": [
          "personal shopper",
          "proxy review",
          "seller communication",
          "purchase handoff"
        ],
        "clickable": true,
        "notes": "Clickable if route cards link.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0134",
            "label": "Horse Knight",
            "handle": "horse",
            "primary_category": "strategy-movement",
            "rotation_group": "strategy-movement-horse-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "hybrid-route-cards",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "route-marker",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "42-54px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "product-path",
        "hierarchy": "support",
        "visual_owner": "price-cta",
        "icon_role": "utility-marker",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-38px",
        "exact_icon_needs": [
          "shopping review",
          "case deposit",
          "in-person day",
          "purchase handoff"
        ],
        "clickable": false,
        "notes": "Commerce layer.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          },
          {
            "registry_id": "JSICON-0028",
            "label": "Analytical Evaluation Lens",
            "handle": "icon-10-japansolved-process-case-review-analytical-evaluation",
            "primary_category": "case-review",
            "rotation_group": "process-evaluation-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0035",
            "label": "Value Driven Target Precision",
            "handle": "icon-15-japansolved-values-results-driven-target-precision",
            "primary_category": "results-outcomes",
            "rotation_group": "target-precision-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0047",
            "label": "Precision Target Monoline",
            "handle": "japansolved-solutions-icon-advisory-intelligence-precision-target-monoline",
            "primary_category": "results-outcomes",
            "rotation_group": "monoline-precision-target-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "product-path",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "price-cta",
          "data-jsi-role": "utility-marker",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-38px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "ring icon",
      "pearl icon",
      "certificate icon",
      "resizing icon"
    ],
    "content_id": "japan-jewelry-shopping-proxy-personal-shopper",
    "canonical_handle": "japan-jewelry-shopping-proxy-personal-shopper",
    "canonical_url": "https://japansolved.com/pages/japan-jewelry-shopping-proxy-personal-shopper",
    "source_file": "Japan Jewelry Shopping Proxy & Personal Shopper Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 80767,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-large-cargo-shipping-logistics": {
    "title": "Japan Large Format Cargo Shipping & Execution Desk™",
    "page_wing": "large-cargo-logistics",
    "narrative_role": "large/fragile/valuable object pickup, packing, crating, warehousing, freight routing and movement-risk classification",
    "style_mood": "logistics command, fragile-object caution, execution discipline",
    "icon_strategy_summary": "Registry coverage is strong for truck/logistics/execution. Use large free logistics anchor in thesis, top-center risk icons for cargo failure cards, contained utility stamps for quote/payment/handoff.",
    "zones": [
      {
        "section_key": "movement-before-mistake",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-92px",
        "exact_icon_needs": [
          "large cargo",
          "movement risk",
          "fragile object",
          "logistics execution"
        ],
        "clickable": false,
        "notes": "Truck/crate/route icon should lead.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0137",
            "label": "Airplane Jet 01",
            "handle": "airplane-jet-01",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0138",
            "label": "Airplane Jet 08",
            "handle": "airplane-jet-08",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-08",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "movement-before-mistake",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "72-92px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "cargo-risk-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "38-50px",
        "exact_icon_needs": [
          "seller cannot pack",
          "carrier quote incomplete",
          "fragile object",
          "purchase before logistics"
        ],
        "clickable": false,
        "notes": "Exact risk icons.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "cargo-risk-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "problem-signal",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "38-50px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "handoff-process",
        "hierarchy": "mid",
        "visual_owner": "number-title",
        "icon_role": "workflow-stage",
        "preferred_treatment": "centered-under-number",
        "preferred_placement": "centered-under-number",
        "preferred_container": "none",
        "size_range": "28-40px",
        "exact_icon_needs": [
          "pickup",
          "crating",
          "warehouse",
          "freight handoff",
          "insurance customs"
        ],
        "clickable": false,
        "notes": "Process exactness.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0058",
            "label": "Local Representation Institution",
            "handle": "icon-13-japansolved-local-representation",
            "primary_category": "logistics-representation",
            "rotation_group": "local-representation-02",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "handoff-process",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "number-title",
          "data-jsi-role": "workflow-stage",
          "data-jsi-treatment": "centered-under-number",
          "data-jsi-placement": "centered-under-number",
          "data-jsi-container": "none",
          "data-jsi-size": "28-40px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "product-path",
        "hierarchy": "support",
        "visual_owner": "price-cta",
        "icon_role": "utility-marker",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-38px",
        "exact_icon_needs": [
          "cargo review",
          "case deposit",
          "freight quote",
          "execution support"
        ],
        "clickable": false,
        "notes": "Contained support icons.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0168",
            "label": "Execution Gap 29a Compass Star",
            "handle": "29a-js-case-library-vnext-icon-execution-gap-29a",
            "primary_category": "execution-gap",
            "rotation_group": "case-library-execution-gap-29a",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0035",
            "label": "Value Driven Target Precision",
            "handle": "icon-15-japansolved-values-results-driven-target-precision",
            "primary_category": "results-outcomes",
            "rotation_group": "target-precision-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0047",
            "label": "Precision Target Monoline",
            "handle": "japansolved-solutions-icon-advisory-intelligence-precision-target-monoline",
            "primary_category": "results-outcomes",
            "rotation_group": "monoline-precision-target-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0050",
            "label": "Strategic Alignment Target",
            "handle": "icon-12-japansolved-strategic-alignment",
            "primary_category": "strategy-alignment",
            "rotation_group": "strategic-alignment-02",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "product-path",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "price-cta",
          "data-jsi-role": "utility-marker",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-38px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "crate icon",
      "fragile handling icon",
      "warehouse icon",
      "customs/insurance icon"
    ],
    "content_id": "japan-large-cargo-shipping-logistics",
    "canonical_handle": "japan-large-cargo-shipping-logistics",
    "canonical_url": "https://japansolved.com/pages/japan-large-cargo-shipping-logistics",
    "source_file": "Japan Large Format Cargo Shipping & Execution Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 73220,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-lost-item-recovery-return-coordination": {
    "title": "Japan Lost Item Recovery & Return Coordination Desk™",
    "page_wing": "lost-item-recovery",
    "narrative_role": "lost-and-found route identification, facility/police/operator contact, pickup/shipping coordination for travelers outside Japan",
    "style_mood": "gentle urgency, route tracing, sentimental recovery",
    "icon_strategy_summary": "Use question/route/lens, support, logistics, time-sensitive, document/identity. Exact lost-property icons may be missing. Large thesis icon can be a map/lens/support anchor; utility stamps for shipping/payment.",
    "zones": [
      {
        "section_key": "lost-property-route-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "68-88px",
        "exact_icon_needs": [
          "lost property",
          "route tracing",
          "facility contact",
          "return coordination"
        ],
        "clickable": false,
        "notes": "Compassionate but operational.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0151",
            "label": "Property Relocation Cases",
            "handle": "21-js-case-library-vnext-icon-property-relocation-cases-21",
            "primary_category": "property-relocation",
            "rotation_group": "case-library-property-relocation-21",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "lost-property-route-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "68-88px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "where-item-may-be-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "category-marker",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "36-48px",
        "exact_icon_needs": [
          "station counter",
          "hotel desk",
          "police station",
          "taxi office",
          "airport counter",
          "venue"
        ],
        "clickable": false,
        "notes": "Exact place icons likely missing; use route/support fallbacks.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0073",
            "label": "Counterparty Mapping Mono",
            "handle": "js-icon-footer-counterparty-mapping-mono-bw-v1",
            "primary_category": "counterparty-mapping",
            "rotation_group": "footer-counterparty-mapping-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0042",
            "label": "Access Retainer Priority Key A",
            "handle": "icon-17-a-japansolved-tiers-private-access-retainer-priority",
            "primary_category": "retainer-priority",
            "rotation_group": "retainer-priority-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0162",
            "label": "Travel Access Cases 24c Plane Circle",
            "handle": "24c-js-case-library-vnext-icon-travel-access-cases-24c",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24c",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0143",
            "label": "Headphone Support",
            "handle": "headphone",
            "primary_category": "client-support",
            "rotation_group": "client-support-headphone-01",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "where-item-may-be-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "category-marker",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "36-48px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "recovery-process",
        "hierarchy": "mid",
        "visual_owner": "number-title",
        "icon_role": "workflow-stage",
        "preferred_treatment": "centered-under-number",
        "preferred_placement": "centered-under-number",
        "preferred_container": "none",
        "size_range": "28-40px",
        "exact_icon_needs": [
          "identity check",
          "facility call",
          "pickup rule",
          "shipping form",
          "handoff"
        ],
        "clickable": false,
        "notes": "Process exactness.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0058",
            "label": "Local Representation Institution",
            "handle": "icon-13-japansolved-local-representation",
            "primary_category": "logistics-representation",
            "rotation_group": "local-representation-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0089",
            "label": "Operational Capability Briefcase",
            "handle": "4-js-icon-operational-capability",
            "primary_category": "execution-support",
            "rotation_group": "operational-capability-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "recovery-process",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "number-title",
          "data-jsi-role": "workflow-stage",
          "data-jsi-treatment": "centered-under-number",
          "data-jsi-placement": "centered-under-number",
          "data-jsi-container": "none",
          "data-jsi-size": "28-40px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "route-note-related",
        "hierarchy": "support",
        "visual_owner": "copy",
        "icon_role": "route-marker",
        "preferred_treatment": "inline-micro",
        "preferred_placement": "inline-left-micro",
        "preferred_container": "none",
        "size_range": "20-28px",
        "exact_icon_needs": [
          "travel route",
          "logistics handoff",
          "support"
        ],
        "clickable": true,
        "notes": "Clickable route note only if text links.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0203",
            "label": "Cultural Access Mono Line",
            "handle": "07-js-solutions-vnext-icon-travel-cultural-access-mono-line-07",
            "primary_category": "cultural-access",
            "rotation_group": "solutions-cultural-access-mono-line-07",
            "priority": 53
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0058",
            "label": "Local Representation Institution",
            "handle": "icon-13-japansolved-local-representation",
            "primary_category": "logistics-representation",
            "rotation_group": "local-representation-02",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "route-note-related",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "copy",
          "data-jsi-role": "route-marker",
          "data-jsi-treatment": "inline-micro",
          "data-jsi-placement": "inline-left-micro",
          "data-jsi-container": "none",
          "data-jsi-size": "20-28px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "lost item/tag icon",
      "station/police counter icons",
      "shipping form icon",
      "passport pouch/wallet/camera icon"
    ],
    "content_id": "japan-lost-item-recovery-return-coordination",
    "canonical_handle": "japan-lost-item-recovery-return-coordination",
    "canonical_url": "https://japansolved.com/pages/japan-lost-item-recovery-return-coordination",
    "source_file": "Japan Lost Item Recovery & Return Coordination Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 64670,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-medical-tourism-entourage-support": {
    "title": "Japan Medical Tourism Entourage & Support Desk™",
    "page_wing": "medical-tourism-entourage",
    "narrative_role": "non-medical logistics, interpretation, document organization, transport, hotel/family support around Japan care routes",
    "style_mood": "calm medical-adjacent bridge, privacy, logistics",
    "icon_strategy_summary": "Use clinic protocol, medical due diligence, privacy, transport, document, family/support icons. Avoid icons that imply clinical care or treatment guarantee. Utility warnings/boundaries can be contained.",
    "zones": [
      {
        "section_key": "local-bridge-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-92px",
        "exact_icon_needs": [
          "medical bridge",
          "clinic protocol",
          "non-medical support",
          "privacy"
        ],
        "clickable": false,
        "notes": "Clinical-adjacent but not treatment.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0074",
            "label": "Clinic Protocol Review Mono",
            "handle": "js-icon-micro-clinic-protocol-review-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "micro-clinic-protocol-review-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0169",
            "label": "Accessible 24/7 Clock",
            "handle": "36-js-case-library-vnext-icon-accessible-247-36",
            "primary_category": "accessible-247",
            "rotation_group": "case-library-accessible-247-36",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0163",
            "label": "Sensitive Matters Door",
            "handle": "18-js-case-library-vnext-icon-sensitive-matters-18",
            "primary_category": "sensitive-matters",
            "rotation_group": "case-library-sensitive-matters-18",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "local-bridge-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "72-92px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "support-needs-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "concept-emblem",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "38-50px",
        "exact_icon_needs": [
          "documents",
          "interpretation",
          "transport",
          "hotel coordination",
          "family updates"
        ],
        "clickable": false,
        "notes": "Exact support categories.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0173",
            "label": "Language Gap Chat Bubbles",
            "handle": "28-js-case-library-vnext-icon-language-gap-28",
            "primary_category": "language-gap",
            "rotation_group": "case-library-language-gap-28",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0183",
            "label": "Engagement Sealed",
            "handle": "12-js-faq-vnext-icon-engagement-sealed-12",
            "primary_category": "faq-engagement",
            "rotation_group": "faq-engagement-sealed-12",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "support-needs-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "concept-emblem",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "38-50px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "medical-boundary-notes",
        "hierarchy": "support",
        "visual_owner": "copy",
        "icon_role": "utility-warning",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-38px",
        "exact_icon_needs": [
          "no medical advice",
          "privacy",
          "licensed professionals",
          "case review"
        ],
        "clickable": false,
        "notes": "Contained warnings appropriate.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0109",
            "label": "How It Works Wisdom-Led Assessment",
            "handle": "03-js-how-it-works-vnext-icon-wisdom-led-assessment-03",
            "primary_category": "advisory-intelligence",
            "rotation_group": "how-it-works-assessment-03",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0095",
            "label": "Assess Checklist",
            "handle": "7-js-icon-assess",
            "primary_category": "case-review",
            "rotation_group": "assess-checklist-07",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0057",
            "label": "Engagement Brief Restricted Advisory",
            "handle": "icon-03-japansolved-engagementbrief-restricted-advisory",
            "primary_category": "advisory-intelligence",
            "rotation_group": "engagement-restricted-advisory-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "medical-boundary-notes",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "copy",
          "data-jsi-role": "utility-warning",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-38px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "product-path",
        "hierarchy": "support",
        "visual_owner": "price-cta",
        "icon_role": "utility-marker",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-38px",
        "exact_icon_needs": [
          "support review",
          "case deposit",
          "entourage retainer"
        ],
        "clickable": false,
        "notes": "Commerce layer.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0035",
            "label": "Value Driven Target Precision",
            "handle": "icon-15-japansolved-values-results-driven-target-precision",
            "primary_category": "results-outcomes",
            "rotation_group": "target-precision-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0047",
            "label": "Precision Target Monoline",
            "handle": "japansolved-solutions-icon-advisory-intelligence-precision-target-monoline",
            "primary_category": "results-outcomes",
            "rotation_group": "monoline-precision-target-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0050",
            "label": "Strategic Alignment Target",
            "handle": "icon-12-japansolved-strategic-alignment",
            "primary_category": "strategy-alignment",
            "rotation_group": "strategic-alignment-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0155",
            "label": "Execution Gap Compass",
            "handle": "29b-js-case-library-vnext-icon-execution-gap-29b",
            "primary_category": "execution-gap",
            "rotation_group": "case-library-execution-gap-29b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "product-path",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "price-cta",
          "data-jsi-role": "utility-marker",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-38px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "medical document folder icon",
      "hotel/transport care icon",
      "family-support medical icon"
    ],
    "content_id": "japan-medical-tourism-entourage-support",
    "canonical_handle": "japan-medical-tourism-entourage-support",
    "canonical_url": "https://japansolved.com/pages/japan-medical-tourism-entourage-support",
    "source_file": "Japan Medical Tourism Entourage & Support Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 165862,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-missing-person-welfare-search-coordination": {
    "title": "Japan Missing Person Welfare & Search Coordination Desk™",
    "page_wing": "sensitive-welfare-search",
    "narrative_role": "authorized missing-person/welfare-concern triage, authority/institution routing, privacy and lawful-basis protection",
    "style_mood": "serious sensitive, emergency-first, welfare before whereabouts",
    "icon_strategy_summary": "Use very restrained shield/privacy/support/risk icons. Avoid search/detective drama. High-level thesis can use a free protective anchor; authority/emergency boundaries use contained stamps; some sections should have no icons to preserve seriousness.",
    "zones": [
      {
        "section_key": "welfare-before-whereabouts",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-92px",
        "exact_icon_needs": [
          "welfare protection",
          "privacy",
          "authorized search",
          "authority routing"
        ],
        "clickable": false,
        "notes": "Protective shield/people/support, not sensational.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0085",
            "label": "Think Thank Institute Globe",
            "handle": "japansolved-think-thank-institute",
            "primary_category": "institutional-authority",
            "rotation_group": "think-thank-institute-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0025",
            "label": "Analytical Insight Lens",
            "handle": "icon-7-japansolved-solutions-advisory-intelligence-analytical-insight",
            "primary_category": "advisory-intelligence",
            "rotation_group": "solution-intelligence-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0141",
            "label": "Magnifying Glass",
            "handle": "magnifying-glass",
            "primary_category": "advisory-intelligence",
            "rotation_group": "advisory-magnifying-glass-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0171",
            "label": "Secret Professional 33 Tie Shield",
            "handle": "33-js-case-library-vnext-icon-discreet-professional-33",
            "primary_category": "secret-professional",
            "rotation_group": "case-library-secret-professional-33",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "welfare-before-whereabouts",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "72-92px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "case-path-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "risk-signal",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "38-50px",
        "exact_icon_needs": [
          "family outside japan",
          "urgent case",
          "private silence",
          "wrong search harm"
        ],
        "clickable": false,
        "notes": "Use exact welfare/privacy/emergency concepts.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          },
          {
            "registry_id": "JSICON-0114",
            "label": "How It Works Private Intake",
            "handle": "01-js-how-it-works-vnext-icon-private-intake-01",
            "primary_category": "native-intake",
            "rotation_group": "how-it-works-private-intake-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0161",
            "label": "Travel Access Cases 24a Airplane",
            "handle": "24a-js-case-library-vnext-icon-travel-access-cases-24a",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24a",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0027",
            "label": "Structured Intake Request",
            "handle": "icon-9-japansolved-process-submit-request-structured-intake",
            "primary_category": "intake-request",
            "rotation_group": "process-intake-01",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "case-path-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "risk-signal",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "38-50px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "emergency-first-alert",
        "hierarchy": "support",
        "visual_owner": "alert-copy",
        "icon_role": "utility-warning",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-38px",
        "exact_icon_needs": [
          "emergency",
          "police",
          "ambulance",
          "life safety"
        ],
        "clickable": false,
        "notes": "Contained warning is correct.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0055",
            "label": "Engagement Brief Shield Verification",
            "handle": "icon-01-japansolved-engagementbrief-shield-verification",
            "primary_category": "privacy-discretion",
            "rotation_group": "engagement-shield-verification-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0084",
            "label": "Shield Inside Circle Check 2",
            "handle": "japansolved-shield-inside-circle-check-2",
            "primary_category": "privacy-discretion",
            "rotation_group": "shield-circle-check-02",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0087",
            "label": "Shield Inside Circle Check 1",
            "handle": "japansolved-shield-inside-circle-check-1",
            "primary_category": "privacy-discretion",
            "rotation_group": "shield-circle-check-01",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "emergency-first-alert",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "alert-copy",
          "data-jsi-role": "utility-warning",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-38px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "authority-routing-process",
        "hierarchy": "mid",
        "visual_owner": "number-title",
        "icon_role": "workflow-stage",
        "preferred_treatment": "centered-under-number-or-none",
        "preferred_placement": "centered-under-number",
        "preferred_container": "none",
        "size_range": "28-38px",
        "exact_icon_needs": [
          "fact organization",
          "risk classification",
          "authority route",
          "institution contact",
          "licensed investigator"
        ],
        "clickable": false,
        "notes": "Numbers may own hierarchy; icons only if stage-specific.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0094",
            "label": "Institutions Building",
            "handle": "15-js-icon-institutions",
            "primary_category": "institutional-authority",
            "rotation_group": "institutions-15",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0041",
            "label": "Tier Comprehensive Solutions",
            "handle": "icon-16-japansolved-tiers-standard-engagement-comprehensive-solutions",
            "primary_category": "service-tier",
            "rotation_group": "service-tier-comprehensive-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0081",
            "label": "Capital Program",
            "handle": "japansolved-capital-program",
            "primary_category": "investments-capital",
            "rotation_group": "capital-program-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0085",
            "label": "Think Thank Institute Globe",
            "handle": "japansolved-think-thank-institute",
            "primary_category": "institutional-authority",
            "rotation_group": "think-thank-institute-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0088",
            "label": "Reserved Pathway Crown",
            "handle": "japansolved-reserved-pathway-crown-icon",
            "primary_category": "premium-authority",
            "rotation_group": "reserved-pathway-crown-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "authority-routing-process",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "number-title",
          "data-jsi-role": "workflow-stage",
          "data-jsi-treatment": "centered-under-number-or-none",
          "data-jsi-placement": "centered-under-number",
          "data-jsi-container": "none",
          "data-jsi-size": "28-38px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "welfare check icon",
      "authorized family icon",
      "authority route icon",
      "emergency first icon"
    ],
    "content_id": "japan-missing-person-welfare-search-coordination",
    "canonical_handle": "japan-missing-person-welfare-search-coordination",
    "canonical_url": "https://japansolved.com/pages/japan-missing-person-welfare-search-coordination",
    "source_file": "Japan Missing Person Welfare & Search Coordination Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 87608,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-nightlife-companion-safety-support": {
    "title": "Japan Nightlife Companion & Safety Support Desk™",
    "page_wing": "nightlife-companion-safety",
    "narrative_role": "after-dark route design, social buffering, venue reading, companion presence, safe return rhythm",
    "style_mood": "alive but controlled, after-dark ease, safety without fear",
    "icon_strategy_summary": "Use route/clock/shield/people/venue/safe-return symbols. Avoid heavy warning icons. Major after-dark thesis can use free emblem; safety/payment boundaries can use contained stamps.",
    "zones": [
      {
        "section_key": "night-route-design",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-92px",
        "exact_icon_needs": [
          "night route",
          "social buffering",
          "safe return",
          "room reading"
        ],
        "clickable": false,
        "notes": "Should feel alive, not alarmist.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0134",
            "label": "Horse Knight",
            "handle": "horse",
            "primary_category": "strategy-movement",
            "rotation_group": "strategy-movement-horse-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0084",
            "label": "Shield Inside Circle Check 2",
            "handle": "japansolved-shield-inside-circle-check-2",
            "primary_category": "privacy-discretion",
            "rotation_group": "shield-circle-check-02",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0087",
            "label": "Shield Inside Circle Check 1",
            "handle": "japansolved-shield-inside-circle-check-1",
            "primary_category": "privacy-discretion",
            "rotation_group": "shield-circle-check-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0026",
            "label": "CurrentColor Protection Shield",
            "handle": "icon-8-japansolved-solutions-discreet-sensitive-confidential-protection-currentcolor",
            "primary_category": "privacy-discretion",
            "rotation_group": "solution-protection-01",
            "priority": 67
          },
          {
            "registry_id": "JSICON-0040",
            "label": "Comprehensive Solutions Star",
            "handle": "icon-16-e-japansolved-tiers-standard-engagement-comprehensive-solutions",
            "primary_category": "comprehensive-solutions",
            "rotation_group": "comprehensive-solutions-05",
            "priority": 65
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "night-route-design",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "72-92px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "normal-night-route-failure",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "38-50px",
        "exact_icon_needs": [
          "venue rules",
          "late trains",
          "language sensitivity",
          "social current",
          "return path"
        ],
        "clickable": false,
        "notes": "Exact nightlife route issues.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0164",
            "label": "Travel Access Cases 24d Jet Path",
            "handle": "24d-js-case-library-vnext-icon-travel-access-cases-24d",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24d",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0026",
            "label": "CurrentColor Protection Shield",
            "handle": "icon-8-japansolved-solutions-discreet-sensitive-confidential-protection-currentcolor",
            "primary_category": "privacy-discretion",
            "rotation_group": "solution-protection-01",
            "priority": 67
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "normal-night-route-failure",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "problem-signal",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "38-50px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "support-menu",
        "hierarchy": "mid-high",
        "visual_owner": "card-title",
        "icon_role": "category-marker",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "42-56px",
        "exact_icon_needs": [
          "route design",
          "venue guidance",
          "companion fit",
          "safe return",
          "interpretation"
        ],
        "clickable": true,
        "notes": "Potential clickable service cards.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0164",
            "label": "Travel Access Cases 24d Jet Path",
            "handle": "24d-js-case-library-vnext-icon-travel-access-cases-24d",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24d",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0173",
            "label": "Language Gap Chat Bubbles",
            "handle": "28-js-case-library-vnext-icon-language-gap-28",
            "primary_category": "language-gap",
            "rotation_group": "case-library-language-gap-28",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0084",
            "label": "Shield Inside Circle Check 2",
            "handle": "japansolved-shield-inside-circle-check-2",
            "primary_category": "privacy-discretion",
            "rotation_group": "shield-circle-check-02",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0087",
            "label": "Shield Inside Circle Check 1",
            "handle": "japansolved-shield-inside-circle-check-1",
            "primary_category": "privacy-discretion",
            "rotation_group": "shield-circle-check-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0098",
            "label": "Individuals Group",
            "handle": "11-js-icon-individuals-11",
            "primary_category": "client-people",
            "rotation_group": "individuals-group-11",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "support-menu",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "category-marker",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "42-56px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "boundary-notes",
        "hierarchy": "support",
        "visual_owner": "copy",
        "icon_role": "utility-warning",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-38px",
        "exact_icon_needs": [
          "lawful boundaries",
          "discretion",
          "safety",
          "no adult service"
        ],
        "clickable": false,
        "notes": "Contained support marker OK lower down.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0055",
            "label": "Engagement Brief Shield Verification",
            "handle": "icon-01-japansolved-engagementbrief-shield-verification",
            "primary_category": "privacy-discretion",
            "rotation_group": "engagement-shield-verification-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0084",
            "label": "Shield Inside Circle Check 2",
            "handle": "japansolved-shield-inside-circle-check-2",
            "primary_category": "privacy-discretion",
            "rotation_group": "shield-circle-check-02",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0087",
            "label": "Shield Inside Circle Check 1",
            "handle": "japansolved-shield-inside-circle-check-1",
            "primary_category": "privacy-discretion",
            "rotation_group": "shield-circle-check-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0111",
            "label": "How It Works Scope Discipline",
            "handle": "20-js-how-it-works-vnext-icon-scope-discipline-20",
            "primary_category": "scope-discipline",
            "rotation_group": "how-it-works-scope-discipline-20",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "boundary-notes",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "copy",
          "data-jsi-role": "utility-warning",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-38px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "moon/night icon",
      "venue/door icon",
      "safe return/train icon",
      "social buffering icon"
    ],
    "content_id": "japan-nightlife-companion-safety-support",
    "canonical_handle": "japan-nightlife-companion-safety-support",
    "canonical_url": "https://japansolved.com/pages/japan-nightlife-companion-safety-support",
    "source_file": "Japan Nightlife Companion & Safety Support Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 70293,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-personal-shopping-styling-companion-support": {
    "title": "Japan Personal Shopping, Styling & Companion Support Desk™",
    "page_wing": "personal-shopping-styling-companion",
    "narrative_role": "shopping route shaped around style, body, budget, mood, gender expression/privacy, district planning, companion support",
    "style_mood": "human style transformation, private confidence, route-as-mirror",
    "icon_strategy_summary": "Use style/shopping/presence/human warmth icons, but registry lacks fashion-specific assets. Major style thesis should use a free emblem; category cards top-center/free; utility product cards contained.",
    "zones": [
      {
        "section_key": "style-shopping-presence-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-92px",
        "exact_icon_needs": [
          "style transformation",
          "shopping route",
          "human confidence",
          "personal presence"
        ],
        "clickable": false,
        "notes": "Needs fashion/identity sensitivity, not generic box.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0038",
            "label": "Comprehensive Solutions Compass C",
            "handle": "icon-16-c-japansolved-tiers-standard-engagement-comprehensive-solutions",
            "primary_category": "comprehensive-solutions",
            "rotation_group": "comprehensive-solutions-03",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0043",
            "label": "Access Retainer Priority Key B",
            "handle": "icon-17-b-japansolved-tiers-private-access-retainer-priority",
            "primary_category": "retainer-priority",
            "rotation_group": "retainer-priority-02",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "style-shopping-presence-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading",
          "data-jsi-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "72-92px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "route-needs-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "concept-emblem",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "38-50px",
        "exact_icon_needs": [
          "body budget mood",
          "sizing fit",
          "gender expression",
          "beauty floor",
          "district route"
        ],
        "clickable": false,
        "notes": "Exact human-centered icons.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0040",
            "label": "Comprehensive Solutions Star",
            "handle": "icon-16-e-japansolved-tiers-standard-engagement-comprehensive-solutions",
            "primary_category": "comprehensive-solutions",
            "rotation_group": "comprehensive-solutions-05",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0061",
            "label": "Engagement Brief Client Onboarding",
            "handle": "icon-10-japansolved-engagementbrief-client-onboarding",
            "primary_category": "client-onboarding",
            "rotation_group": "engagement-client-onboarding-01",
            "priority": 64
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "route-needs-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "concept-emblem",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "38-50px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "shopping-route-cards",
        "hierarchy": "mid-high",
        "visual_owner": "card-title",
        "icon_role": "category-marker",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "42-56px",
        "exact_icon_needs": [
          "Ginza",
          "Harajuku",
          "Shimokitazawa",
          "vintage luxury",
          "jewelry",
          "beauty"
        ],
        "clickable": true,
        "notes": "Clickable route cards if present.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0100",
            "label": "Collectors Diamond",
            "handle": "13-js-icon-collectors-13",
            "primary_category": "luxury-collectibles",
            "rotation_group": "collectors-diamond-13",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0154",
            "label": "Sourcing Rare Assets Gem Box",
            "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
            "primary_category": "rare-asset-sourcing",
            "rotation_group": "case-library-sourcing-rare-assets-14",
            "priority": 61
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "shopping-route-cards",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "category-marker",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-size": "42-56px",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "product-path",
        "hierarchy": "support",
        "visual_owner": "price-cta",
        "icon_role": "utility-marker",
        "preferred_treatment": "contained-stamp",
        "preferred_placement": "contained-left-stamp",
        "preferred_container": "rounded-square",
        "size_range": "30-38px",
        "exact_icon_needs": [
          "style route review",
          "experience design",
          "companion request"
        ],
        "clickable": false,
        "notes": "Commercial layer.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          },
          {
            "registry_id": "JSICON-0035",
            "label": "Value Driven Target Precision",
            "handle": "icon-15-japansolved-values-results-driven-target-precision",
            "primary_category": "results-outcomes",
            "rotation_group": "target-precision-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0037",
            "label": "Comprehensive Solutions Compass B",
            "handle": "icon-16-b-japansolved-tiers-standard-engagement-comprehensive-solutions",
            "primary_category": "comprehensive-solutions",
            "rotation_group": "comprehensive-solutions-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0047",
            "label": "Precision Target Monoline",
            "handle": "japansolved-solutions-icon-advisory-intelligence-precision-target-monoline",
            "primary_category": "results-outcomes",
            "rotation_group": "monoline-precision-target-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0049",
            "label": "Feasibility Assessment Globe",
            "handle": "icon-11-japansolved-feasibility-assessment",
            "primary_category": "feasibility-assessment",
            "rotation_group": "feasibility-assessment-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "product-path",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "price-cta",
          "data-jsi-role": "utility-marker",
          "data-jsi-treatment": "contained-stamp",
          "data-jsi-placement": "contained-left-stamp",
          "data-jsi-container": "rounded-square",
          "data-jsi-size": "30-38px",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "hanger/fashion icon",
      "body fit/sizing icon",
      "identity expression icon",
      "beauty floor icon"
    ],
    "content_id": "japan-personal-shopping-styling-companion-support",
    "canonical_handle": "japan-personal-shopping-styling-companion-support",
    "canonical_url": "https://japansolved.com/pages/japan-personal-shopping-styling-companion-support",
    "source_file": "Japan Personal Shopping, Styling & Companion Support Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 1",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 91158,
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy already carries the emotional doorway; avoid tiny decorative stamps unless a page has an intentional emblem system."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ numbers, summary controls, and typography should own the interaction. Icons only in side nav/commitment rail, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own form logic and visual hierarchy; do not inject page-body icons inside the centralized slot."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-preloved-vintage-luxury-shopping": {
    "title": "Japan Preloved Vintage Luxury Brand Shopping Desk™",
    "page_wing": "preloved-vintage-luxury-shopping",
    "narrative_role": "condition-aware resale route, vintage luxury archive shopping, authenticity caution, proxy escalation before purchase",
    "style_mood": "archive-luxury restraint, condition intelligence, quiet boutique caution",
    "icon_strategy_summary": "Use small proof/condition icons in resale-risk cards and elegant collector emblems in product/route cards. Keep icons thin, quiet, and jewel-like; avoid fashion-clutter or brand-looking symbols.",
    "zones": [
      {
        "section_key": "resale-condition-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "symbolic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "70-90px",
        "exact_icon_needs": [
          "archive luxury",
          "condition risk",
          "authentication question",
          "resale route"
        ],
        "clickable": false,
        "notes": "One restrained collector/proof emblem is enough near the thesis; the page should feel like a private archive, not a shopping mall.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0100",
            "label": "Collectors Diamond",
            "handle": "13-js-icon-collectors-13",
            "primary_category": "luxury-collectibles",
            "rotation_group": "collectors-diamond-13",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0157",
            "label": "Verification Gap Document",
            "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30a",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0082",
            "label": "Decision Clarity Mono",
            "handle": "js-icon-micro-decision-clarity-mono-bw-v1",
            "primary_category": "advisory-intelligence",
            "rotation_group": "micro-decision-clarity-01",
            "priority": 59
          },
          {
            "registry_id": "JSICON-0048",
            "label": "Restricted Access Monoline",
            "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
            "primary_category": "privacy-discretion",
            "rotation_group": "monoline-restricted-access-01",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "resale-condition-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "symbolic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "archive luxury | condition risk | authentication question | resale route"
        }
      },
      {
        "section_key": "condition-authenticity-pain-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "32-44px",
        "exact_icon_needs": [
          "condition grade",
          "seller claim",
          "photo proof",
          "repair/history ambiguity"
        ],
        "clickable": false,
        "notes": "Pain icons must match the defect or uncertainty being named. Avoid generic stars.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0174",
            "label": "Verification Gap 30c Magnifier",
            "handle": "30c-js-case-library-vnext-icon-verification-gap-30c",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30c",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0157",
            "label": "Verification Gap Document",
            "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30a",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0084",
            "label": "Shield Inside Circle Check 2",
            "handle": "japansolved-shield-inside-circle-check-2",
            "primary_category": "privacy-discretion",
            "rotation_group": "shield-circle-check-02",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0072",
            "label": "Risk Compliance Analysis Mono",
            "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
            "primary_category": "risk-compliance",
            "rotation_group": "footer-risk-compliance-01",
            "priority": 59
          },
          {
            "registry_id": "JSICON-0047",
            "label": "Precision Target Monoline",
            "handle": "japansolved-solutions-icon-advisory-intelligence-precision-target-monoline",
            "primary_category": "results-outcomes",
            "rotation_group": "monoline-precision-target-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "condition-authenticity-pain-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "problem-signal",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "condition grade | seller claim | photo proof | repair/history ambiguity"
        }
      },
      {
        "section_key": "vintage-luxury-route-cards",
        "hierarchy": "mid-high",
        "visual_owner": "card-border-title",
        "icon_role": "category-marker",
        "preferred_treatment": "small-free-icon",
        "preferred_placement": "top-left-floating",
        "preferred_container": "none",
        "size_range": "34-50px",
        "exact_icon_needs": [
          "boutique archive",
          "preloved luxury",
          "private buyer escalation",
          "shipping handoff"
        ],
        "clickable": false,
        "notes": "Use a collector icon for object discovery and logistics icon only when the card crosses into handoff or shipment.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0100",
            "label": "Collectors Diamond",
            "handle": "13-js-icon-collectors-13",
            "primary_category": "luxury-collectibles",
            "rotation_group": "collectors-diamond-13",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0154",
            "label": "Sourcing Rare Assets Gem Box",
            "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
            "primary_category": "rare-asset-sourcing",
            "rotation_group": "case-library-sourcing-rare-assets-14",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "vintage-luxury-route-cards",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "category-marker",
          "data-jsi-treatment": "small-free-icon",
          "data-jsi-placement": "top-left-floating",
          "data-jsi-container": "none",
          "data-jsi-needs": "boutique archive | preloved luxury | private buyer escalation | shipping handoff"
        }
      },
      {
        "section_key": "route-reading-related",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "authentication",
          "private buyer",
          "Ginza luxury",
          "cargo logistics"
        ],
        "clickable": true,
        "notes": "Clickable icons may mirror related card destination; never self-link.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0100",
            "label": "Collectors Diamond",
            "handle": "13-js-icon-collectors-13",
            "primary_category": "luxury-collectibles",
            "rotation_group": "collectors-diamond-13",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "route-reading-related",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "authentication | private buyer | Ginza luxury | cargo logistics"
        }
      }
    ],
    "missing_icon_needs": [
      "handbag/tag condition grading icon",
      "resale archive shelf icon",
      "authenticity stamp icon"
    ],
    "content_id": "japan-preloved-vintage-luxury-shopping",
    "canonical_handle": "japan-preloved-vintage-luxury-shopping",
    "canonical_url": "https://japansolved.com/pages/japan-preloved-vintage-luxury-shopping",
    "source_file": "Japan Preloved Vintage Luxury Brand Shopping Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 90620,
    "source_sha1_12": "43be60b1f7b8",
    "source_signals": {
      "has_centralized_slot_language": true,
      "has_inline_intake_language": false,
      "icon_card_count": 39,
      "pain_card_count": 40,
      "related_card_count": 37,
      "svg_count": 0,
      "img_count": 9,
      "intake_anchor_count": 0,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-private-buyer-proxy-execution-desk": {
    "title": "Japan Private Buyer Proxy & Execution Desk™",
    "page_wing": "private-buyer-proxy-execution",
    "narrative_role": "Japan-side buyer pursuit, seller contact, acquisition execution, payment/file path before active pursuit",
    "style_mood": "operator discipline, pursuit intelligence, purchase-route command",
    "icon_strategy_summary": "Favor execution, target, procurement, and local-representation icons. This page is not browsing; it is pursuit. Icons should feel directional and operational, not decorative.",
    "zones": [
      {
        "section_key": "buyer-execution-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "route-command",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-92px",
        "exact_icon_needs": [
          "buyer mandate",
          "seller pursuit",
          "Japan-side execution",
          "route control"
        ],
        "clickable": false,
        "notes": "A single directional execution mark can anchor the page. Avoid playful shopping icons.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0089",
            "label": "Operational Capability Briefcase",
            "handle": "4-js-icon-operational-capability",
            "primary_category": "execution-support",
            "rotation_group": "operational-capability-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0102",
            "label": "Strategy Target",
            "handle": "02-js-icon-strategy-02",
            "primary_category": "strategy-alignment",
            "rotation_group": "strategy-target-02",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0062",
            "label": "Execution Coordination Nodes",
            "handle": "icon-14-japansolved-execution-coordination",
            "primary_category": "execution-support",
            "rotation_group": "execution-coordination-02",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "buyer-execution-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "route-command",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "buyer mandate | seller pursuit | Japan-side execution | route control"
        }
      },
      {
        "section_key": "seller-friction-pain-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "32-44px",
        "exact_icon_needs": [
          "seller silence",
          "platform restriction",
          "condition uncertainty",
          "timing gap"
        ],
        "clickable": false,
        "notes": "Each card should show the specific purchase obstacle: seller, platform, proof, time, or counterparty.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0155",
            "label": "Execution Gap Compass",
            "handle": "29b-js-case-library-vnext-icon-execution-gap-29b",
            "primary_category": "execution-gap",
            "rotation_group": "case-library-execution-gap-29b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0173",
            "label": "Language Gap Chat Bubbles",
            "handle": "28-js-case-library-vnext-icon-language-gap-28",
            "primary_category": "language-gap",
            "rotation_group": "case-library-language-gap-28",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0157",
            "label": "Verification Gap Document",
            "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30a",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0073",
            "label": "Counterparty Mapping Mono",
            "handle": "js-icon-footer-counterparty-mapping-mono-bw-v1",
            "primary_category": "counterparty-mapping",
            "rotation_group": "footer-counterparty-mapping-01",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "seller-friction-pain-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "problem-signal",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "seller silence | platform restriction | condition uncertainty | timing gap"
        }
      },
      {
        "section_key": "payment-product-path",
        "hierarchy": "mid-high",
        "visual_owner": "product-card-meta",
        "icon_role": "paid-route-marker",
        "preferred_treatment": "micro-stamp",
        "preferred_placement": "price-pill-left",
        "preferred_container": "soft-capsule",
        "size_range": "28-38px",
        "exact_icon_needs": [
          "review",
          "case deposit",
          "buyer execution",
          "retainer"
        ],
        "clickable": false,
        "notes": "Payment/product icons should behave like seals, not illustrations.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0052",
            "label": "Engagement Brief Structured Intake",
            "handle": "icon-02-japansolved-engagementbrief-structured-intake",
            "primary_category": "intake-request",
            "rotation_group": "engagement-brief-intake-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0128",
            "label": "How It Works Quotation Estimates",
            "handle": "08-js-how-it-works-vnext-icon-quotation-estimates-08",
            "primary_category": "quotation-estimate",
            "rotation_group": "how-it-works-quotation-estimates-08",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0042",
            "label": "Access Retainer Priority Key A",
            "handle": "icon-17-a-japansolved-tiers-private-access-retainer-priority",
            "primary_category": "retainer-priority",
            "rotation_group": "retainer-priority-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "payment-product-path",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "paid-route-marker",
          "data-jsi-treatment": "micro-stamp",
          "data-jsi-placement": "price-pill-left",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "review | case deposit | buyer execution | retainer"
        }
      },
      {
        "section_key": "related-desk-pathways",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "proxy QA",
          "private sourcing",
          "cargo logistics",
          "concierge shopping"
        ],
        "clickable": true,
        "notes": "Use related icons to show escalation routes across the four-desk ecosystem.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0152",
            "label": "Local Execution Cases Compass",
            "handle": "23-js-case-library-vnext-icon-local-execution-cases-23",
            "primary_category": "local-execution",
            "rotation_group": "case-library-local-execution-23",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-desk-pathways",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "proxy QA | private sourcing | cargo logistics | concierge shopping"
        }
      }
    ],
    "missing_icon_needs": [
      "seller pursuit icon",
      "purchase order route icon",
      "buyer mandate icon"
    ],
    "content_id": "japan-private-buyer-proxy-execution-desk",
    "canonical_handle": "japan-private-buyer-proxy-execution-desk",
    "canonical_url": "https://japansolved.com/pages/japan-private-buyer-proxy-execution-desk",
    "source_file": "Japan Private Buyer Proxy & Execution Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 67082,
    "source_sha1_12": "f73d1b15c070",
    "source_signals": {
      "has_centralized_slot_language": true,
      "has_inline_intake_language": true,
      "icon_card_count": 18,
      "pain_card_count": 34,
      "related_card_count": 29,
      "svg_count": 0,
      "img_count": 3,
      "intake_anchor_count": 0,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-proxy-shopping-quality-assurance": {
    "title": "Japan Private Deputy Shopping Proxy & Quality Assurance Desk™",
    "page_wing": "proxy-shopping-quality-assurance",
    "narrative_role": "deputy shopping, condition/photo confirmation, seller/platform checks, quality-control before payment or handoff",
    "style_mood": "protective proxy, inspection calm, proof before purchase",
    "icon_strategy_summary": "Use verification, shield-check, magnifier, and procurement icons. This page is the protective membrane between client enthusiasm and Japan-side reality.",
    "zones": [
      {
        "section_key": "proxy-qa-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "protective-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-90px",
        "exact_icon_needs": [
          "proxy protection",
          "quality assurance",
          "seller check",
          "photo proof"
        ],
        "clickable": false,
        "notes": "Use shield/lens as the mental model: we look before the client pays.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0084",
            "label": "Shield Inside Circle Check 2",
            "handle": "japansolved-shield-inside-circle-check-2",
            "primary_category": "privacy-discretion",
            "rotation_group": "shield-circle-check-02",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0174",
            "label": "Verification Gap 30c Magnifier",
            "handle": "30c-js-case-library-vnext-icon-verification-gap-30c",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30c",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0072",
            "label": "Risk Compliance Analysis Mono",
            "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
            "primary_category": "risk-compliance",
            "rotation_group": "footer-risk-compliance-01",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "proxy-qa-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "protective-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "proxy protection | quality assurance | seller check | photo proof"
        }
      },
      {
        "section_key": "qa-risk-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "34-46px",
        "exact_icon_needs": [
          "condition mismatch",
          "fake confidence",
          "seller ambiguity",
          "platform friction"
        ],
        "clickable": false,
        "notes": "If a card speaks about proof, use proof/lens. If it speaks about platform/seller, use counterparty or restricted access.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0157",
            "label": "Verification Gap Document",
            "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30a",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0174",
            "label": "Verification Gap 30c Magnifier",
            "handle": "30c-js-case-library-vnext-icon-verification-gap-30c",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30c",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0073",
            "label": "Counterparty Mapping Mono",
            "handle": "js-icon-footer-counterparty-mapping-mono-bw-v1",
            "primary_category": "counterparty-mapping",
            "rotation_group": "footer-counterparty-mapping-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0048",
            "label": "Restricted Access Monoline",
            "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
            "primary_category": "privacy-discretion",
            "rotation_group": "monoline-restricted-access-01",
            "priority": 59
          },
          {
            "registry_id": "JSICON-0188",
            "label": "Scope Boundary Compass",
            "handle": "14-js-faq-vnext-icon-scope-boundary-compass-14",
            "primary_category": "faq-scope",
            "rotation_group": "faq-scope-boundary-compass-14",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "qa-risk-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "problem-signal",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-needs": "condition mismatch | fake confidence | seller ambiguity | platform friction"
        }
      },
      {
        "section_key": "inspection-process-steps",
        "hierarchy": "mid-high",
        "visual_owner": "step-number-title",
        "icon_role": "process-marker",
        "preferred_treatment": "number-plus-icon",
        "preferred_placement": "left-of-step-number",
        "preferred_container": "soft-capsule",
        "size_range": "24-34px",
        "exact_icon_needs": [
          "identify",
          "verify",
          "report",
          "handoff"
        ],
        "clickable": false,
        "notes": "Keep process icons subordinate to step numbers.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0095",
            "label": "Assess Checklist",
            "handle": "7-js-icon-assess",
            "primary_category": "case-review",
            "rotation_group": "assess-checklist-07",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0028",
            "label": "Analytical Evaluation Lens",
            "handle": "icon-10-japansolved-process-case-review-analytical-evaluation",
            "primary_category": "case-review",
            "rotation_group": "process-evaluation-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0062",
            "label": "Execution Coordination Nodes",
            "handle": "icon-14-japansolved-execution-coordination",
            "primary_category": "execution-support",
            "rotation_group": "execution-coordination-02",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0129",
            "label": "How It Works Scope Prepared",
            "handle": "09-js-how-it-works-vnext-icon-scope-prepared-09",
            "primary_category": "scope-preparation",
            "rotation_group": "how-it-works-scope-prepared-09",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "inspection-process-steps",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "process-marker",
          "data-jsi-treatment": "number-plus-icon",
          "data-jsi-placement": "left-of-step-number",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "identify | verify | report | handoff"
        }
      },
      {
        "section_key": "related-proxy-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "buyer proxy",
          "sourcing",
          "cargo",
          "jewelry/luxury shopping"
        ],
        "clickable": true,
        "notes": "Related pathways can be clickable, but the current proxy QA card must not self-link.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0100",
            "label": "Collectors Diamond",
            "handle": "13-js-icon-collectors-13",
            "primary_category": "luxury-collectibles",
            "rotation_group": "collectors-diamond-13",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-proxy-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "buyer proxy | sourcing | cargo | jewelry/luxury shopping"
        }
      }
    ],
    "missing_icon_needs": [
      "photo proof icon",
      "quality control stamp icon",
      "condition checklist icon"
    ],
    "content_id": "japan-proxy-shopping-quality-assurance",
    "canonical_handle": "japan-proxy-shopping-quality-assurance",
    "canonical_url": "https://japansolved.com/pages/japan-proxy-shopping-quality-assurance",
    "source_file": "Japan Private Deputy Shopping Proxy & Quality Assurance Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 69142,
    "source_sha1_12": "490ea366a659",
    "source_signals": {
      "has_centralized_slot_language": true,
      "has_inline_intake_language": false,
      "icon_card_count": 14,
      "pain_card_count": 29,
      "related_card_count": 21,
      "svg_count": 0,
      "img_count": 9,
      "intake_anchor_count": 0,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "private-cultural-experiences-japan-local-access": {
    "title": "Japan Private Local Experiences & Cultural Access Desk™",
    "page_wing": "private-local-experiences-cultural-access",
    "narrative_role": "artisan doors, local context, cultural texture, neighborhood access beneath bespoke Japan programs",
    "style_mood": "quiet cultural doorways, warm local presence, non-touristic route texture",
    "icon_strategy_summary": "Use cultural access, doorway, local execution, and human-context icons. Icons should feel like doors opening into places, not tourist stickers.",
    "zones": [
      {
        "section_key": "local-access-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "doorway-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "74-94px",
        "exact_icon_needs": [
          "local access",
          "cultural context",
          "artisan door",
          "human layer"
        ],
        "clickable": false,
        "notes": "A doorway or cultural-access mark can quietly signal entry beneath the tourist layer.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0203",
            "label": "Cultural Access Mono Line",
            "handle": "07-js-solutions-vnext-icon-travel-cultural-access-mono-line-07",
            "primary_category": "cultural-access",
            "rotation_group": "solutions-cultural-access-mono-line-07",
            "priority": 53
          },
          {
            "registry_id": "JSICON-0165",
            "label": "Access Gap Doorway",
            "handle": "27-js-case-library-vnext-icon-access-gap-27",
            "primary_category": "access-gap",
            "rotation_group": "case-library-access-gap-27",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0152",
            "label": "Local Execution Cases Compass",
            "handle": "23-js-case-library-vnext-icon-local-execution-cases-23",
            "primary_category": "local-execution",
            "rotation_group": "case-library-local-execution-23",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0104",
            "label": "Japan Intelligence Globe Pin",
            "handle": "03b-js-icon-japan-intelligence-03b",
            "primary_category": "japan-intelligence",
            "rotation_group": "japan-intelligence-03b",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "local-access-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "doorway-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "local access | cultural context | artisan door | human layer"
        }
      },
      {
        "section_key": "experience-possibility-cards",
        "hierarchy": "mid-high",
        "visual_owner": "card-title",
        "icon_role": "category-marker",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "34-48px",
        "exact_icon_needs": [
          "craft",
          "local scene",
          "food route",
          "neighborhood support",
          "private host"
        ],
        "clickable": false,
        "notes": "Match icon to the human or local texture of each route, not merely the activity noun.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0203",
            "label": "Cultural Access Mono Line",
            "handle": "07-js-solutions-vnext-icon-travel-cultural-access-mono-line-07",
            "primary_category": "cultural-access",
            "rotation_group": "solutions-cultural-access-mono-line-07",
            "priority": 53
          },
          {
            "registry_id": "JSICON-0098",
            "label": "Individuals Group",
            "handle": "11-js-icon-individuals-11",
            "primary_category": "client-people",
            "rotation_group": "individuals-group-11",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0103",
            "label": "Japan Intelligence Globe Shield",
            "handle": "03a-js-icon-japan-intelligence-03a",
            "primary_category": "japan-intelligence",
            "rotation_group": "japan-intelligence-03a",
            "priority": 60
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "experience-possibility-cards",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "category-marker",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "craft | local scene | food route | neighborhood support | private host"
        }
      },
      {
        "section_key": "why-japan-context-layer",
        "hierarchy": "mid",
        "visual_owner": "copy-card",
        "icon_role": "context-signal",
        "preferred_treatment": "small-free-icon",
        "preferred_placement": "inline-left",
        "preferred_container": "none",
        "size_range": "28-38px",
        "exact_icon_needs": [
          "language gap",
          "etiquette",
          "scene reading",
          "local timing"
        ],
        "clickable": false,
        "notes": "Small line icons can punctuate context cards if the text is long.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0173",
            "label": "Language Gap Chat Bubbles",
            "handle": "28-js-case-library-vnext-icon-language-gap-28",
            "primary_category": "language-gap",
            "rotation_group": "case-library-language-gap-28",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0082",
            "label": "Decision Clarity Mono",
            "handle": "js-icon-micro-decision-clarity-mono-bw-v1",
            "primary_category": "advisory-intelligence",
            "rotation_group": "micro-decision-clarity-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0155",
            "label": "Execution Gap Compass",
            "handle": "29b-js-case-library-vnext-icon-execution-gap-29b",
            "primary_category": "execution-gap",
            "rotation_group": "case-library-execution-gap-29b",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0104",
            "label": "Japan Intelligence Globe Pin",
            "handle": "03b-js-icon-japan-intelligence-03b",
            "primary_category": "japan-intelligence",
            "rotation_group": "japan-intelligence-03b",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0152",
            "label": "Local Execution Cases Compass",
            "handle": "23-js-case-library-vnext-icon-local-execution-cases-23",
            "primary_category": "local-execution",
            "rotation_group": "case-library-local-execution-23",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "why-japan-context-layer",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "context-signal",
          "data-jsi-treatment": "small-free-icon",
          "data-jsi-placement": "inline-left",
          "data-jsi-container": "none",
          "data-jsi-needs": "language gap | etiquette | scene reading | local timing"
        }
      },
      {
        "section_key": "related-experience-hub-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "travel hub",
          "bespoke design",
          "VIP navigation",
          "restaurant/activity"
        ],
        "clickable": true,
        "notes": "This related layer should visually connect to the parent Travel & Cultural Access Hub.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0203",
            "label": "Cultural Access Mono Line",
            "handle": "07-js-solutions-vnext-icon-travel-cultural-access-mono-line-07",
            "primary_category": "cultural-access",
            "rotation_group": "solutions-cultural-access-mono-line-07",
            "priority": 53
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0137",
            "label": "Airplane Jet 01",
            "handle": "airplane-jet-01",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0165",
            "label": "Access Gap Doorway",
            "handle": "27-js-case-library-vnext-icon-access-gap-27",
            "primary_category": "access-gap",
            "rotation_group": "case-library-access-gap-27",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-experience-hub-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "travel hub | bespoke design | VIP navigation | restaurant/activity"
        }
      }
    ],
    "missing_icon_needs": [
      "artisan hands/craft icon",
      "neighborhood lane icon",
      "local host context icon"
    ],
    "content_id": "private-cultural-experiences-japan-local-access",
    "canonical_handle": "private-cultural-experiences-japan-local-access",
    "canonical_url": "https://japansolved.com/pages/private-cultural-experiences-japan-local-access",
    "source_file": "Japan Private Local Experiences & Cultural Access Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 74599,
    "source_sha1_12": "253f2e8f3fbd",
    "source_signals": {
      "has_centralized_slot_language": true,
      "has_inline_intake_language": false,
      "icon_card_count": 18,
      "pain_card_count": 16,
      "related_card_count": 28,
      "svg_count": 0,
      "img_count": 0,
      "intake_anchor_count": 0,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "high"
  },
  "japan-private-sensitive-matter-review": {
    "title": "Japan Private Sensitive & Discreet Matters Desk",
    "page_wing": "private-sensitive-discreet-matters",
    "narrative_role": "quiet triage for privacy-sensitive Japan-side matters, lawful routing, discretion, suitability and boundaries before action",
    "style_mood": "sealed-door discretion, calm boundary, protected review",
    "icon_strategy_summary": "Use only privacy, shield, restricted access, and sealed-door signals. No decorative variety. This page should feel controlled, private, and sparse.",
    "zones": [
      {
        "section_key": "sensitive-review-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "sealed-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "70-88px",
        "exact_icon_needs": [
          "discretion",
          "lawful review",
          "protected intake",
          "suitability"
        ],
        "clickable": false,
        "notes": "One shield/door symbol only. More than one large icon makes the page feel noisy.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0163",
            "label": "Sensitive Matters Door",
            "handle": "18-js-case-library-vnext-icon-sensitive-matters-18",
            "primary_category": "sensitive-matters",
            "rotation_group": "case-library-sensitive-matters-18",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0048",
            "label": "Restricted Access Monoline",
            "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
            "primary_category": "privacy-discretion",
            "rotation_group": "monoline-restricted-access-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0044",
            "label": "Tier Maximum Discretion Eye",
            "handle": "icon-18-japansolved-tiers-discreet-confidential-maximum-discretion",
            "primary_category": "privacy-discretion",
            "rotation_group": "service-tier-discretion-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0055",
            "label": "Engagement Brief Shield Verification",
            "handle": "icon-01-japansolved-engagementbrief-shield-verification",
            "primary_category": "privacy-discretion",
            "rotation_group": "engagement-shield-verification-01",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "sensitive-review-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "sealed-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "discretion | lawful review | protected intake | suitability"
        }
      },
      {
        "section_key": "boundary-risk-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "boundary-marker",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "30-42px",
        "exact_icon_needs": [
          "privacy",
          "consent",
          "lawful basis",
          "controlled exposure"
        ],
        "clickable": false,
        "notes": "Every icon must reinforce boundary and responsibility, never drama.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0185",
            "label": "Discretion Shield",
            "handle": "16-js-faq-vnext-icon-discretion-shield-16",
            "primary_category": "faq-discretion",
            "rotation_group": "faq-discretion-shield-16",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0188",
            "label": "Scope Boundary Compass",
            "handle": "14-js-faq-vnext-icon-scope-boundary-compass-14",
            "primary_category": "faq-scope",
            "rotation_group": "faq-scope-boundary-compass-14",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0072",
            "label": "Risk Compliance Analysis Mono",
            "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
            "primary_category": "risk-compliance",
            "rotation_group": "footer-risk-compliance-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0057",
            "label": "Engagement Brief Restricted Advisory",
            "handle": "icon-03-japansolved-engagementbrief-restricted-advisory",
            "primary_category": "advisory-intelligence",
            "rotation_group": "engagement-restricted-advisory-01",
            "priority": 59
          },
          {
            "registry_id": "JSICON-0087",
            "label": "Shield Inside Circle Check 1",
            "handle": "japansolved-shield-inside-circle-check-1",
            "primary_category": "privacy-discretion",
            "rotation_group": "shield-circle-check-01",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "boundary-risk-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "boundary-marker",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "privacy | consent | lawful basis | controlled exposure"
        }
      },
      {
        "section_key": "review-process",
        "hierarchy": "mid-high",
        "visual_owner": "step-title",
        "icon_role": "trust-step-marker",
        "preferred_treatment": "number-plus-icon",
        "preferred_placement": "left-of-step-number",
        "preferred_container": "soft-capsule",
        "size_range": "24-34px",
        "exact_icon_needs": [
          "identify",
          "verify",
          "limit scope",
          "route privately"
        ],
        "clickable": false,
        "notes": "Keep icons small beside process numbers; never inside final confirmation/intake.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0114",
            "label": "How It Works Private Intake",
            "handle": "01-js-how-it-works-vnext-icon-private-intake-01",
            "primary_category": "native-intake",
            "rotation_group": "how-it-works-private-intake-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0095",
            "label": "Assess Checklist",
            "handle": "7-js-icon-assess",
            "primary_category": "case-review",
            "rotation_group": "assess-checklist-07",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0188",
            "label": "Scope Boundary Compass",
            "handle": "14-js-faq-vnext-icon-scope-boundary-compass-14",
            "primary_category": "faq-scope",
            "rotation_group": "faq-scope-boundary-compass-14",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "review-process",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "trust-step-marker",
          "data-jsi-treatment": "number-plus-icon",
          "data-jsi-placement": "left-of-step-number",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "identify | verify | limit scope | route privately"
        }
      },
      {
        "section_key": "related-sensitive-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "missing person",
          "welfare coordination",
          "travel suitability",
          "medical representation"
        ],
        "clickable": true,
        "notes": "Clickable related icons should stay understated.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0163",
            "label": "Sensitive Matters Door",
            "handle": "18-js-case-library-vnext-icon-sensitive-matters-18",
            "primary_category": "sensitive-matters",
            "rotation_group": "case-library-sensitive-matters-18",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0080",
            "label": "Medical Due Diligence Mono",
            "handle": "js-icon-footer-medical-operational-due-diligence-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "footer-medical-due-diligence-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0083",
            "label": "Decision Intelligence Mono",
            "handle": "js-icon-footer-decision-ready-intelligence-mono-bw-v1",
            "primary_category": "advisory-intelligence",
            "rotation_group": "footer-decision-intelligence-01",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-sensitive-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "missing person | welfare coordination | travel suitability | medical representation"
        }
      }
    ],
    "missing_icon_needs": [
      "sealed dossier icon",
      "private chamber door icon",
      "lawful boundary seal icon"
    ],
    "content_id": "japan-private-sensitive-matter-review",
    "canonical_handle": "japan-private-sensitive-matter-review",
    "canonical_url": "https://japansolved.com/pages/japan-private-sensitive-matter-review",
    "source_file": "Japan Private Sensitive & Discreet Matters Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 43995,
    "source_sha1_12": "9b03d6ef2259",
    "source_signals": {
      "has_centralized_slot_language": false,
      "has_inline_intake_language": false,
      "icon_card_count": 10,
      "pain_card_count": 12,
      "related_card_count": 19,
      "svg_count": 0,
      "img_count": 0,
      "intake_anchor_count": 0,
      "schema_key": "sensitive_discreet",
      "data_handle": "japan-private-sensitive-matter-review"
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "high"
  },
  "japan-private-sourcing-collector-acquisition-desk": {
    "title": "Japan Private Sourcing & Collector Acquisition Desk™",
    "page_wing": "private-sourcing-collector-acquisition",
    "narrative_role": "rare-object sourcing, collector acquisition, seller identification, private route formation, escalation into proxy/logistics when needed",
    "style_mood": "collector hunt, rare asset intelligence, acquisition quiet power",
    "icon_strategy_summary": "Use rare-asset, collector, procurement, target, and verification icons. Treat icons like map pins in a collector hunt, not catalogue symbols.",
    "zones": [
      {
        "section_key": "collector-acquisition-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "hunt-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "74-94px",
        "exact_icon_needs": [
          "rare asset",
          "collector hunt",
          "private sourcing",
          "acquisition intelligence"
        ],
        "clickable": false,
        "notes": "Large icon can be jewel/box/target depending on whether the section is emotional or operational.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0154",
            "label": "Sourcing Rare Assets Gem Box",
            "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
            "primary_category": "rare-asset-sourcing",
            "rotation_group": "case-library-sourcing-rare-assets-14",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0100",
            "label": "Collectors Diamond",
            "handle": "13-js-icon-collectors-13",
            "primary_category": "luxury-collectibles",
            "rotation_group": "collectors-diamond-13",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0102",
            "label": "Strategy Target",
            "handle": "02-js-icon-strategy-02",
            "primary_category": "strategy-alignment",
            "rotation_group": "strategy-target-02",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0141",
            "label": "Magnifying Glass",
            "handle": "magnifying-glass",
            "primary_category": "advisory-intelligence",
            "rotation_group": "advisory-magnifying-glass-01",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "collector-acquisition-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "hunt-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "rare asset | collector hunt | private sourcing | acquisition intelligence"
        }
      },
      {
        "section_key": "sourcing-friction-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-center-free",
        "preferred_placement": "top-center-free",
        "preferred_container": "none",
        "size_range": "34-48px",
        "exact_icon_needs": [
          "seller discovery",
          "availability uncertainty",
          "condition proof",
          "negotiation gap"
        ],
        "clickable": false,
        "notes": "Specificity is the win: search, seller, proof, language, timing.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0141",
            "label": "Magnifying Glass",
            "handle": "magnifying-glass",
            "primary_category": "advisory-intelligence",
            "rotation_group": "advisory-magnifying-glass-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0073",
            "label": "Counterparty Mapping Mono",
            "handle": "js-icon-footer-counterparty-mapping-mono-bw-v1",
            "primary_category": "counterparty-mapping",
            "rotation_group": "footer-counterparty-mapping-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0157",
            "label": "Verification Gap Document",
            "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30a",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0155",
            "label": "Execution Gap Compass",
            "handle": "29b-js-case-library-vnext-icon-execution-gap-29b",
            "primary_category": "execution-gap",
            "rotation_group": "case-library-execution-gap-29b",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0173",
            "label": "Language Gap Chat Bubbles",
            "handle": "28-js-case-library-vnext-icon-language-gap-28",
            "primary_category": "language-gap",
            "rotation_group": "case-library-language-gap-28",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "sourcing-friction-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "problem-signal",
          "data-jsi-treatment": "top-center-free",
          "data-jsi-placement": "top-center-free",
          "data-jsi-container": "none",
          "data-jsi-needs": "seller discovery | availability uncertainty | condition proof | negotiation gap"
        }
      },
      {
        "section_key": "acquisition-route-flow",
        "hierarchy": "mid-high",
        "visual_owner": "step-title",
        "icon_role": "flow-marker",
        "preferred_treatment": "number-plus-icon",
        "preferred_placement": "left-of-step-number",
        "preferred_container": "soft-capsule",
        "size_range": "24-36px",
        "exact_icon_needs": [
          "brief",
          "map",
          "approach",
          "purchase path",
          "handoff"
        ],
        "clickable": false,
        "notes": "Flow icons can help break long acquisition process blocks.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0052",
            "label": "Engagement Brief Structured Intake",
            "handle": "icon-02-japansolved-engagementbrief-structured-intake",
            "primary_category": "intake-request",
            "rotation_group": "engagement-brief-intake-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0062",
            "label": "Execution Coordination Nodes",
            "handle": "icon-14-japansolved-execution-coordination",
            "primary_category": "execution-support",
            "rotation_group": "execution-coordination-02",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "acquisition-route-flow",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "flow-marker",
          "data-jsi-treatment": "number-plus-icon",
          "data-jsi-placement": "left-of-step-number",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "brief | map | approach | purchase path | handoff"
        }
      },
      {
        "section_key": "related-sourcing-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "private buyer",
          "proxy QA",
          "large cargo",
          "luxury collectibles"
        ],
        "clickable": true,
        "notes": "Related route icons should show when sourcing becomes buyer proxy, QA, or logistics.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0100",
            "label": "Collectors Diamond",
            "handle": "13-js-icon-collectors-13",
            "primary_category": "luxury-collectibles",
            "rotation_group": "collectors-diamond-13",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-sourcing-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "private buyer | proxy QA | large cargo | luxury collectibles"
        }
      }
    ],
    "missing_icon_needs": [
      "auction paddle icon",
      "rare object route map icon",
      "seller lead icon"
    ],
    "content_id": "japan-private-sourcing-collector-acquisition-desk",
    "canonical_handle": "japan-private-sourcing-collector-acquisition-desk",
    "canonical_url": "https://japansolved.com/pages/japan-private-sourcing-collector-acquisition-desk",
    "source_file": "Japan Private Sourcing & Collector Acquisition Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 181837,
    "source_sha1_12": "5b875dd8446a",
    "source_signals": {
      "has_centralized_slot_language": false,
      "has_inline_intake_language": true,
      "icon_card_count": 18,
      "pain_card_count": 25,
      "related_card_count": 25,
      "svg_count": 0,
      "img_count": 9,
      "intake_anchor_count": 1,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-private-travel-companion-sabbatical-reset": {
    "title": "Japan Private Travel Companion & Sabbatical Reset Desk™",
    "page_wing": "private-travel-companion-sabbatical-reset",
    "narrative_role": "private travel presence, soft reset, companion suitability, route rhythm, safety/discretion before in-person support",
    "style_mood": "calm human presence, soft reset, private Japan rhythm",
    "icon_strategy_summary": "Use human, private access, travel, shield, and stewardship icons. Do not over-icon emotional copy; icons should feel like quiet presence and route rhythm.",
    "zones": [
      {
        "section_key": "companion-reset-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "human-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-92px",
        "exact_icon_needs": [
          "private presence",
          "reset",
          "suitability",
          "soft travel rhythm"
        ],
        "clickable": false,
        "notes": "Use one human/private-access emblem. Avoid anything that looks romance-coded.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0098",
            "label": "Individuals Group",
            "handle": "11-js-icon-individuals-11",
            "primary_category": "client-people",
            "rotation_group": "individuals-group-11",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0153",
            "label": "Visiting Japan Privately Keyhole",
            "handle": "16-js-case-library-vnext-icon-accessing-japan-privately-16",
            "primary_category": "private-japan-access",
            "rotation_group": "case-library-private-japan-16",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0115",
            "label": "How It Works Ongoing Stewardship",
            "handle": "15-js-how-it-works-vnext-icon-ongoing-stewardship-15",
            "primary_category": "stewardship-support",
            "rotation_group": "how-it-works-ongoing-stewardship-15",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "companion-reset-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "human-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "private presence | reset | suitability | soft travel rhythm"
        }
      },
      {
        "section_key": "suitability-boundary-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "trust-signal",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "30-42px",
        "exact_icon_needs": [
          "compatibility",
          "boundaries",
          "privacy",
          "timing"
        ],
        "clickable": false,
        "notes": "Icons must support suitability and privacy, not imply guarantee or companionship on demand.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0087",
            "label": "Shield Inside Circle Check 1",
            "handle": "japansolved-shield-inside-circle-check-1",
            "primary_category": "privacy-discretion",
            "rotation_group": "shield-circle-check-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0188",
            "label": "Scope Boundary Compass",
            "handle": "14-js-faq-vnext-icon-scope-boundary-compass-14",
            "primary_category": "faq-scope",
            "rotation_group": "faq-scope-boundary-compass-14",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0048",
            "label": "Restricted Access Monoline",
            "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
            "primary_category": "privacy-discretion",
            "rotation_group": "monoline-restricted-access-01",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "suitability-boundary-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "trust-signal",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "compatibility | boundaries | privacy | timing"
        }
      },
      {
        "section_key": "reset-program-paths",
        "hierarchy": "mid-high",
        "visual_owner": "product-card-meta",
        "icon_role": "program-marker",
        "preferred_treatment": "micro-stamp",
        "preferred_placement": "price-pill-left",
        "preferred_container": "soft-capsule",
        "size_range": "28-38px",
        "exact_icon_needs": [
          "compatibility review",
          "day session",
          "multi-day program",
          "retainer"
        ],
        "clickable": false,
        "notes": "Program icons should feel premium and quiet, not package-tour.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0071",
            "label": "Key Inside Circle",
            "handle": "japansolved-key-inside-circle",
            "primary_category": "private-access",
            "rotation_group": "private-access-key-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0161",
            "label": "Travel Access Cases 24a Airplane",
            "handle": "24a-js-case-library-vnext-icon-travel-access-cases-24a",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24a",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0042",
            "label": "Access Retainer Priority Key A",
            "handle": "icon-17-a-japansolved-tiers-private-access-retainer-priority",
            "primary_category": "retainer-priority",
            "rotation_group": "retainer-priority-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0115",
            "label": "How It Works Ongoing Stewardship",
            "handle": "15-js-how-it-works-vnext-icon-ongoing-stewardship-15",
            "primary_category": "stewardship-support",
            "rotation_group": "how-it-works-ongoing-stewardship-15",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "reset-program-paths",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "program-marker",
          "data-jsi-treatment": "micro-stamp",
          "data-jsi-placement": "price-pill-left",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "compatibility review | day session | multi-day program | retainer"
        }
      },
      {
        "section_key": "related-reset-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "VIP navigation",
          "nightlife safety",
          "personal shopping companion",
          "travel hub"
        ],
        "clickable": true,
        "notes": "Related icons reveal how companion support can combine with access, safety, style, or navigation.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0163",
            "label": "Sensitive Matters Door",
            "handle": "18-js-case-library-vnext-icon-sensitive-matters-18",
            "primary_category": "sensitive-matters",
            "rotation_group": "case-library-sensitive-matters-18",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0098",
            "label": "Individuals Group",
            "handle": "11-js-icon-individuals-11",
            "primary_category": "client-people",
            "rotation_group": "individuals-group-11",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0137",
            "label": "Airplane Jet 01",
            "handle": "airplane-jet-01",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-reset-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "VIP navigation | nightlife safety | personal shopping companion | travel hub"
        }
      }
    ],
    "missing_icon_needs": [
      "calm companion presence icon",
      "reset rhythm icon",
      "Yamato suitability symbol"
    ],
    "content_id": "japan-private-travel-companion-sabbatical-reset",
    "canonical_handle": "japan-private-travel-companion-sabbatical-reset",
    "canonical_url": "https://japansolved.com/pages/japan-private-travel-companion-sabbatical-reset",
    "source_file": "Japan Private Travel Companion & Sabbatical Reset Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 117388,
    "source_sha1_12": "5d37900720c7",
    "source_signals": {
      "has_centralized_slot_language": false,
      "has_inline_intake_language": true,
      "icon_card_count": 19,
      "pain_card_count": 24,
      "related_card_count": 37,
      "svg_count": 0,
      "img_count": 0,
      "intake_anchor_count": 0,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "high"
  },
  "japan-restaurant-activity-reservation-concierge": {
    "title": "Japan Restaurant, Activity & Reservation Concierge Desk™",
    "page_wing": "restaurant-activity-reservation-concierge",
    "narrative_role": "reservation logic, restaurants/activities/timed access, provider contact, booking route review before execution",
    "style_mood": "calendar precision, queue intelligence, polished access coordination",
    "icon_strategy_summary": "Use clock, access-gap, cultural access, language gap, and priority icons. Avoid food clichés unless a true restaurant/table icon exists in the asset bank.",
    "zones": [
      {
        "section_key": "reservation-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "access-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-90px",
        "exact_icon_needs": [
          "reservation access",
          "timed entry",
          "booking route",
          "provider contact"
        ],
        "clickable": false,
        "notes": "The page should feel like timing and access, not generic dining.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0165",
            "label": "Access Gap Doorway",
            "handle": "27-js-case-library-vnext-icon-access-gap-27",
            "primary_category": "access-gap",
            "rotation_group": "case-library-access-gap-27",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0064",
            "label": "Priority Access Star",
            "handle": "icon-15-japansolved-priority-access",
            "primary_category": "priority-access",
            "rotation_group": "priority-access-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0173",
            "label": "Language Gap Chat Bubbles",
            "handle": "28-js-case-library-vnext-icon-language-gap-28",
            "primary_category": "language-gap",
            "rotation_group": "case-library-language-gap-28",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "reservation-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "access-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "reservation access | timed entry | booking route | provider contact"
        }
      },
      {
        "section_key": "booking-friction-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "32-44px",
        "exact_icon_needs": [
          "sold out",
          "language barrier",
          "deposit rule",
          "timing window",
          "provider ambiguity"
        ],
        "clickable": false,
        "notes": "Icon each card by route failure type.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0173",
            "label": "Language Gap Chat Bubbles",
            "handle": "28-js-case-library-vnext-icon-language-gap-28",
            "primary_category": "language-gap",
            "rotation_group": "case-library-language-gap-28",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0155",
            "label": "Execution Gap Compass",
            "handle": "29b-js-case-library-vnext-icon-execution-gap-29b",
            "primary_category": "execution-gap",
            "rotation_group": "case-library-execution-gap-29b",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0174",
            "label": "Verification Gap 30c Magnifier",
            "handle": "30c-js-case-library-vnext-icon-verification-gap-30c",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30c",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0188",
            "label": "Scope Boundary Compass",
            "handle": "14-js-faq-vnext-icon-scope-boundary-compass-14",
            "primary_category": "faq-scope",
            "rotation_group": "faq-scope-boundary-compass-14",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "booking-friction-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "problem-signal",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "sold out | language barrier | deposit rule | timing window | provider ambiguity"
        }
      },
      {
        "section_key": "reservation-product-ladder",
        "hierarchy": "mid-high",
        "visual_owner": "product-card-meta",
        "icon_role": "paid-route-marker",
        "preferred_treatment": "micro-stamp",
        "preferred_placement": "price-pill-left",
        "preferred_container": "soft-capsule",
        "size_range": "28-38px",
        "exact_icon_needs": [
          "review",
          "case deposit",
          "concierge route",
          "private program"
        ],
        "clickable": false,
        "notes": "Pricing cards should have small, clean seals.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0128",
            "label": "How It Works Quotation Estimates",
            "handle": "08-js-how-it-works-vnext-icon-quotation-estimates-08",
            "primary_category": "quotation-estimate",
            "rotation_group": "how-it-works-quotation-estimates-08",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0064",
            "label": "Priority Access Star",
            "handle": "icon-15-japansolved-priority-access",
            "primary_category": "priority-access",
            "rotation_group": "priority-access-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0042",
            "label": "Access Retainer Priority Key A",
            "handle": "icon-17-a-japansolved-tiers-private-access-retainer-priority",
            "primary_category": "retainer-priority",
            "rotation_group": "retainer-priority-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "reservation-product-ladder",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "paid-route-marker",
          "data-jsi-treatment": "micro-stamp",
          "data-jsi-placement": "price-pill-left",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "review | case deposit | concierge route | private program"
        }
      },
      {
        "section_key": "related-access-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "ticket access",
          "VIP navigation",
          "local experiences",
          "bespoke itinerary"
        ],
        "clickable": true,
        "notes": "Related icons should distinguish ticket/event vs restaurant/activity access.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0165",
            "label": "Access Gap Doorway",
            "handle": "27-js-case-library-vnext-icon-access-gap-27",
            "primary_category": "access-gap",
            "rotation_group": "case-library-access-gap-27",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0203",
            "label": "Cultural Access Mono Line",
            "handle": "07-js-solutions-vnext-icon-travel-cultural-access-mono-line-07",
            "primary_category": "cultural-access",
            "rotation_group": "solutions-cultural-access-mono-line-07",
            "priority": 51
          },
          {
            "registry_id": "JSICON-0137",
            "label": "Airplane Jet 01",
            "handle": "airplane-jet-01",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-access-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "ticket access | VIP navigation | local experiences | bespoke itinerary"
        }
      }
    ],
    "missing_icon_needs": [
      "reservation book icon",
      "restaurant table icon",
      "queue/timed-entry icon"
    ],
    "content_id": "japan-restaurant-activity-reservation-concierge",
    "canonical_handle": "japan-restaurant-activity-reservation-concierge",
    "canonical_url": "https://japansolved.com/pages/japan-restaurant-activity-reservation-concierge",
    "source_file": "Japan Restaurant, Activity & Reservation Concierge Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 112255,
    "source_sha1_12": "f0f0dc4dbcbf",
    "source_signals": {
      "has_centralized_slot_language": true,
      "has_inline_intake_language": false,
      "icon_card_count": 15,
      "pain_card_count": 16,
      "related_card_count": 46,
      "svg_count": 0,
      "img_count": 0,
      "intake_anchor_count": 0,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-recovery-sabbatical-wellness-stay-design": {
    "title": "Japan Sabbatical Planning & Recovery Itinerary Design Desk",
    "page_wing": "sabbatical-recovery-wellness-stay-design",
    "narrative_role": "soft recovery stay design, wellness pacing, itinerary design for restoration, private rhythm before logistics",
    "style_mood": "quiet reset, wellness architecture, gentle pacing",
    "icon_strategy_summary": "Use travel rhythm, shield, clock, stewardship, and scope icons sparingly. This page needs air. Too many icons make recovery feel procedural.",
    "zones": [
      {
        "section_key": "recovery-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "rhythm-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "70-88px",
        "exact_icon_needs": [
          "recovery",
          "sabbatical",
          "soft pacing",
          "private itinerary"
        ],
        "clickable": false,
        "notes": "Use one soft route/rhythm emblem; never medicalize the page with clinic icons.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0115",
            "label": "How It Works Ongoing Stewardship",
            "handle": "15-js-how-it-works-vnext-icon-ongoing-stewardship-15",
            "primary_category": "stewardship-support",
            "rotation_group": "how-it-works-ongoing-stewardship-15",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 60
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "recovery-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "rhythm-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "recovery | sabbatical | soft pacing | private itinerary"
        }
      },
      {
        "section_key": "wellness-friction-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "gentle-problem-signal",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "30-42px",
        "exact_icon_needs": [
          "overplanning",
          "wrong pace",
          "privacy",
          "date window",
          "location fit"
        ],
        "clickable": false,
        "notes": "Icons should feel like pacing and fit, not alarm.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0188",
            "label": "Scope Boundary Compass",
            "handle": "14-js-faq-vnext-icon-scope-boundary-compass-14",
            "primary_category": "faq-scope",
            "rotation_group": "faq-scope-boundary-compass-14",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0082",
            "label": "Decision Clarity Mono",
            "handle": "js-icon-micro-decision-clarity-mono-bw-v1",
            "primary_category": "advisory-intelligence",
            "rotation_group": "micro-decision-clarity-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0104",
            "label": "Japan Intelligence Globe Pin",
            "handle": "03b-js-icon-japan-intelligence-03b",
            "primary_category": "japan-intelligence",
            "rotation_group": "japan-intelligence-03b",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "wellness-friction-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "gentle-problem-signal",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "overplanning | wrong pace | privacy | date window | location fit"
        }
      },
      {
        "section_key": "itinerary-design-process",
        "hierarchy": "mid-high",
        "visual_owner": "step-title",
        "icon_role": "design-step-marker",
        "preferred_treatment": "number-plus-icon",
        "preferred_placement": "left-of-step-number",
        "preferred_container": "soft-capsule",
        "size_range": "24-34px",
        "exact_icon_needs": [
          "themes",
          "feasibility",
          "route logic",
          "paid path"
        ],
        "clickable": false,
        "notes": "Design process icons can be useful if kept as micro-stamps beside step numbers.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0053",
            "label": "Engagement Preparedness Pencil",
            "handle": "icon-06-japansolved-engagementbrief-engagement-preparedness",
            "primary_category": "engagement-brief",
            "rotation_group": "engagement-preparedness-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0049",
            "label": "Feasibility Assessment Globe",
            "handle": "icon-11-japansolved-feasibility-assessment",
            "primary_category": "feasibility-assessment",
            "rotation_group": "feasibility-assessment-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0129",
            "label": "How It Works Scope Prepared",
            "handle": "09-js-how-it-works-vnext-icon-scope-prepared-09",
            "primary_category": "scope-preparation",
            "rotation_group": "how-it-works-scope-prepared-09",
            "priority": 60
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "itinerary-design-process",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "design-step-marker",
          "data-jsi-treatment": "number-plus-icon",
          "data-jsi-placement": "left-of-step-number",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "themes | feasibility | route logic | paid path"
        }
      },
      {
        "section_key": "related-recovery-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "companion reset",
          "wellness access",
          "bespoke experience",
          "travel suitability"
        ],
        "clickable": true,
        "notes": "Related icons should show adjacent doors without sounding clinical.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0098",
            "label": "Individuals Group",
            "handle": "11-js-icon-individuals-11",
            "primary_category": "client-people",
            "rotation_group": "individuals-group-11",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0071",
            "label": "Key Inside Circle",
            "handle": "japansolved-key-inside-circle",
            "primary_category": "private-access",
            "rotation_group": "private-access-key-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-recovery-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "companion reset | wellness access | bespoke experience | travel suitability"
        }
      }
    ],
    "missing_icon_needs": [
      "wellness stay icon",
      "recovery rhythm icon",
      "quiet retreat doorway icon"
    ],
    "content_id": "japan-recovery-sabbatical-wellness-stay-design",
    "canonical_handle": "japan-recovery-sabbatical-wellness-stay-design",
    "canonical_url": "https://japansolved.com/pages/japan-recovery-sabbatical-wellness-stay-design",
    "source_file": "Japan Sabbatical Planning & Recovery Itinerary Design Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 52527,
    "source_sha1_12": "412c9df6a1b5",
    "source_signals": {
      "has_centralized_slot_language": false,
      "has_inline_intake_language": false,
      "icon_card_count": 16,
      "pain_card_count": 18,
      "related_card_count": 19,
      "svg_count": 0,
      "img_count": 0,
      "intake_anchor_count": 0,
      "schema_key": "sabbatical_recovery",
      "data_handle": "japan-recovery-sabbatical-wellness-stay-design"
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-medical-second-opinion-due-diligence-review": {
    "title": "Japan Second Opinion, Due Diligence & Medical Representation Desk",
    "page_wing": "medical-second-opinion-due-diligence",
    "narrative_role": "clinic/provider due diligence, second-opinion routing, document readiness, non-medical representation boundaries",
    "style_mood": "clinical due diligence, careful representation, documentation clarity",
    "icon_strategy_summary": "Use medical due-diligence, clinic protocol, document verification, risk compliance, and shield icons. Keep visual tone sober and factual.",
    "zones": [
      {
        "section_key": "second-opinion-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "medical-review-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-90px",
        "exact_icon_needs": [
          "second opinion",
          "due diligence",
          "clinic routing",
          "document review"
        ],
        "clickable": false,
        "notes": "Use a clinical lens/document mark, not a hospital cross unless a compliant icon exists.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0080",
            "label": "Medical Due Diligence Mono",
            "handle": "js-icon-footer-medical-operational-due-diligence-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "footer-medical-due-diligence-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0074",
            "label": "Clinic Protocol Review Mono",
            "handle": "js-icon-micro-clinic-protocol-review-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "micro-clinic-protocol-review-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0072",
            "label": "Risk Compliance Analysis Mono",
            "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
            "primary_category": "risk-compliance",
            "rotation_group": "footer-risk-compliance-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0157",
            "label": "Verification Gap Document",
            "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30a",
            "priority": 60
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "second-opinion-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "medical-review-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "second opinion | due diligence | clinic routing | document review"
        }
      },
      {
        "section_key": "clinic-risk-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "risk-signal",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "30-42px",
        "exact_icon_needs": [
          "provider claim",
          "protocol ambiguity",
          "document gap",
          "consent",
          "medical boundary"
        ],
        "clickable": false,
        "notes": "Icons must reinforce due diligence, not medical advice.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0074",
            "label": "Clinic Protocol Review Mono",
            "handle": "js-icon-micro-clinic-protocol-review-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "micro-clinic-protocol-review-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0072",
            "label": "Risk Compliance Analysis Mono",
            "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
            "primary_category": "risk-compliance",
            "rotation_group": "footer-risk-compliance-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0157",
            "label": "Verification Gap Document",
            "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30a",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0188",
            "label": "Scope Boundary Compass",
            "handle": "14-js-faq-vnext-icon-scope-boundary-compass-14",
            "primary_category": "faq-scope",
            "rotation_group": "faq-scope-boundary-compass-14",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0185",
            "label": "Discretion Shield",
            "handle": "16-js-faq-vnext-icon-discretion-shield-16",
            "primary_category": "faq-discretion",
            "rotation_group": "faq-discretion-shield-16",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "clinic-risk-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "risk-signal",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "provider claim | protocol ambiguity | document gap | consent | medical boundary"
        }
      },
      {
        "section_key": "document-process-steps",
        "hierarchy": "mid-high",
        "visual_owner": "step-title",
        "icon_role": "process-marker",
        "preferred_treatment": "number-plus-icon",
        "preferred_placement": "left-of-step-number",
        "preferred_container": "soft-capsule",
        "size_range": "24-34px",
        "exact_icon_needs": [
          "collect",
          "organize",
          "review route",
          "represent logistics"
        ],
        "clickable": false,
        "notes": "Process icons must keep the non-medical boundary visible.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0053",
            "label": "Engagement Preparedness Pencil",
            "handle": "icon-06-japansolved-engagementbrief-engagement-preparedness",
            "primary_category": "engagement-brief",
            "rotation_group": "engagement-preparedness-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0095",
            "label": "Assess Checklist",
            "handle": "7-js-icon-assess",
            "primary_category": "case-review",
            "rotation_group": "assess-checklist-07",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0028",
            "label": "Analytical Evaluation Lens",
            "handle": "icon-10-japansolved-process-case-review-analytical-evaluation",
            "primary_category": "case-review",
            "rotation_group": "process-evaluation-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0058",
            "label": "Local Representation Institution",
            "handle": "icon-13-japansolved-local-representation",
            "primary_category": "logistics-representation",
            "rotation_group": "local-representation-02",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0084",
            "label": "Shield Inside Circle Check 2",
            "handle": "japansolved-shield-inside-circle-check-2",
            "primary_category": "privacy-discretion",
            "rotation_group": "shield-circle-check-02",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "document-process-steps",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "process-marker",
          "data-jsi-treatment": "number-plus-icon",
          "data-jsi-placement": "left-of-step-number",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "collect | organize | review route | represent logistics"
        }
      },
      {
        "section_key": "related-medical-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "medical tourism",
          "stem cell longevity",
          "discreet care",
          "travel suitability"
        ],
        "clickable": true,
        "notes": "Medical-related icons can repeat intentionally to create a trustworthy wing.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0080",
            "label": "Medical Due Diligence Mono",
            "handle": "js-icon-footer-medical-operational-due-diligence-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "footer-medical-due-diligence-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0074",
            "label": "Clinic Protocol Review Mono",
            "handle": "js-icon-micro-clinic-protocol-review-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "micro-clinic-protocol-review-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0083",
            "label": "Decision Intelligence Mono",
            "handle": "js-icon-footer-decision-ready-intelligence-mono-bw-v1",
            "primary_category": "advisory-intelligence",
            "rotation_group": "footer-decision-intelligence-01",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-medical-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "medical tourism | stem cell longevity | discreet care | travel suitability"
        }
      }
    ],
    "missing_icon_needs": [
      "second opinion twin-lens icon",
      "medical document folder icon",
      "clinic route comparison icon"
    ],
    "content_id": "japan-medical-second-opinion-due-diligence-review",
    "canonical_handle": "japan-medical-second-opinion-due-diligence-review",
    "canonical_url": "https://japansolved.com/pages/japan-medical-second-opinion-due-diligence-review",
    "source_file": "Japan Second Opinion, Due Diligence & Medical Representation Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 41310,
    "source_sha1_12": "7528cc19ad1e",
    "source_signals": {
      "has_centralized_slot_language": false,
      "has_inline_intake_language": false,
      "icon_card_count": 20,
      "pain_card_count": 8,
      "related_card_count": 16,
      "svg_count": 0,
      "img_count": 0,
      "intake_anchor_count": 0,
      "schema_key": "second_opinion_due_diligence",
      "data_handle": "japan-medical-second-opinion-due-diligence-review"
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "high"
  },
  "japan-stem-cell-regenerative-longevity-access": {
    "title": "Japan Stem Cell Therapy & Longevity Coordination Desk",
    "page_wing": "stem-cell-regenerative-longevity-access",
    "narrative_role": "regenerative/longevity clinic access coordination, claim caution, protocol due diligence, travel/logistics support boundaries",
    "style_mood": "future-health caution, clinic protocol clarity, premium longevity discretion",
    "icon_strategy_summary": "Use clinic protocol, medical due diligence, risk compliance, decision clarity, and discreet shield icons. Avoid miracle/wellness sparkle imagery.",
    "zones": [
      {
        "section_key": "longevity-access-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "clinic-access-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-90px",
        "exact_icon_needs": [
          "regenerative access",
          "clinic protocol",
          "longevity due diligence",
          "claim caution"
        ],
        "clickable": false,
        "notes": "Use sober clinical/protocol marks. No biotech fantasy icons.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0074",
            "label": "Clinic Protocol Review Mono",
            "handle": "js-icon-micro-clinic-protocol-review-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "micro-clinic-protocol-review-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0080",
            "label": "Medical Due Diligence Mono",
            "handle": "js-icon-footer-medical-operational-due-diligence-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "footer-medical-due-diligence-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0072",
            "label": "Risk Compliance Analysis Mono",
            "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
            "primary_category": "risk-compliance",
            "rotation_group": "footer-risk-compliance-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0082",
            "label": "Decision Clarity Mono",
            "handle": "js-icon-micro-decision-clarity-mono-bw-v1",
            "primary_category": "advisory-intelligence",
            "rotation_group": "micro-decision-clarity-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "longevity-access-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "clinic-access-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "regenerative access | clinic protocol | longevity due diligence | claim caution"
        }
      },
      {
        "section_key": "claim-risk-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "risk-signal",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "30-42px",
        "exact_icon_needs": [
          "treatment claim",
          "provider evidence",
          "legal/compliance risk",
          "document readiness"
        ],
        "clickable": false,
        "notes": "Icon logic should signal skepticism and responsible review.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0072",
            "label": "Risk Compliance Analysis Mono",
            "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
            "primary_category": "risk-compliance",
            "rotation_group": "footer-risk-compliance-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0174",
            "label": "Verification Gap 30c Magnifier",
            "handle": "30c-js-case-library-vnext-icon-verification-gap-30c",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30c",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0074",
            "label": "Clinic Protocol Review Mono",
            "handle": "js-icon-micro-clinic-protocol-review-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "micro-clinic-protocol-review-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0188",
            "label": "Scope Boundary Compass",
            "handle": "14-js-faq-vnext-icon-scope-boundary-compass-14",
            "primary_category": "faq-scope",
            "rotation_group": "faq-scope-boundary-compass-14",
            "priority": 60
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "claim-risk-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "risk-signal",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "treatment claim | provider evidence | legal/compliance risk | document readiness"
        }
      },
      {
        "section_key": "coordination-path",
        "hierarchy": "mid-high",
        "visual_owner": "step-title",
        "icon_role": "route-marker",
        "preferred_treatment": "number-plus-icon",
        "preferred_placement": "left-of-step-number",
        "preferred_container": "soft-capsule",
        "size_range": "24-34px",
        "exact_icon_needs": [
          "intake",
          "documents",
          "clinic contact",
          "travel support",
          "representation"
        ],
        "clickable": false,
        "notes": "Keep operational support distinct from medical decision-making.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0114",
            "label": "How It Works Private Intake",
            "handle": "01-js-how-it-works-vnext-icon-private-intake-01",
            "primary_category": "native-intake",
            "rotation_group": "how-it-works-private-intake-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0053",
            "label": "Engagement Preparedness Pencil",
            "handle": "icon-06-japansolved-engagementbrief-engagement-preparedness",
            "primary_category": "engagement-brief",
            "rotation_group": "engagement-preparedness-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0058",
            "label": "Local Representation Institution",
            "handle": "icon-13-japansolved-local-representation",
            "primary_category": "logistics-representation",
            "rotation_group": "local-representation-02",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "coordination-path",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "number-plus-icon",
          "data-jsi-placement": "left-of-step-number",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "intake | documents | clinic contact | travel support | representation"
        }
      },
      {
        "section_key": "related-longevity-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "second opinion",
          "medical tourism",
          "beauty longevity sourcing",
          "discreet care"
        ],
        "clickable": true,
        "notes": "Related icons should keep the health wing coherent.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0080",
            "label": "Medical Due Diligence Mono",
            "handle": "js-icon-footer-medical-operational-due-diligence-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "footer-medical-due-diligence-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0074",
            "label": "Clinic Protocol Review Mono",
            "handle": "js-icon-micro-clinic-protocol-review-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "micro-clinic-protocol-review-01",
            "priority": 61
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-longevity-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "second opinion | medical tourism | beauty longevity sourcing | discreet care"
        }
      }
    ],
    "missing_icon_needs": [
      "cell/protocol ladder icon",
      "longevity clinic access icon",
      "claim-risk molecule icon"
    ],
    "content_id": "japan-stem-cell-regenerative-longevity-access",
    "canonical_handle": "japan-stem-cell-regenerative-longevity-access",
    "canonical_url": "https://japansolved.com/pages/japan-stem-cell-regenerative-longevity-access",
    "source_file": "Japan Stem Cell Therapy & Longevity Coordination Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 61680,
    "source_sha1_12": "b93fab5e5cf9",
    "source_signals": {
      "has_centralized_slot_language": false,
      "has_inline_intake_language": false,
      "icon_card_count": 16,
      "pain_card_count": 18,
      "related_card_count": 19,
      "svg_count": 0,
      "img_count": 0,
      "intake_anchor_count": 1,
      "schema_key": "stem_longevity",
      "data_handle": "japan-stem-cell-regenerative-longevity-access"
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "high"
  },
  "japan-sword-export-compliance": {
    "title": "Japan Sword Compliance & Export Intelligence Desk™",
    "page_wing": "sword-export-compliance",
    "narrative_role": "Japanese sword export legality, registration documentation, cultural-property caution, seller/export claim verification before movement",
    "style_mood": "legal steel, document-first caution, cultural asset discipline",
    "icon_strategy_summary": "Use risk compliance, document verification, institutional authority, shield, and controlled movement icons. Do not use aggressive weapon iconography.",
    "zones": [
      {
        "section_key": "sword-legality-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "compliance-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-90px",
        "exact_icon_needs": [
          "sword legality",
          "registration",
          "export compliance",
          "cultural property"
        ],
        "clickable": false,
        "notes": "Use document/compliance symbols, not blade-as-decoration.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0072",
            "label": "Risk Compliance Analysis Mono",
            "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
            "primary_category": "risk-compliance",
            "rotation_group": "footer-risk-compliance-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0157",
            "label": "Verification Gap Document",
            "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30a",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0094",
            "label": "Institutions Building",
            "handle": "15-js-icon-institutions",
            "primary_category": "institutional-authority",
            "rotation_group": "institutions-15",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0103",
            "label": "Japan Intelligence Globe Shield",
            "handle": "03a-js-icon-japan-intelligence-03a",
            "primary_category": "japan-intelligence",
            "rotation_group": "japan-intelligence-03a",
            "priority": 60
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "sword-legality-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "compliance-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "sword legality | registration | export compliance | cultural property"
        }
      },
      {
        "section_key": "seller-claim-risk-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "risk-signal",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "30-42px",
        "exact_icon_needs": [
          "seller claim",
          "registration paper",
          "export restriction",
          "customs risk"
        ],
        "clickable": false,
        "notes": "This page is documentation before movement.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0157",
            "label": "Verification Gap Document",
            "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30a",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0072",
            "label": "Risk Compliance Analysis Mono",
            "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
            "primary_category": "risk-compliance",
            "rotation_group": "footer-risk-compliance-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0073",
            "label": "Counterparty Mapping Mono",
            "handle": "js-icon-footer-counterparty-mapping-mono-bw-v1",
            "primary_category": "counterparty-mapping",
            "rotation_group": "footer-counterparty-mapping-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0188",
            "label": "Scope Boundary Compass",
            "handle": "14-js-faq-vnext-icon-scope-boundary-compass-14",
            "primary_category": "faq-scope",
            "rotation_group": "faq-scope-boundary-compass-14",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "seller-claim-risk-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "risk-signal",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "seller claim | registration paper | export restriction | customs risk"
        }
      },
      {
        "section_key": "compliance-process",
        "hierarchy": "mid-high",
        "visual_owner": "step-title",
        "icon_role": "process-marker",
        "preferred_treatment": "number-plus-icon",
        "preferred_placement": "left-of-step-number",
        "preferred_container": "soft-capsule",
        "size_range": "24-34px",
        "exact_icon_needs": [
          "identify",
          "review documents",
          "check route",
          "prepare next step"
        ],
        "clickable": false,
        "notes": "Process icons must look administrative and calm.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0095",
            "label": "Assess Checklist",
            "handle": "7-js-icon-assess",
            "primary_category": "case-review",
            "rotation_group": "assess-checklist-07",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0028",
            "label": "Analytical Evaluation Lens",
            "handle": "icon-10-japansolved-process-case-review-analytical-evaluation",
            "primary_category": "case-review",
            "rotation_group": "process-evaluation-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0094",
            "label": "Institutions Building",
            "handle": "15-js-icon-institutions",
            "primary_category": "institutional-authority",
            "rotation_group": "institutions-15",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0129",
            "label": "How It Works Scope Prepared",
            "handle": "09-js-how-it-works-vnext-icon-scope-prepared-09",
            "primary_category": "scope-preparation",
            "rotation_group": "how-it-works-scope-prepared-09",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "compliance-process",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "process-marker",
          "data-jsi-treatment": "number-plus-icon",
          "data-jsi-placement": "left-of-step-number",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "identify | review documents | check route | prepare next step"
        }
      },
      {
        "section_key": "related-compliance-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "arts authentication",
          "cultural assets",
          "private buyer",
          "cargo logistics"
        ],
        "clickable": true,
        "notes": "Related routes bridge cultural asset review and shipping execution.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0100",
            "label": "Collectors Diamond",
            "handle": "13-js-icon-collectors-13",
            "primary_category": "luxury-collectibles",
            "rotation_group": "collectors-diamond-13",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0072",
            "label": "Risk Compliance Analysis Mono",
            "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
            "primary_category": "risk-compliance",
            "rotation_group": "footer-risk-compliance-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0157",
            "label": "Verification Gap Document",
            "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30a",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-compliance-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "arts authentication | cultural assets | private buyer | cargo logistics"
        }
      }
    ],
    "missing_icon_needs": [
      "sword registration paper icon",
      "cultural property seal icon",
      "export permit folder icon"
    ],
    "content_id": "japan-sword-export-compliance",
    "canonical_handle": "japan-sword-export-compliance",
    "canonical_url": "https://japansolved.com/pages/japan-sword-export-compliance",
    "source_file": "Japan Sword Compliance & Export Intelligence Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 122119,
    "source_sha1_12": "b9b3040c3ed3",
    "source_signals": {
      "has_centralized_slot_language": false,
      "has_inline_intake_language": true,
      "icon_card_count": 16,
      "pain_card_count": 23,
      "related_card_count": 30,
      "svg_count": 0,
      "img_count": 9,
      "intake_anchor_count": 1,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "high"
  },
  "japan-ticket-event-entertainment-access": {
    "title": "Japan Ticket, Event & Entertainment Access Desk™",
    "page_wing": "ticket-event-entertainment-access",
    "narrative_role": "ticket/event route review, timed access, venue/platform friction, lawful access boundaries, concierge escalation",
    "style_mood": "event timing, access choreography, calm urgency",
    "icon_strategy_summary": "Use access-gap, time-sensitive, priority, travel access, and language-gap icons. Icons should feel like timed doors, not party decoration.",
    "zones": [
      {
        "section_key": "event-access-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "timed-access-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-90px",
        "exact_icon_needs": [
          "ticket access",
          "event route",
          "timed entry",
          "lawful access"
        ],
        "clickable": false,
        "notes": "A clock/doorway mark best expresses the page.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0165",
            "label": "Access Gap Doorway",
            "handle": "27-js-case-library-vnext-icon-access-gap-27",
            "primary_category": "access-gap",
            "rotation_group": "case-library-access-gap-27",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0064",
            "label": "Priority Access Star",
            "handle": "icon-15-japansolved-priority-access",
            "primary_category": "priority-access",
            "rotation_group": "priority-access-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0024",
            "label": "Curated Access Gateway",
            "handle": "icon-6-japansolved-solutions-travel-cultural-access-curated-gateway",
            "primary_category": "travel-cultural-access",
            "rotation_group": "solution-cultural-access-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "event-access-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "timed-access-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "ticket access | event route | timed entry | lawful access"
        }
      },
      {
        "section_key": "ticket-route-friction",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "32-44px",
        "exact_icon_needs": [
          "platform lock",
          "sold out",
          "ID rule",
          "timing gap",
          "language barrier"
        ],
        "clickable": false,
        "notes": "Use icons as failure-type markers.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0165",
            "label": "Access Gap Doorway",
            "handle": "27-js-case-library-vnext-icon-access-gap-27",
            "primary_category": "access-gap",
            "rotation_group": "case-library-access-gap-27",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0048",
            "label": "Restricted Access Monoline",
            "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
            "primary_category": "privacy-discretion",
            "rotation_group": "monoline-restricted-access-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0173",
            "label": "Language Gap Chat Bubbles",
            "handle": "28-js-case-library-vnext-icon-language-gap-28",
            "primary_category": "language-gap",
            "rotation_group": "case-library-language-gap-28",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0174",
            "label": "Verification Gap 30c Magnifier",
            "handle": "30c-js-case-library-vnext-icon-verification-gap-30c",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30c",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "ticket-route-friction",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "problem-signal",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "platform lock | sold out | ID rule | timing gap | language barrier"
        }
      },
      {
        "section_key": "event-route-flow",
        "hierarchy": "mid-high",
        "visual_owner": "step-title",
        "icon_role": "flow-marker",
        "preferred_treatment": "number-plus-icon",
        "preferred_placement": "left-of-step-number",
        "preferred_container": "soft-capsule",
        "size_range": "24-34px",
        "exact_icon_needs": [
          "request",
          "review",
          "route",
          "execution",
          "handoff"
        ],
        "clickable": false,
        "notes": "Flow icons should not compete with step numbers.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0027",
            "label": "Structured Intake Request",
            "handle": "icon-9-japansolved-process-submit-request-structured-intake",
            "primary_category": "intake-request",
            "rotation_group": "process-intake-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "event-route-flow",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "flow-marker",
          "data-jsi-treatment": "number-plus-icon",
          "data-jsi-placement": "left-of-step-number",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "request | review | route | execution | handoff"
        }
      },
      {
        "section_key": "related-entertainment-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "reservation concierge",
          "VIP navigation",
          "travel hub",
          "local experiences"
        ],
        "clickable": true,
        "notes": "Related icons clarify how event access belongs to the broader travel wing.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0165",
            "label": "Access Gap Doorway",
            "handle": "27-js-case-library-vnext-icon-access-gap-27",
            "primary_category": "access-gap",
            "rotation_group": "case-library-access-gap-27",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0152",
            "label": "Local Execution Cases Compass",
            "handle": "23-js-case-library-vnext-icon-local-execution-cases-23",
            "primary_category": "local-execution",
            "rotation_group": "case-library-local-execution-23",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0137",
            "label": "Airplane Jet 01",
            "handle": "airplane-jet-01",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-entertainment-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "reservation concierge | VIP navigation | travel hub | local experiences"
        }
      }
    ],
    "missing_icon_needs": [
      "ticket stub icon",
      "event calendar icon",
      "timed-entry gate icon"
    ],
    "content_id": "japan-ticket-event-entertainment-access",
    "canonical_handle": "japan-ticket-event-entertainment-access",
    "canonical_url": "https://japansolved.com/pages/japan-ticket-event-entertainment-access",
    "source_file": "Japan Ticket, Event & Entertainment Access Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 93428,
    "source_sha1_12": "4838c0adc47e",
    "source_signals": {
      "has_centralized_slot_language": true,
      "has_inline_intake_language": false,
      "icon_card_count": 31,
      "pain_card_count": 26,
      "related_card_count": 30,
      "svg_count": 0,
      "img_count": 0,
      "intake_anchor_count": 0,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-travel-cultural-experience-access-hub": {
    "title": "Japan Travel & Cultural Experience Access Hub",
    "page_wing": "travel-cultural-experience-access-hub",
    "narrative_role": "parent hub for access, presence, navigation, reservations, companion support, cultural experiences, and bespoke Japan routing",
    "style_mood": "door map, route architecture, cultural access command center",
    "icon_strategy_summary": "This is a choreography page. Use a consistent door/card icon grammar: travel access for parent hub, exact icons for each child desk, tiny route markers for proof/archive drawers.",
    "zones": [
      {
        "section_key": "hub-door-map-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "hub-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "76-96px",
        "exact_icon_needs": [
          "route map",
          "access hub",
          "cultural experience",
          "door architecture"
        ],
        "clickable": false,
        "notes": "The hub deserves one authoritative emblem, not many random icons.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0203",
            "label": "Cultural Access Mono Line",
            "handle": "07-js-solutions-vnext-icon-travel-cultural-access-mono-line-07",
            "primary_category": "cultural-access",
            "rotation_group": "solutions-cultural-access-mono-line-07",
            "priority": 53
          },
          {
            "registry_id": "JSICON-0024",
            "label": "Curated Access Gateway",
            "handle": "icon-6-japansolved-solutions-travel-cultural-access-curated-gateway",
            "primary_category": "travel-cultural-access",
            "rotation_group": "solution-cultural-access-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0165",
            "label": "Access Gap Doorway",
            "handle": "27-js-case-library-vnext-icon-access-gap-27",
            "primary_category": "access-gap",
            "rotation_group": "case-library-access-gap-27",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "hub-door-map-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "hub-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "route map | access hub | cultural experience | door architecture"
        }
      },
      {
        "section_key": "child-desk-route-cards",
        "hierarchy": "high",
        "visual_owner": "card-title",
        "icon_role": "category-marker",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "34-48px",
        "exact_icon_needs": [
          "tickets",
          "reservations",
          "companion",
          "VIP navigation",
          "local access",
          "shopping entourage"
        ],
        "clickable": false,
        "notes": "Child cards must use semantically distinct icons so the grid becomes a map.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0165",
            "label": "Access Gap Doorway",
            "handle": "27-js-case-library-vnext-icon-access-gap-27",
            "primary_category": "access-gap",
            "rotation_group": "case-library-access-gap-27",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0098",
            "label": "Individuals Group",
            "handle": "11-js-icon-individuals-11",
            "primary_category": "client-people",
            "rotation_group": "individuals-group-11",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 60
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "child-desk-route-cards",
          "data-jsi-hierarchy": "high",
          "data-jsi-icon-role": "category-marker",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "tickets | reservations | companion | VIP navigation | local access | shopping entourage"
        }
      },
      {
        "section_key": "pattern-finder-tags",
        "hierarchy": "mid",
        "visual_owner": "pill-label",
        "icon_role": "filter-marker",
        "preferred_treatment": "inline-micro",
        "preferred_placement": "left-inside-pill",
        "preferred_container": "none",
        "size_range": "18-24px",
        "exact_icon_needs": [
          "starting in Japan",
          "managing overseas",
          "accessing privately",
          "clarifying risk"
        ],
        "clickable": false,
        "notes": "Pill icons must stay tiny; no heavy medallions inside filters.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0104",
            "label": "Japan Intelligence Globe Pin",
            "handle": "03b-js-icon-japan-intelligence-03b",
            "primary_category": "japan-intelligence",
            "rotation_group": "japan-intelligence-03b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0137",
            "label": "Airplane Jet 01",
            "handle": "airplane-jet-01",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0071",
            "label": "Key Inside Circle",
            "handle": "japansolved-key-inside-circle",
            "primary_category": "private-access",
            "rotation_group": "private-access-key-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0082",
            "label": "Decision Clarity Mono",
            "handle": "js-icon-micro-decision-clarity-mono-bw-v1",
            "primary_category": "advisory-intelligence",
            "rotation_group": "micro-decision-clarity-01",
            "priority": 59
          },
          {
            "registry_id": "JSICON-0072",
            "label": "Risk Compliance Analysis Mono",
            "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
            "primary_category": "risk-compliance",
            "rotation_group": "footer-risk-compliance-01",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "pattern-finder-tags",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "filter-marker",
          "data-jsi-treatment": "inline-micro",
          "data-jsi-placement": "left-inside-pill",
          "data-jsi-container": "none",
          "data-jsi-needs": "starting in Japan | managing overseas | accessing privately | clarifying risk"
        }
      },
      {
        "section_key": "related-hub-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "bespoke design",
          "local experiences",
          "reservation",
          "VIP navigation"
        ],
        "clickable": true,
        "notes": "Because this is a hub, related icons can double as sitemap signals.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0203",
            "label": "Cultural Access Mono Line",
            "handle": "07-js-solutions-vnext-icon-travel-cultural-access-mono-line-07",
            "primary_category": "cultural-access",
            "rotation_group": "solutions-cultural-access-mono-line-07",
            "priority": 53
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0165",
            "label": "Access Gap Doorway",
            "handle": "27-js-case-library-vnext-icon-access-gap-27",
            "primary_category": "access-gap",
            "rotation_group": "case-library-access-gap-27",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0152",
            "label": "Local Execution Cases Compass",
            "handle": "23-js-case-library-vnext-icon-local-execution-cases-23",
            "primary_category": "local-execution",
            "rotation_group": "case-library-local-execution-23",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-hub-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "bespoke design | local experiences | reservation | VIP navigation"
        }
      }
    ],
    "missing_icon_needs": [
      "site-wide door map icon",
      "experience architecture icon",
      "hub switchboard icon"
    ],
    "content_id": "japan-travel-cultural-experience-access-hub",
    "canonical_handle": "japan-travel-cultural-experience-access-hub",
    "canonical_url": "https://japansolved.com/pages/japan-travel-cultural-experience-access-hub",
    "source_file": "Japan Travel & Cultural Experience Access Hub.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 67148,
    "source_sha1_12": "0dc9e4313346",
    "source_signals": {
      "has_centralized_slot_language": true,
      "has_inline_intake_language": false,
      "icon_card_count": 5,
      "pain_card_count": 9,
      "related_card_count": 26,
      "svg_count": 0,
      "img_count": 0,
      "intake_anchor_count": 0,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "high"
  },
  "japan-travel-suitability-cultural-access-review-desk": {
    "title": "Japan Travel Suitability & Cultural Access Review Desk",
    "page_wing": "travel-suitability-cultural-access-review",
    "narrative_role": "pre-route suitability review for cultural access, travel fit, sensitivity, route risk, and correct desk assignment",
    "style_mood": "compatibility compass, private-fit review, route triage",
    "icon_strategy_summary": "Use assessment, decision clarity, scope, shield, and cultural access icons. This page should feel like fit-check intelligence, not a travel product page.",
    "zones": [
      {
        "section_key": "suitability-review-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "fit-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-90px",
        "exact_icon_needs": [
          "suitability",
          "cultural access fit",
          "review",
          "route assignment"
        ],
        "clickable": false,
        "notes": "A lens/compass hybrid is the right metaphor.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0082",
            "label": "Decision Clarity Mono",
            "handle": "js-icon-micro-decision-clarity-mono-bw-v1",
            "primary_category": "advisory-intelligence",
            "rotation_group": "micro-decision-clarity-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0049",
            "label": "Feasibility Assessment Globe",
            "handle": "icon-11-japansolved-feasibility-assessment",
            "primary_category": "feasibility-assessment",
            "rotation_group": "feasibility-assessment-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0203",
            "label": "Cultural Access Mono Line",
            "handle": "07-js-solutions-vnext-icon-travel-cultural-access-mono-line-07",
            "primary_category": "cultural-access",
            "rotation_group": "solutions-cultural-access-mono-line-07",
            "priority": 50
          },
          {
            "registry_id": "JSICON-0188",
            "label": "Scope Boundary Compass",
            "handle": "14-js-faq-vnext-icon-scope-boundary-compass-14",
            "primary_category": "faq-scope",
            "rotation_group": "faq-scope-boundary-compass-14",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "suitability-review-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "fit-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "suitability | cultural access fit | review | route assignment"
        }
      },
      {
        "section_key": "fit-risk-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "fit-signal",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "30-42px",
        "exact_icon_needs": [
          "sensitivity",
          "timing",
          "privacy",
          "expectation mismatch",
          "route complexity"
        ],
        "clickable": false,
        "notes": "Icons help separate fit risks without making the page feel rejecting.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0188",
            "label": "Scope Boundary Compass",
            "handle": "14-js-faq-vnext-icon-scope-boundary-compass-14",
            "primary_category": "faq-scope",
            "rotation_group": "faq-scope-boundary-compass-14",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0083",
            "label": "Decision Intelligence Mono",
            "handle": "js-icon-footer-decision-ready-intelligence-mono-bw-v1",
            "primary_category": "advisory-intelligence",
            "rotation_group": "footer-decision-intelligence-01",
            "priority": 59
          },
          {
            "registry_id": "JSICON-0155",
            "label": "Execution Gap Compass",
            "handle": "29b-js-case-library-vnext-icon-execution-gap-29b",
            "primary_category": "execution-gap",
            "rotation_group": "case-library-execution-gap-29b",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "fit-risk-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "fit-signal",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "sensitivity | timing | privacy | expectation mismatch | route complexity"
        }
      },
      {
        "section_key": "review-process",
        "hierarchy": "mid-high",
        "visual_owner": "step-title",
        "icon_role": "process-marker",
        "preferred_treatment": "number-plus-icon",
        "preferred_placement": "left-of-step-number",
        "preferred_container": "soft-capsule",
        "size_range": "24-34px",
        "exact_icon_needs": [
          "identify",
          "classify",
          "assess",
          "route",
          "review"
        ],
        "clickable": false,
        "notes": "Keep routing icons calm and helpful.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0027",
            "label": "Structured Intake Request",
            "handle": "icon-9-japansolved-process-submit-request-structured-intake",
            "primary_category": "intake-request",
            "rotation_group": "process-intake-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0095",
            "label": "Assess Checklist",
            "handle": "7-js-icon-assess",
            "primary_category": "case-review",
            "rotation_group": "assess-checklist-07",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0126",
            "label": "How It Works Declined Redirected",
            "handle": "07-js-how-it-works-vnext-icon-declined-redirected-07",
            "primary_category": "routing-referral",
            "rotation_group": "how-it-works-declined-redirected-07",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "review-process",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "process-marker",
          "data-jsi-treatment": "number-plus-icon",
          "data-jsi-placement": "left-of-step-number",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "identify | classify | assess | route | review"
        }
      },
      {
        "section_key": "related-suitability-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "travel hub",
          "private companion",
          "VIP navigation",
          "sensitive matters"
        ],
        "clickable": true,
        "notes": "Related route icons should show where the review may send the client.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0098",
            "label": "Individuals Group",
            "handle": "11-js-icon-individuals-11",
            "primary_category": "client-people",
            "rotation_group": "individuals-group-11",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0163",
            "label": "Sensitive Matters Door",
            "handle": "18-js-case-library-vnext-icon-sensitive-matters-18",
            "primary_category": "sensitive-matters",
            "rotation_group": "case-library-sensitive-matters-18",
            "priority": 59
          },
          {
            "registry_id": "JSICON-0082",
            "label": "Decision Clarity Mono",
            "handle": "js-icon-micro-decision-clarity-mono-bw-v1",
            "primary_category": "advisory-intelligence",
            "rotation_group": "micro-decision-clarity-01",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-suitability-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "travel hub | private companion | VIP navigation | sensitive matters"
        }
      }
    ],
    "missing_icon_needs": [
      "suitability mirror icon",
      "cultural fit compass icon",
      "route triage stamp icon"
    ],
    "content_id": "japan-travel-suitability-cultural-access-review-desk",
    "canonical_handle": "japan-travel-suitability-cultural-access-review-desk",
    "canonical_url": "https://japansolved.com/pages/japan-travel-suitability-cultural-access-review-desk",
    "source_file": "Japan Travel Suitability & Cultural Access Review Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 55876,
    "source_sha1_12": "64eed4bdd203",
    "source_signals": {
      "has_centralized_slot_language": false,
      "has_inline_intake_language": false,
      "icon_card_count": 4,
      "pain_card_count": 12,
      "related_card_count": 21,
      "svg_count": 0,
      "img_count": 0,
      "intake_anchor_count": 0,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-vintage-thrift-flea-market-guided-shopping": {
    "title": "Japan Vintage, Thrift & Flea Market Guided Shopping Desk™",
    "page_wing": "vintage-thrift-flea-market-guided-shopping",
    "narrative_role": "guided vintage/thrift/flea-market discovery, route timing, seller-context navigation, physical shopping support",
    "style_mood": "treasure hunt, street-level discovery, practical local guidance",
    "icon_strategy_summary": "Use sourcing, access, time, local execution, and collector icons. Keep the tone playful but controlled; avoid clutter that makes the page feel like a bazaar poster.",
    "zones": [
      {
        "section_key": "market-discovery-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "hunt-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-90px",
        "exact_icon_needs": [
          "vintage route",
          "flea market",
          "guided discovery",
          "local timing"
        ],
        "clickable": false,
        "notes": "Treasure-hunt icon energy is allowed here, but stay premium.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0154",
            "label": "Sourcing Rare Assets Gem Box",
            "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
            "primary_category": "rare-asset-sourcing",
            "rotation_group": "case-library-sourcing-rare-assets-14",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0152",
            "label": "Local Execution Cases Compass",
            "handle": "23-js-case-library-vnext-icon-local-execution-cases-23",
            "primary_category": "local-execution",
            "rotation_group": "case-library-local-execution-23",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "market-discovery-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "hunt-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "vintage route | flea market | guided discovery | local timing"
        }
      },
      {
        "section_key": "market-friction-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "32-44px",
        "exact_icon_needs": [
          "weather/date change",
          "cash/local practice",
          "condition",
          "language",
          "bulk shipping"
        ],
        "clickable": false,
        "notes": "Icon cards should show real field friction, not cute market nouns.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0173",
            "label": "Language Gap Chat Bubbles",
            "handle": "28-js-case-library-vnext-icon-language-gap-28",
            "primary_category": "language-gap",
            "rotation_group": "case-library-language-gap-28",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0157",
            "label": "Verification Gap Document",
            "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30a",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0155",
            "label": "Execution Gap Compass",
            "handle": "29b-js-case-library-vnext-icon-execution-gap-29b",
            "primary_category": "execution-gap",
            "rotation_group": "case-library-execution-gap-29b",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "market-friction-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "problem-signal",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "weather/date change | cash/local practice | condition | language | bulk shipping"
        }
      },
      {
        "section_key": "guided-shopping-route-cards",
        "hierarchy": "mid-high",
        "visual_owner": "card-title",
        "icon_role": "category-marker",
        "preferred_treatment": "top-left-free",
        "preferred_placement": "top-left-floating",
        "preferred_container": "none",
        "size_range": "34-48px",
        "exact_icon_needs": [
          "vintage",
          "thrift",
          "streetwear",
          "flea-market",
          "subculture"
        ],
        "clickable": false,
        "notes": "Use slightly warmer, more varied icons than luxury pages, but keep weight consistent.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0098",
            "label": "Individuals Group",
            "handle": "11-js-icon-individuals-11",
            "primary_category": "client-people",
            "rotation_group": "individuals-group-11",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0154",
            "label": "Sourcing Rare Assets Gem Box",
            "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
            "primary_category": "rare-asset-sourcing",
            "rotation_group": "case-library-sourcing-rare-assets-14",
            "priority": 58
          },
          {
            "registry_id": "JSICON-0104",
            "label": "Japan Intelligence Globe Pin",
            "handle": "03b-js-icon-japan-intelligence-03b",
            "primary_category": "japan-intelligence",
            "rotation_group": "japan-intelligence-03b",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "guided-shopping-route-cards",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "category-marker",
          "data-jsi-treatment": "top-left-free",
          "data-jsi-placement": "top-left-floating",
          "data-jsi-container": "none",
          "data-jsi-needs": "vintage | thrift | streetwear | flea-market | subculture"
        }
      },
      {
        "section_key": "related-vintage-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "preloved luxury",
          "personal shopping",
          "local experiences",
          "cargo logistics"
        ],
        "clickable": true,
        "notes": "Related icons show escalation from fun hunt to purchase, support, or cargo.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0100",
            "label": "Collectors Diamond",
            "handle": "13-js-icon-collectors-13",
            "primary_category": "luxury-collectibles",
            "rotation_group": "collectors-diamond-13",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0098",
            "label": "Individuals Group",
            "handle": "11-js-icon-individuals-11",
            "primary_category": "client-people",
            "rotation_group": "individuals-group-11",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0203",
            "label": "Cultural Access Mono Line",
            "handle": "07-js-solutions-vnext-icon-travel-cultural-access-mono-line-07",
            "primary_category": "cultural-access",
            "rotation_group": "solutions-cultural-access-mono-line-07",
            "priority": 51
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-vintage-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "preloved luxury | personal shopping | local experiences | cargo logistics"
        }
      }
    ],
    "missing_icon_needs": [
      "market stall icon",
      "hanger/rack icon",
      "treasure find icon"
    ],
    "content_id": "japan-vintage-thrift-flea-market-guided-shopping",
    "canonical_handle": "japan-vintage-thrift-flea-market-guided-shopping",
    "canonical_url": "https://japansolved.com/pages/japan-vintage-thrift-flea-market-guided-shopping",
    "source_file": "Japan Vintage, Thrift & Flea Market Guided Shopping Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 197771,
    "source_sha1_12": "17ff6315edf8",
    "source_signals": {
      "has_centralized_slot_language": false,
      "has_inline_intake_language": true,
      "icon_card_count": 30,
      "pain_card_count": 43,
      "related_card_count": 43,
      "svg_count": 0,
      "img_count": 9,
      "intake_anchor_count": 1,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japan-vip-travel-navigation-cultural-support": {
    "title": "Japan VIP Travel Navigation & Cultural Support Desk™",
    "page_wing": "vip-travel-navigation-cultural-support",
    "narrative_role": "VIP movement, station logic, itinerary flow, cultural cues, low-friction navigation through Japan days",
    "style_mood": "polished movement, private navigation, cultural confidence",
    "icon_strategy_summary": "Use travel movement, cultural access, local execution, priority, and decision icons. The page should feel like a route conductor rather than a tour guide.",
    "zones": [
      {
        "section_key": "vip-navigation-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "movement-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "74-94px",
        "exact_icon_needs": [
          "VIP navigation",
          "station logic",
          "cultural support",
          "movement confidence"
        ],
        "clickable": false,
        "notes": "Use movement/cultural support iconography, not luxury crown alone.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0161",
            "label": "Travel Access Cases 24a Airplane",
            "handle": "24a-js-case-library-vnext-icon-travel-access-cases-24a",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24a",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0137",
            "label": "Airplane Jet 01",
            "handle": "airplane-jet-01",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0203",
            "label": "Cultural Access Mono Line",
            "handle": "07-js-solutions-vnext-icon-travel-cultural-access-mono-line-07",
            "primary_category": "cultural-access",
            "rotation_group": "solutions-cultural-access-mono-line-07",
            "priority": 51
          },
          {
            "registry_id": "JSICON-0064",
            "label": "Priority Access Star",
            "handle": "icon-15-japansolved-priority-access",
            "primary_category": "priority-access",
            "rotation_group": "priority-access-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0152",
            "label": "Local Execution Cases Compass",
            "handle": "23-js-case-library-vnext-icon-local-execution-cases-23",
            "primary_category": "local-execution",
            "rotation_group": "case-library-local-execution-23",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "vip-navigation-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "movement-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "VIP navigation | station logic | cultural support | movement confidence"
        }
      },
      {
        "section_key": "navigation-friction-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "32-44px",
        "exact_icon_needs": [
          "station complexity",
          "timing",
          "etiquette",
          "handoff",
          "language"
        ],
        "clickable": false,
        "notes": "Icons should identify where the day breaks: station, timing, language, etiquette, or handoff.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0155",
            "label": "Execution Gap Compass",
            "handle": "29b-js-case-library-vnext-icon-execution-gap-29b",
            "primary_category": "execution-gap",
            "rotation_group": "case-library-execution-gap-29b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0173",
            "label": "Language Gap Chat Bubbles",
            "handle": "28-js-case-library-vnext-icon-language-gap-28",
            "primary_category": "language-gap",
            "rotation_group": "case-library-language-gap-28",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0104",
            "label": "Japan Intelligence Globe Pin",
            "handle": "03b-js-icon-japan-intelligence-03b",
            "primary_category": "japan-intelligence",
            "rotation_group": "japan-intelligence-03b",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0152",
            "label": "Local Execution Cases Compass",
            "handle": "23-js-case-library-vnext-icon-local-execution-cases-23",
            "primary_category": "local-execution",
            "rotation_group": "case-library-local-execution-23",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "navigation-friction-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "problem-signal",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "station complexity | timing | etiquette | handoff | language"
        }
      },
      {
        "section_key": "vip-product-ladder",
        "hierarchy": "mid-high",
        "visual_owner": "product-card-meta",
        "icon_role": "paid-route-marker",
        "preferred_treatment": "micro-stamp",
        "preferred_placement": "price-pill-left",
        "preferred_container": "soft-capsule",
        "size_range": "28-38px",
        "exact_icon_needs": [
          "review",
          "navigation support",
          "private day",
          "retainer"
        ],
        "clickable": false,
        "notes": "Paid route icons should be crisp and executive.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0064",
            "label": "Priority Access Star",
            "handle": "icon-15-japansolved-priority-access",
            "primary_category": "priority-access",
            "rotation_group": "priority-access-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0042",
            "label": "Access Retainer Priority Key A",
            "handle": "icon-17-a-japansolved-tiers-private-access-retainer-priority",
            "primary_category": "retainer-priority",
            "rotation_group": "retainer-priority-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "vip-product-ladder",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "paid-route-marker",
          "data-jsi-treatment": "micro-stamp",
          "data-jsi-placement": "price-pill-left",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "review | navigation support | private day | retainer"
        }
      },
      {
        "section_key": "related-vip-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "travel companion",
          "reservation concierge",
          "ticket access",
          "celebrity private access"
        ],
        "clickable": true,
        "notes": "Related icons should show how VIP navigation combines with other access desks.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0098",
            "label": "Individuals Group",
            "handle": "11-js-icon-individuals-11",
            "primary_category": "client-people",
            "rotation_group": "individuals-group-11",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0165",
            "label": "Access Gap Doorway",
            "handle": "27-js-case-library-vnext-icon-access-gap-27",
            "primary_category": "access-gap",
            "rotation_group": "case-library-access-gap-27",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0088",
            "label": "Reserved Pathway Crown",
            "handle": "japansolved-reserved-pathway-crown-icon",
            "primary_category": "premium-authority",
            "rotation_group": "reserved-pathway-crown-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0163",
            "label": "Sensitive Matters Door",
            "handle": "18-js-case-library-vnext-icon-sensitive-matters-18",
            "primary_category": "sensitive-matters",
            "rotation_group": "case-library-sensitive-matters-18",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-vip-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "travel companion | reservation concierge | ticket access | celebrity private access"
        }
      }
    ],
    "missing_icon_needs": [
      "station-flow icon",
      "VIP movement corridor icon",
      "cultural etiquette cue icon"
    ],
    "content_id": "japan-vip-travel-navigation-cultural-support",
    "canonical_handle": "japan-vip-travel-navigation-cultural-support",
    "canonical_url": "https://japansolved.com/pages/japan-vip-travel-navigation-cultural-support",
    "source_file": "Japan VIP Travel Navigation & Cultural Support Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 85867,
    "source_sha1_12": "a734d5b0a3ac",
    "source_signals": {
      "has_centralized_slot_language": true,
      "has_inline_intake_language": false,
      "icon_card_count": 18,
      "pain_card_count": 16,
      "related_card_count": 23,
      "svg_count": 0,
      "img_count": 0,
      "intake_anchor_count": 0,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "high"
  },
  "japan-watch-servicing-warranty-proxy": {
    "title": "Japan Watch Servicing & Warranty Proxy Desk™",
    "page_wing": "watch-servicing-warranty-proxy",
    "narrative_role": "watch aftercare, service/warranty proxy, boutique/manufacturer route coordination, documentation and handoff caution",
    "style_mood": "precision aftercare, warranty discipline, quiet horology support",
    "icon_strategy_summary": "Use verification, time, institutions, risk, and logistics icons. A watch icon is missing, so lean into time/document/service-route symbols.",
    "zones": [
      {
        "section_key": "watch-aftercare-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "precision-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-90px",
        "exact_icon_needs": [
          "watch service",
          "warranty route",
          "aftercare",
          "documentation"
        ],
        "clickable": false,
        "notes": "Clock/document icon works until a real watch-dial asset exists.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0157",
            "label": "Verification Gap Document",
            "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30a",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0094",
            "label": "Institutions Building",
            "handle": "15-js-icon-institutions",
            "primary_category": "institutional-authority",
            "rotation_group": "institutions-15",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0072",
            "label": "Risk Compliance Analysis Mono",
            "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
            "primary_category": "risk-compliance",
            "rotation_group": "footer-risk-compliance-01",
            "priority": 59
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "watch-aftercare-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "precision-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "watch service | warranty route | aftercare | documentation"
        }
      },
      {
        "section_key": "warranty-friction-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "30-42px",
        "exact_icon_needs": [
          "warranty eligibility",
          "service quote",
          "documentation gap",
          "boutique handoff",
          "shipping risk"
        ],
        "clickable": false,
        "notes": "Use quote and institution icons where the page talks about service centers/boutiques.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0157",
            "label": "Verification Gap Document",
            "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30a",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0128",
            "label": "How It Works Quotation Estimates",
            "handle": "08-js-how-it-works-vnext-icon-quotation-estimates-08",
            "primary_category": "quotation-estimate",
            "rotation_group": "how-it-works-quotation-estimates-08",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0094",
            "label": "Institutions Building",
            "handle": "15-js-icon-institutions",
            "primary_category": "institutional-authority",
            "rotation_group": "institutions-15",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0072",
            "label": "Risk Compliance Analysis Mono",
            "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
            "primary_category": "risk-compliance",
            "rotation_group": "footer-risk-compliance-01",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "warranty-friction-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "problem-signal",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "warranty eligibility | service quote | documentation gap | boutique handoff | shipping risk"
        }
      },
      {
        "section_key": "service-process-steps",
        "hierarchy": "mid-high",
        "visual_owner": "step-title",
        "icon_role": "process-marker",
        "preferred_treatment": "number-plus-icon",
        "preferred_placement": "left-of-step-number",
        "preferred_container": "soft-capsule",
        "size_range": "24-34px",
        "exact_icon_needs": [
          "review",
          "contact",
          "quote",
          "handoff",
          "return"
        ],
        "clickable": false,
        "notes": "Process icons should feel like precision steps.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0058",
            "label": "Local Representation Institution",
            "handle": "icon-13-japansolved-local-representation",
            "primary_category": "logistics-representation",
            "rotation_group": "local-representation-02",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0128",
            "label": "How It Works Quotation Estimates",
            "handle": "08-js-how-it-works-vnext-icon-quotation-estimates-08",
            "primary_category": "quotation-estimate",
            "rotation_group": "how-it-works-quotation-estimates-08",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0062",
            "label": "Execution Coordination Nodes",
            "handle": "icon-14-japansolved-execution-coordination",
            "primary_category": "execution-support",
            "rotation_group": "execution-coordination-02",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "service-process-steps",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "process-marker",
          "data-jsi-treatment": "number-plus-icon",
          "data-jsi-placement": "left-of-step-number",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "review | contact | quote | handoff | return"
        }
      },
      {
        "section_key": "related-watch-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "Ginza luxury",
          "proxy QA",
          "cargo logistics",
          "private buyer"
        ],
        "clickable": true,
        "notes": "Related icons show service can move into purchase or logistics.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0100",
            "label": "Collectors Diamond",
            "handle": "13-js-icon-collectors-13",
            "primary_category": "luxury-collectibles",
            "rotation_group": "collectors-diamond-13",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0174",
            "label": "Verification Gap 30c Magnifier",
            "handle": "30c-js-case-library-vnext-icon-verification-gap-30c",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30c",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 60
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-watch-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "Ginza luxury | proxy QA | cargo logistics | private buyer"
        }
      }
    ],
    "missing_icon_needs": [
      "watch dial icon",
      "warranty card icon",
      "service bench icon"
    ],
    "content_id": "japan-watch-servicing-warranty-proxy",
    "canonical_handle": "japan-watch-servicing-warranty-proxy",
    "canonical_url": "https://japansolved.com/pages/japan-watch-servicing-warranty-proxy",
    "source_file": "Japan Watch Servicing & Warranty Proxy Desk.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 79829,
    "source_sha1_12": "134ac79abbc2",
    "source_signals": {
      "has_centralized_slot_language": true,
      "has_inline_intake_language": false,
      "icon_card_count": 14,
      "pain_card_count": 29,
      "related_card_count": 20,
      "svg_count": 0,
      "img_count": 9,
      "intake_anchor_count": 0,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "japansolved-concierge-shopping-entourage-support": {
    "page_wing": "concierge-shopping-entourage",
    "narrative_role": "in-person shopping, appointment, interpretation, entourage, route support, and human presence when clients are already moving through Japan",
    "style_mood": "warm private support, polished shopping day, movement assistance, discreet companionable execution",
    "icon_strategy_summary": "Use lighter, human-route icons than pure procurement pages. Concierge icons should feel like doors opening and support hands appearing, not warehouse machinery. Keep fashion/shopping/service icons exact but restrained.",
    "zones": [
      {
        "section_key": "ordinary-concierge-route-fails",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "friction-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-90px",
        "exact_icon_needs": [
          "concierge",
          "shopping",
          "appointment",
          "route friction",
          "human support"
        ],
        "clickable": true,
        "notes": "A single door/key/route icon should introduce why presence matters.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0064",
            "label": "Priority Access Star",
            "handle": "icon-15-japansolved-priority-access",
            "primary_category": "priority-access",
            "rotation_group": "priority-access-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0169",
            "label": "Accessible 24/7 Clock",
            "handle": "36-js-case-library-vnext-icon-accessible-247-36",
            "primary_category": "accessible-247",
            "rotation_group": "case-library-accessible-247-36",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0098",
            "label": "Individuals Group",
            "handle": "11-js-icon-individuals-11",
            "primary_category": "client-people",
            "rotation_group": "individuals-group-11",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0042",
            "label": "Access Retainer Priority Key A",
            "handle": "icon-17-a-japansolved-tiers-private-access-retainer-priority",
            "primary_category": "retainer-priority",
            "rotation_group": "retainer-priority-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "ordinary-concierge-route-fails",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading-copy",
          "data-jsi-role": "friction-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "72-90px",
          "data-jsi-needs": "concierge | shopping | appointment | route friction | human support",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "shopping-entourage-service-cards",
        "hierarchy": "mid-high",
        "visual_owner": "card-title",
        "icon_role": "service-lane-marker",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "34-46px",
        "exact_icon_needs": [
          "shopping",
          "styling",
          "appointment",
          "translation",
          "entourage",
          "handoff"
        ],
        "clickable": true,
        "notes": "Exact icons should match lanes: appointment, shop route, style, handoff, not repeat one bag everywhere.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0058",
            "label": "Local Representation Institution",
            "handle": "icon-13-japansolved-local-representation",
            "primary_category": "logistics-representation",
            "rotation_group": "local-representation-02",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "shopping-entourage-service-cards",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "service-lane-marker",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-size": "34-46px",
          "data-jsi-needs": "shopping | styling | appointment | translation | entourage | handoff",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "presence-and-movement-flow",
        "hierarchy": "mid",
        "visual_owner": "step-title",
        "icon_role": "flow-signal",
        "preferred_treatment": "side-medallion",
        "preferred_placement": "left-rail",
        "preferred_container": "soft-medallion",
        "size_range": "34-44px",
        "exact_icon_needs": [
          "meetup",
          "navigation",
          "interpretation",
          "support",
          "return"
        ],
        "clickable": true,
        "notes": "Use route/clock/person icons sparingly along flow rows.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0042",
            "label": "Access Retainer Priority Key A",
            "handle": "icon-17-a-japansolved-tiers-private-access-retainer-priority",
            "primary_category": "retainer-priority",
            "rotation_group": "retainer-priority-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0064",
            "label": "Priority Access Star",
            "handle": "icon-15-japansolved-priority-access",
            "primary_category": "priority-access",
            "rotation_group": "priority-access-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0114",
            "label": "How It Works Private Intake",
            "handle": "01-js-how-it-works-vnext-icon-private-intake-01",
            "primary_category": "native-intake",
            "rotation_group": "how-it-works-private-intake-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0125",
            "label": "How It Works Activation",
            "handle": "13-js-how-it-works-vnext-icon-activation-13",
            "primary_category": "activation-access",
            "rotation_group": "how-it-works-activation-13",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "presence-and-movement-flow",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "step-title",
          "data-jsi-role": "flow-signal",
          "data-jsi-treatment": "side-medallion",
          "data-jsi-placement": "left-rail",
          "data-jsi-container": "soft-medallion",
          "data-jsi-size": "34-44px",
          "data-jsi-needs": "meetup | navigation | interpretation | support | return",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "payment-ladder",
        "hierarchy": "support",
        "visual_owner": "product-card-meta",
        "icon_role": "paid-route-marker",
        "preferred_treatment": "micro-stamp",
        "preferred_placement": "price-pill-left",
        "preferred_container": "soft-capsule",
        "size_range": "26-36px",
        "exact_icon_needs": [
          "routing review",
          "case deposit",
          "private retainer"
        ],
        "clickable": true,
        "notes": "Make checkout products feel sealed and orderly.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0205",
            "label": "Sensitive Matters Mono Line",
            "handle": "09-js-solutions-vnext-icon-private-discreet-matters-mono-line-09",
            "primary_category": "sensitive-matters",
            "rotation_group": "solutions-sensitive-matters-mono-line-09",
            "priority": 52
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          },
          {
            "registry_id": "JSICON-0048",
            "label": "Restricted Access Monoline",
            "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
            "primary_category": "privacy-discretion",
            "rotation_group": "monoline-restricted-access-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0154",
            "label": "Sourcing Rare Assets Gem Box",
            "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
            "primary_category": "rare-asset-sourcing",
            "rotation_group": "case-library-sourcing-rare-assets-14",
            "priority": 61
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "payment-ladder",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "product-card-meta",
          "data-jsi-role": "paid-route-marker",
          "data-jsi-treatment": "micro-stamp",
          "data-jsi-placement": "price-pill-left",
          "data-jsi-container": "soft-capsule",
          "data-jsi-size": "26-36px",
          "data-jsi-needs": "routing review | case deposit | private retainer",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "route-reading-and-related-desks",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "ecosystem-route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "shopping",
          "personal styling",
          "reservation",
          "VIP navigation",
          "local representation"
        ],
        "clickable": true,
        "notes": "Related card icons should show neighboring doors.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0137",
            "label": "Airplane Jet 01",
            "handle": "airplane-jet-01",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0139",
            "label": "Airplane Jet 07",
            "handle": "airplane-jet-07",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-07",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0145",
            "label": "Airplane Jet 03",
            "handle": "airplane-jet-03",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-03",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "route-reading-and-related-desks",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "ecosystem-route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-size": "24-32px",
          "data-jsi-needs": "shopping | personal styling | reservation | VIP navigation | local representation",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "human presence icon",
      "appointment support icon",
      "shopping companion route icon"
    ],
    "title": "JapanSolved™ Concierge Shopping & Entourage Support",
    "content_id": "japansolved-concierge-shopping-entourage-support",
    "canonical_handle": "japansolved-concierge-shopping-entourage-support",
    "canonical_url": "https://japansolved.com/pages/japansolved-concierge-shopping-entourage-support",
    "source_file": "JapanSolved™ Concierge Shopping & Entourage Support - page body.txt",
    "source_files_seen": [
      "JapanSolved™ Concierge Shopping & Entourage Support - page body.txt"
    ],
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 3",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 83924,
    "source_sha1_12": "20f6db6de126",
    "source_signals": {
      "has_centralized_slot_language": true,
      "has_inline_intake_language": true,
      "icon_card_count": 19,
      "pain_card_count": 27,
      "related_card_count": 49,
      "route_card_count": 0,
      "product_card_count": 3,
      "svg_count": 3,
      "img_count": 3,
      "intake_anchor_count": 3,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not decorate the hero unless a deliberate oversized emblem slot already exists."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems and state-aware drawers should own the interaction. Add icons only to side rails, category tabs, or expandable proof drawers, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake is centralized. Icon pass must not inject page-body icons inside the intake engine, contact transport, validation, review, receipt, or slot marker."
      },
      {
        "section_key": "primary-checkout-buttons",
        "reason": "Buttons should remain typographic. Use icons in adjacent product cards or pricing seals, not inside the main CTA unless a global CTA pattern is approved."
      }
    ],
    "priority_for_rebake": "high"
  },
  "japansolved-logistics-local-representation-hub": {
    "title": "JapanSolved™ Logistics & Local Representation Hub™",
    "page_wing": "logistics-local-representation-hub",
    "narrative_role": "local pickup, vendor contact, handoff, appointment presence, logistics representation and Japan-side execution support",
    "style_mood": "controlled handoff, practical local operations, representation with clean authority",
    "icon_strategy_summary": "Use logistics truck, local institution, execution nodes, delivery check, and verification icons. This hub should feel operational and stable, not freight clutter.",
    "zones": [
      {
        "section_key": "logistics-hub-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "operations-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "74-94px",
        "exact_icon_needs": [
          "local representation",
          "pickup",
          "handoff",
          "Japan-side operations"
        ],
        "clickable": false,
        "notes": "Truck/institution pairing expresses movement plus representation.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0058",
            "label": "Local Representation Institution",
            "handle": "icon-13-japansolved-local-representation",
            "primary_category": "logistics-representation",
            "rotation_group": "local-representation-02",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0062",
            "label": "Execution Coordination Nodes",
            "handle": "icon-14-japansolved-execution-coordination",
            "primary_category": "execution-support",
            "rotation_group": "execution-coordination-02",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "logistics-hub-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-icon-role": "operations-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-needs": "local representation | pickup | handoff | Japan-side operations"
        }
      },
      {
        "section_key": "local-execution-route-cards",
        "hierarchy": "mid-high",
        "visual_owner": "card-title",
        "icon_role": "category-marker",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "34-48px",
        "exact_icon_needs": [
          "pickup",
          "attendance",
          "handoff",
          "vendor coordination",
          "appointment presence"
        ],
        "clickable": false,
        "notes": "Each card should show what action is being represented locally.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0058",
            "label": "Local Representation Institution",
            "handle": "icon-13-japansolved-local-representation",
            "primary_category": "logistics-representation",
            "rotation_group": "local-representation-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0062",
            "label": "Execution Coordination Nodes",
            "handle": "icon-14-japansolved-execution-coordination",
            "primary_category": "execution-support",
            "rotation_group": "execution-coordination-02",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0143",
            "label": "Headphone Support",
            "handle": "headphone",
            "primary_category": "client-support",
            "rotation_group": "client-support-headphone-01",
            "priority": 59
          },
          {
            "registry_id": "JSICON-0157",
            "label": "Verification Gap Document",
            "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30a",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "local-execution-route-cards",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-icon-role": "category-marker",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "pickup | attendance | handoff | vendor coordination | appointment presence"
        }
      },
      {
        "section_key": "logistics-risk-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "problem-signal",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "30-42px",
        "exact_icon_needs": [
          "vendor delay",
          "identity requirement",
          "shipment risk",
          "storage/packing",
          "time window"
        ],
        "clickable": false,
        "notes": "Operational risk icons keep the hub practical and credible.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0073",
            "label": "Counterparty Mapping Mono",
            "handle": "js-icon-footer-counterparty-mapping-mono-bw-v1",
            "primary_category": "counterparty-mapping",
            "rotation_group": "footer-counterparty-mapping-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0048",
            "label": "Restricted Access Monoline",
            "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
            "primary_category": "privacy-discretion",
            "rotation_group": "monoline-restricted-access-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0175",
            "label": "Time Sensitive Clock",
            "handle": "32-js-case-library-vnext-icon-time-sensitive-32",
            "primary_category": "time-sensitive",
            "rotation_group": "case-library-time-sensitive-32",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0072",
            "label": "Risk Compliance Analysis Mono",
            "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
            "primary_category": "risk-compliance",
            "rotation_group": "footer-risk-compliance-01",
            "priority": 58
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "logistics-risk-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-icon-role": "problem-signal",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-needs": "vendor delay | identity requirement | shipment risk | storage/packing | time window"
        }
      },
      {
        "section_key": "related-logistics-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "large cargo",
          "lost item",
          "private buyer",
          "sourcing export"
        ],
        "clickable": true,
        "notes": "Related icons should clarify this hub as the local hands layer.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 60
          },
          {
            "registry_id": "JSICON-0155",
            "label": "Execution Gap Compass",
            "handle": "29b-js-case-library-vnext-icon-execution-gap-29b",
            "primary_category": "execution-gap",
            "rotation_group": "case-library-execution-gap-29b",
            "priority": 59
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-logistics-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-icon-role": "route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-needs": "large cargo | lost item | private buyer | sourcing export"
        }
      }
    ],
    "missing_icon_needs": [
      "handoff desk icon",
      "warehouse pickup icon",
      "vendor call icon"
    ],
    "content_id": "japansolved-logistics-local-representation-hub",
    "canonical_handle": "japansolved-logistics-local-representation-hub",
    "canonical_url": "https://japansolved.com/pages/japansolved-logistics-local-representation-hub",
    "source_file": "JapanSolved Logistics & Local Representation Hub.txt",
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 2",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 73081,
    "source_sha1_12": "f6cb3989f11e",
    "source_signals": {
      "has_centralized_slot_language": true,
      "has_inline_intake_language": false,
      "icon_card_count": 10,
      "pain_card_count": 23,
      "related_card_count": 42,
      "svg_count": 0,
      "img_count": 3,
      "intake_anchor_count": 0,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not sprinkle small decorative icons across the hero unless the page already has a deliberate hero emblem slot."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems, state-aware drawers, and typography should own the interaction. Icons belong in side rails or category tabs, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake has its own registry, validation, and visual hierarchy. Icon pass must not inject page-body icons inside the intake engine or centralized slot."
      },
      {
        "section_key": "final-cta-buttons",
        "reason": "Buttons should stay typographic and clean. Icons may live in a surrounding note/card, not inside the primary checkout button unless a global CTA icon pattern is later approved."
      }
    ],
    "priority_for_rebake": "high"
  },
  "japansolved-sourcing-procurement-export-hub": {
    "page_wing": "sourcing-procurement-export-hub",
    "narrative_role": "parent routing hub for sourcing, procurement, proof, compliance, private buyer execution, cargo, and local representation before the wrong child desk starts work",
    "style_mood": "cathedral routing map, acquisition caution, compliance sequence, procurement intelligence",
    "icon_strategy_summary": "Treat this page as a route control room. Use a strong symbolic anchor for pathway classification, exact operational icons for child routes and category risks, and very small payment stamps for product paths. Avoid over-iconing the already dense hub grid.",
    "zones": [
      {
        "section_key": "pathway-classification-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "route-logic-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "72-92px",
        "exact_icon_needs": [
          "pathway review",
          "classification",
          "sourcing",
          "export",
          "route map"
        ],
        "clickable": true,
        "notes": "One compass/lens/map emblem can make the hub feel intentional without turning cards into stickers.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0134",
            "label": "Horse Knight",
            "handle": "horse",
            "primary_category": "strategy-movement",
            "rotation_group": "strategy-movement-horse-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0104",
            "label": "Japan Intelligence Globe Pin",
            "handle": "03b-js-icon-japan-intelligence-03b",
            "primary_category": "japan-intelligence",
            "rotation_group": "japan-intelligence-03b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0154",
            "label": "Sourcing Rare Assets Gem Box",
            "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
            "primary_category": "rare-asset-sourcing",
            "rotation_group": "case-library-sourcing-rare-assets-14",
            "priority": 61
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "pathway-classification-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading-copy",
          "data-jsi-role": "route-logic-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "72-92px",
          "data-jsi-needs": "pathway review | classification | sourcing | export | route map",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "primary-desk-route-cards",
        "hierarchy": "mid-high",
        "visual_owner": "card-title",
        "icon_role": "child-desk-marker",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "34-44px",
        "exact_icon_needs": [
          "intelligence",
          "sourcing",
          "authentication",
          "proxy QA",
          "private buyer",
          "cargo logistics"
        ],
        "clickable": true,
        "notes": "Each child desk card needs a precise route marker, not a generic star.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0154",
            "label": "Sourcing Rare Assets Gem Box",
            "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
            "primary_category": "rare-asset-sourcing",
            "rotation_group": "case-library-sourcing-rare-assets-14",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0111",
            "label": "How It Works Scope Discipline",
            "handle": "20-js-how-it-works-vnext-icon-scope-discipline-20",
            "primary_category": "scope-discipline",
            "rotation_group": "how-it-works-scope-discipline-20",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "primary-desk-route-cards",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "child-desk-marker",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-size": "34-44px",
          "data-jsi-needs": "intelligence | sourcing | authentication | proxy QA | private buyer | cargo logistics",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "specialized-category-risks",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "category-risk-signal",
        "preferred_treatment": "top-left-free",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "none",
        "size_range": "38-50px",
        "exact_icon_needs": [
          "watch servicing",
          "sword compliance",
          "bonsai quarantine",
          "JDM export",
          "beauty compliance",
          "disaster preparedness"
        ],
        "clickable": true,
        "notes": "Use category icons only where they clarify the risk territory.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0094",
            "label": "Institutions Building",
            "handle": "15-js-icon-institutions",
            "primary_category": "institutional-authority",
            "rotation_group": "institutions-15",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0072",
            "label": "Risk Compliance Analysis Mono",
            "handle": "js-icon-footer-risk-compliance-analysis-mono-bw-v1",
            "primary_category": "risk-compliance",
            "rotation_group": "footer-risk-compliance-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0201",
            "label": "Sourcing Export Mono Line",
            "handle": "05-js-solutions-vnext-icon-sourcing-export-mono-line-05",
            "primary_category": "sourcing-export",
            "rotation_group": "solutions-sourcing-export-mono-line-05",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0134",
            "label": "Horse Knight",
            "handle": "horse",
            "primary_category": "strategy-movement",
            "rotation_group": "strategy-movement-horse-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "specialized-category-risks",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "category-risk-signal",
          "data-jsi-treatment": "top-left-free",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "none",
          "data-jsi-size": "38-50px",
          "data-jsi-needs": "watch servicing | sword compliance | bonsai quarantine | JDM export | beauty compliance | disaster preparedness",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "pathway-review-process",
        "hierarchy": "mid-high",
        "visual_owner": "step-title",
        "icon_role": "sequence-step-marker",
        "preferred_treatment": "side-medallion",
        "preferred_placement": "left-rail",
        "preferred_container": "soft-medallion",
        "size_range": "34-46px",
        "exact_icon_needs": [
          "submit request",
          "classify",
          "map sequence",
          "next step"
        ],
        "clickable": true,
        "notes": "Numbered steps may keep numerals; icon medallions can sit as secondary signals.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0114",
            "label": "How It Works Private Intake",
            "handle": "01-js-how-it-works-vnext-icon-private-intake-01",
            "primary_category": "native-intake",
            "rotation_group": "how-it-works-private-intake-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0125",
            "label": "How It Works Activation",
            "handle": "13-js-how-it-works-vnext-icon-activation-13",
            "primary_category": "activation-access",
            "rotation_group": "how-it-works-activation-13",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0129",
            "label": "How It Works Scope Prepared",
            "handle": "09-js-how-it-works-vnext-icon-scope-prepared-09",
            "primary_category": "scope-preparation",
            "rotation_group": "how-it-works-scope-prepared-09",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0149",
            "label": "Managing from Overseas Globe",
            "handle": "13-js-case-library-vnext-icon-managing-from-overseas-13",
            "primary_category": "overseas-management",
            "rotation_group": "case-library-managing-overseas-13",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0192",
            "label": "Decision Structure Activation",
            "handle": "20-js-faq-vnext-icon-doctrine-review-structure-activation-20",
            "primary_category": "faq-activation",
            "rotation_group": "faq-decision-structure-activation-20",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "pathway-review-process",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-visual-owner": "step-title",
          "data-jsi-role": "sequence-step-marker",
          "data-jsi-treatment": "side-medallion",
          "data-jsi-placement": "left-rail",
          "data-jsi-container": "soft-medallion",
          "data-jsi-size": "34-46px",
          "data-jsi-needs": "submit request | classify | map sequence | next step",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "payment-product-paths",
        "hierarchy": "support",
        "visual_owner": "product-card-meta",
        "icon_role": "paid-route-marker",
        "preferred_treatment": "micro-stamp",
        "preferred_placement": "price-pill-left",
        "preferred_container": "soft-capsule",
        "size_range": "26-36px",
        "exact_icon_needs": [
          "paid review",
          "case deposit",
          "retainer",
          "quote"
        ],
        "clickable": true,
        "notes": "Payment icons should read as seals.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0035",
            "label": "Value Driven Target Precision",
            "handle": "icon-15-japansolved-values-results-driven-target-precision",
            "primary_category": "results-outcomes",
            "rotation_group": "target-precision-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0047",
            "label": "Precision Target Monoline",
            "handle": "japansolved-solutions-icon-advisory-intelligence-precision-target-monoline",
            "primary_category": "results-outcomes",
            "rotation_group": "monoline-precision-target-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0050",
            "label": "Strategic Alignment Target",
            "handle": "icon-12-japansolved-strategic-alignment",
            "primary_category": "strategy-alignment",
            "rotation_group": "strategic-alignment-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0054",
            "label": "Engagement Brief Professional Rigor",
            "handle": "icon-05-japansolved-engagementbrief-professional-rigor",
            "primary_category": "professional-authority",
            "rotation_group": "engagement-professional-rigor-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "payment-product-paths",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "product-card-meta",
          "data-jsi-role": "paid-route-marker",
          "data-jsi-treatment": "micro-stamp",
          "data-jsi-placement": "price-pill-left",
          "data-jsi-container": "soft-capsule",
          "data-jsi-size": "26-36px",
          "data-jsi-needs": "paid review | case deposit | retainer | quote",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "related-pathway-links",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "ecosystem-route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "watch",
          "sword",
          "bonsai",
          "JDM",
          "logistics",
          "local representation"
        ],
        "clickable": true,
        "notes": "Related icons should help the user see escalation paths, not decorate link cards.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0023",
            "label": "Controlled Movement Truck",
            "handle": "icon-5-japansolved-solutions-logistics-representation-controlled-movement",
            "primary_category": "logistics-representation",
            "rotation_group": "solution-logistics-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0058",
            "label": "Local Representation Institution",
            "handle": "icon-13-japansolved-local-representation",
            "primary_category": "logistics-representation",
            "rotation_group": "local-representation-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0062",
            "label": "Execution Coordination Nodes",
            "handle": "icon-14-japansolved-execution-coordination",
            "primary_category": "execution-support",
            "rotation_group": "execution-coordination-02",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-pathway-links",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "ecosystem-route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-size": "24-32px",
          "data-jsi-needs": "watch | sword | bonsai | JDM | logistics | local representation",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "procurement pathway map icon",
      "compliance clearance icon",
      "multi-desk routing hub icon"
    ],
    "title": "JapanSolved™ Sourcing, Procurement & Export Hub™",
    "content_id": "japansolved-sourcing-procurement-export-hub",
    "canonical_handle": "japansolved-sourcing-procurement-export-hub",
    "canonical_url": "https://japansolved.com/pages/japansolved-sourcing-procurement-export-hub",
    "source_file": "JapanSolved™ Sourcing, Procurement & Export Hub.txt",
    "source_files_seen": [
      "JapanSolved Sourcing, Procurement & Export Hub.txt",
      "JapanSolved™ Sourcing, Procurement & Export Hub.txt"
    ],
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 3",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 215641,
    "source_sha1_12": "ee2fafabab8e",
    "source_signals": {
      "has_centralized_slot_language": false,
      "has_inline_intake_language": true,
      "icon_card_count": 20,
      "pain_card_count": 25,
      "related_card_count": 52,
      "route_card_count": 0,
      "product_card_count": 0,
      "svg_count": 3,
      "img_count": 3,
      "intake_anchor_count": 244,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not decorate the hero unless a deliberate oversized emblem slot already exists."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems and state-aware drawers should own the interaction. Add icons only to side rails, category tabs, or expandable proof drawers, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake is centralized. Icon pass must not inject page-body icons inside the intake engine, contact transport, validation, review, receipt, or slot marker."
      },
      {
        "section_key": "primary-checkout-buttons",
        "reason": "Buttons should remain typographic. Use icons in adjacent product cards or pricing seals, not inside the main CTA unless a global CTA pattern is approved."
      }
    ],
    "priority_for_rebake": "high"
  },
  "tokyo-personal-assistant-private-concierge-support": {
    "page_wing": "tokyo-personal-assistant-private-concierge",
    "narrative_role": "small systems rescue, Tokyo-side errands, quiet private assistant support, day concierge, handoffs, and retainer-based invisible coordination",
    "style_mood": "quiet operational control, personal assistant precision, small-system rescue, Tokyo local hands",
    "icon_strategy_summary": "This page needs utility icons with warmth. Use system/clipboard/calendar/handoff markers, but keep them premium and not corporate SaaS-like. The card rhythm is already strong, so icons should be small and exact.",
    "zones": [
      {
        "section_key": "small-systems-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "operations-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "70-88px",
        "exact_icon_needs": [
          "personal assistant",
          "small systems",
          "Tokyo",
          "private concierge",
          "coordination"
        ],
        "clickable": true,
        "notes": "Use a calm operations emblem, not a generic briefcase.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0042",
            "label": "Access Retainer Priority Key A",
            "handle": "icon-17-a-japansolved-tiers-private-access-retainer-priority",
            "primary_category": "retainer-priority",
            "rotation_group": "retainer-priority-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0071",
            "label": "Key Inside Circle",
            "handle": "japansolved-key-inside-circle",
            "primary_category": "private-access",
            "rotation_group": "private-access-key-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0161",
            "label": "Travel Access Cases 24a Airplane",
            "handle": "24a-js-case-library-vnext-icon-travel-access-cases-24a",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24a",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0138",
            "label": "Airplane Jet 08",
            "handle": "airplane-jet-08",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-08",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "small-systems-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading-copy",
          "data-jsi-role": "operations-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "70-88px",
          "data-jsi-needs": "personal assistant | small systems | Tokyo | private concierge | coordination",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "client-lane-cards",
        "hierarchy": "mid-high",
        "visual_owner": "lane-card-title",
        "icon_role": "lane-marker",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "34-44px",
        "exact_icon_needs": [
          "errands",
          "appointments",
          "paperwork",
          "handoff",
          "route logistics",
          "local support"
        ],
        "clickable": true,
        "notes": "Each lane needs a practical noun icon.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0058",
            "label": "Local Representation Institution",
            "handle": "icon-13-japansolved-local-representation",
            "primary_category": "logistics-representation",
            "rotation_group": "local-representation-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0062",
            "label": "Execution Coordination Nodes",
            "handle": "icon-14-japansolved-execution-coordination",
            "primary_category": "execution-support",
            "rotation_group": "execution-coordination-02",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "client-lane-cards",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-visual-owner": "lane-card-title",
          "data-jsi-role": "lane-marker",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-size": "34-44px",
          "data-jsi-needs": "errands | appointments | paperwork | handoff | route logistics | local support",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "flow-list-steps",
        "hierarchy": "mid",
        "visual_owner": "flow-row-title",
        "icon_role": "execution-step-marker",
        "preferred_treatment": "side-medallion",
        "preferred_placement": "left-rail",
        "preferred_container": "soft-medallion",
        "size_range": "32-44px",
        "exact_icon_needs": [
          "review",
          "schedule",
          "coordinate",
          "confirm",
          "handoff"
        ],
        "clickable": true,
        "notes": "Flow rows can use side medallions beside numbers, but avoid clutter.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0095",
            "label": "Assess Checklist",
            "handle": "7-js-icon-assess",
            "primary_category": "case-review",
            "rotation_group": "assess-checklist-07",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0112",
            "label": "How It Works Acceptance Review",
            "handle": "02-js-how-it-works-vnext-icon-case-acceptance-review-02",
            "primary_category": "case-review",
            "rotation_group": "how-it-works-acceptance-review-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0123",
            "label": "How It Works Accepted In Principle",
            "handle": "06-js-how-it-works-vnext-icon-accepted-in-principle-06",
            "primary_category": "acceptance-status",
            "rotation_group": "how-it-works-accepted-in-principle-06",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0130",
            "label": "How It Works Mutual Confirmation",
            "handle": "10-js-how-it-works-vnext-icon-mutual-confirmation-10",
            "primary_category": "confirmation-alignment",
            "rotation_group": "how-it-works-mutual-confirmation-10",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0134",
            "label": "Horse Knight",
            "handle": "horse",
            "primary_category": "strategy-movement",
            "rotation_group": "strategy-movement-horse-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "flow-list-steps",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "flow-row-title",
          "data-jsi-role": "execution-step-marker",
          "data-jsi-treatment": "side-medallion",
          "data-jsi-placement": "left-rail",
          "data-jsi-container": "soft-medallion",
          "data-jsi-size": "32-44px",
          "data-jsi-needs": "review | schedule | coordinate | confirm | handoff",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "product-prewire-cards",
        "hierarchy": "support",
        "visual_owner": "product-card-meta",
        "icon_role": "paid-route-marker",
        "preferred_treatment": "micro-stamp",
        "preferred_placement": "price-pill-left",
        "preferred_container": "soft-capsule",
        "size_range": "26-36px",
        "exact_icon_needs": [
          "review",
          "case deposit",
          "day concierge",
          "retainer"
        ],
        "clickable": true,
        "notes": "Use payment seals for the prewired products.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0181",
            "label": "Process Three Gates",
            "handle": "10-js-faq-vnext-icon-process-three-gates-10",
            "primary_category": "faq-process",
            "rotation_group": "faq-process-three-gates-10",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0042",
            "label": "Access Retainer Priority Key A",
            "handle": "icon-17-a-japansolved-tiers-private-access-retainer-priority",
            "primary_category": "retainer-priority",
            "rotation_group": "retainer-priority-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0125",
            "label": "How It Works Activation",
            "handle": "13-js-how-it-works-vnext-icon-activation-13",
            "primary_category": "activation-access",
            "rotation_group": "how-it-works-activation-13",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0169",
            "label": "Accessible 24/7 Clock",
            "handle": "36-js-case-library-vnext-icon-accessible-247-36",
            "primary_category": "accessible-247",
            "rotation_group": "case-library-accessible-247-36",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0043",
            "label": "Access Retainer Priority Key B",
            "handle": "icon-17-b-japansolved-tiers-private-access-retainer-priority",
            "primary_category": "retainer-priority",
            "rotation_group": "retainer-priority-02",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "product-prewire-cards",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "product-card-meta",
          "data-jsi-role": "paid-route-marker",
          "data-jsi-treatment": "micro-stamp",
          "data-jsi-placement": "price-pill-left",
          "data-jsi-container": "soft-capsule",
          "data-jsi-size": "26-36px",
          "data-jsi-needs": "review | case deposit | day concierge | retainer",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "boundary-and-related-desk-cards",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "boundary-route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "scope boundary",
          "privacy",
          "local representation",
          "VIP navigation",
          "concierge shopping"
        ],
        "clickable": true,
        "notes": "Use shield/route markers to clarify private scope and neighboring pathways.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0137",
            "label": "Airplane Jet 01",
            "handle": "airplane-jet-01",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0139",
            "label": "Airplane Jet 07",
            "handle": "airplane-jet-07",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-07",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0145",
            "label": "Airplane Jet 03",
            "handle": "airplane-jet-03",
            "primary_category": "travel-movement",
            "rotation_group": "travel-airplane-jet-03",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "boundary-and-related-desk-cards",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "boundary-route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-size": "24-32px",
          "data-jsi-needs": "scope boundary | privacy | local representation | VIP navigation | concierge shopping",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "invisible hand icon",
      "small systems rescue icon",
      "Tokyo local assistant icon"
    ],
    "title": "Tokyo Personal Assistant & Private Concierge Support Desk™",
    "content_id": "tokyo-personal-assistant-private-concierge-support",
    "canonical_handle": "tokyo-personal-assistant-private-concierge-support",
    "canonical_url": "https://japansolved.com/pages/tokyo-personal-assistant-private-concierge-support",
    "source_file": "Tokyo Personal Assistant & Private Concierge Support.txt",
    "source_files_seen": [
      "Tokyo Personal Assistant & Private Concierge Support.txt"
    ],
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 3",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 80355,
    "source_sha1_12": "75658338438e",
    "source_signals": {
      "has_centralized_slot_language": true,
      "has_inline_intake_language": true,
      "icon_card_count": 23,
      "pain_card_count": 15,
      "related_card_count": 20,
      "route_card_count": 0,
      "product_card_count": 14,
      "svg_count": 0,
      "img_count": 0,
      "intake_anchor_count": 3,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not decorate the hero unless a deliberate oversized emblem slot already exists."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems and state-aware drawers should own the interaction. Add icons only to side rails, category tabs, or expandable proof drawers, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake is centralized. Icon pass must not inject page-body icons inside the intake engine, contact transport, validation, review, receipt, or slot marker."
      },
      {
        "section_key": "primary-checkout-buttons",
        "reason": "Buttons should remain typographic. Use icons in adjacent product cards or pricing seals, not inside the main CTA unless a global CTA pattern is approved."
      }
    ],
    "priority_for_rebake": "high"
  },
  "japan-medical-tourism-clinic-access-review": {
    "page_wing": "medical-clinic-access-review",
    "narrative_role": "medical tourism and clinic access coordination review for appointment readiness, clinic route, document preparation, interpretation/logistics, and non-medical support boundaries",
    "style_mood": "calm clinical due diligence, privacy, document readiness, route review, non-diagnostic support",
    "icon_strategy_summary": "Use medical-adjacent icons without hospital clichés. Favor document, shield, checklist, translation, appointment, and route-readiness symbols. Avoid red-cross style or anything that implies medical advice or guaranteed treatment.",
    "zones": [
      {
        "section_key": "clinic-access-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "clinical-route-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "70-88px",
        "exact_icon_needs": [
          "medical clinic",
          "access review",
          "due diligence",
          "document readiness"
        ],
        "clickable": true,
        "notes": "A lens/document/shield emblem is safer than a cross or stethoscope.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0074",
            "label": "Clinic Protocol Review Mono",
            "handle": "js-icon-micro-clinic-protocol-review-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "micro-clinic-protocol-review-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0080",
            "label": "Medical Due Diligence Mono",
            "handle": "js-icon-footer-medical-operational-due-diligence-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "footer-medical-due-diligence-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0097",
            "label": "Analyze Document Lens",
            "handle": "06-js-icon-analyze-06",
            "primary_category": "advisory-intelligence",
            "rotation_group": "analyze-document-06",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0117",
            "label": "How It Works Experienced Judgment",
            "handle": "23-js-how-it-works-vnext-icon-experienced-judgment-23",
            "primary_category": "advisory-intelligence",
            "rotation_group": "how-it-works-experienced-judgment-23",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0157",
            "label": "Verification Gap Document",
            "handle": "30a-js-case-library-vnext-icon-verification-gap-30a",
            "primary_category": "verification-gap",
            "rotation_group": "case-library-verification-gap-30a",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "clinic-access-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading-copy",
          "data-jsi-role": "clinical-route-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "70-88px",
          "data-jsi-needs": "medical clinic | access review | due diligence | document readiness",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "clinic-readiness-signal-grid",
        "hierarchy": "mid-high",
        "visual_owner": "card-title",
        "icon_role": "risk-signal",
        "preferred_treatment": "top-left-capsule",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "soft-capsule",
        "size_range": "34-46px",
        "exact_icon_needs": [
          "appointment",
          "medical records",
          "translation",
          "privacy",
          "second opinion",
          "clinic route"
        ],
        "clickable": true,
        "notes": "Exact signals should separate medical content from logistics support.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0080",
            "label": "Medical Due Diligence Mono",
            "handle": "js-icon-footer-medical-operational-due-diligence-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "footer-medical-due-diligence-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0074",
            "label": "Clinic Protocol Review Mono",
            "handle": "js-icon-micro-clinic-protocol-review-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "micro-clinic-protocol-review-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0169",
            "label": "Accessible 24/7 Clock",
            "handle": "36-js-case-library-vnext-icon-accessible-247-36",
            "primary_category": "accessible-247",
            "rotation_group": "case-library-accessible-247-36",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0153",
            "label": "Visiting Japan Privately Keyhole",
            "handle": "16-js-case-library-vnext-icon-accessing-japan-privately-16",
            "primary_category": "private-japan-access",
            "rotation_group": "case-library-private-japan-16",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0160",
            "label": "Privacy Gap Lock Frame",
            "handle": "31-js-case-library-vnext-icon-privacy-gap-31",
            "primary_category": "privacy-gap",
            "rotation_group": "case-library-privacy-gap-31",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "clinic-readiness-signal-grid",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "risk-signal",
          "data-jsi-treatment": "top-left-capsule",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "soft-capsule",
          "data-jsi-size": "34-46px",
          "data-jsi-needs": "appointment | medical records | translation | privacy | second opinion | clinic route",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "document-and-support-flow",
        "hierarchy": "mid",
        "visual_owner": "flow-row-title",
        "icon_role": "process-marker",
        "preferred_treatment": "side-medallion",
        "preferred_placement": "left-rail",
        "preferred_container": "soft-medallion",
        "size_range": "32-44px",
        "exact_icon_needs": [
          "records",
          "intake",
          "provider check",
          "schedule",
          "support plan"
        ],
        "clickable": true,
        "notes": "Flow icons should reinforce readiness and boundary-safe coordination.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0050",
            "label": "Strategic Alignment Target",
            "handle": "icon-12-japansolved-strategic-alignment",
            "primary_category": "strategy-alignment",
            "rotation_group": "strategic-alignment-02",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0106",
            "label": "Integrity Check Circle",
            "handle": "05-js-icon-integrity-05",
            "primary_category": "trust-verification",
            "rotation_group": "integrity-check-05",
            "priority": 64
          },
          {
            "registry_id": "JSICON-0035",
            "label": "Value Driven Target Precision",
            "handle": "icon-15-japansolved-values-results-driven-target-precision",
            "primary_category": "results-outcomes",
            "rotation_group": "target-precision-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0047",
            "label": "Precision Target Monoline",
            "handle": "japansolved-solutions-icon-advisory-intelligence-precision-target-monoline",
            "primary_category": "results-outcomes",
            "rotation_group": "monoline-precision-target-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0186",
            "label": "General Scroll Question",
            "handle": "09-js-faq-vnext-icon-general-scroll-question-09",
            "primary_category": "faq-general",
            "rotation_group": "faq-general-scroll-question-09",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "document-and-support-flow",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "flow-row-title",
          "data-jsi-role": "process-marker",
          "data-jsi-treatment": "side-medallion",
          "data-jsi-placement": "left-rail",
          "data-jsi-container": "soft-medallion",
          "data-jsi-size": "32-44px",
          "data-jsi-needs": "records | intake | provider check | schedule | support plan",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "payment-review-products",
        "hierarchy": "support",
        "visual_owner": "product-card-meta",
        "icon_role": "paid-review-marker",
        "preferred_treatment": "micro-stamp",
        "preferred_placement": "price-pill-left",
        "preferred_container": "soft-capsule",
        "size_range": "26-36px",
        "exact_icon_needs": [
          "case review",
          "clinic coordination",
          "due diligence"
        ],
        "clickable": true,
        "notes": "Payment icons stay small and formal.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0074",
            "label": "Clinic Protocol Review Mono",
            "handle": "js-icon-micro-clinic-protocol-review-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "micro-clinic-protocol-review-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0080",
            "label": "Medical Due Diligence Mono",
            "handle": "js-icon-footer-medical-operational-due-diligence-mono-bw-v1",
            "primary_category": "medical-due-diligence",
            "rotation_group": "footer-medical-due-diligence-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0155",
            "label": "Execution Gap Compass",
            "handle": "29b-js-case-library-vnext-icon-execution-gap-29b",
            "primary_category": "execution-gap",
            "rotation_group": "case-library-execution-gap-29b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0076",
            "label": "Nodes Network Molecule",
            "handle": "japansolved-nodes-network-molecule",
            "primary_category": "strategy-alignment",
            "rotation_group": "network-molecule-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0118",
            "label": "How It Works Structured Clarity",
            "handle": "21-js-how-it-works-vnext-icon-structured-clarity-21",
            "primary_category": "strategy-alignment",
            "rotation_group": "how-it-works-structured-clarity-21",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "payment-review-products",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "product-card-meta",
          "data-jsi-role": "paid-review-marker",
          "data-jsi-treatment": "micro-stamp",
          "data-jsi-placement": "price-pill-left",
          "data-jsi-container": "soft-capsule",
          "data-jsi-size": "26-36px",
          "data-jsi-needs": "case review | clinic coordination | due diligence",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "related-health-wing-routes",
        "hierarchy": "support",
        "visual_owner": "card-title",
        "icon_role": "related-route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "stem cell",
          "second opinion",
          "medical entourage",
          "discreet care",
          "sabbatical recovery"
        ],
        "clickable": true,
        "notes": "Related route icons should distinguish healthcare-adjacent branches.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0115",
            "label": "How It Works Ongoing Stewardship",
            "handle": "15-js-how-it-works-vnext-icon-ongoing-stewardship-15",
            "primary_category": "stewardship-support",
            "rotation_group": "how-it-works-ongoing-stewardship-15",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0026",
            "label": "CurrentColor Protection Shield",
            "handle": "icon-8-japansolved-solutions-discreet-sensitive-confidential-protection-currentcolor",
            "primary_category": "privacy-discretion",
            "rotation_group": "solution-protection-01",
            "priority": 67
          },
          {
            "registry_id": "JSICON-0040",
            "label": "Comprehensive Solutions Star",
            "handle": "icon-16-e-japansolved-tiers-standard-engagement-comprehensive-solutions",
            "primary_category": "comprehensive-solutions",
            "rotation_group": "comprehensive-solutions-05",
            "priority": 65
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "related-health-wing-routes",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "related-route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-size": "24-32px",
          "data-jsi-needs": "stem cell | second opinion | medical entourage | discreet care | sabbatical recovery",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "clinic route icon",
      "medical document readiness icon",
      "non-medical support boundary icon"
    ],
    "title": "x Japan Medical Tourism & Clinic Coordination Desk",
    "content_id": "japan-medical-tourism-clinic-access-review",
    "canonical_handle": "japan-medical-tourism-clinic-access-review",
    "canonical_url": "https://japansolved.com/pages/japan-medical-tourism-clinic-access-review",
    "source_file": "x Japan Medical Tourism & Clinic Coordination Desk.txt",
    "source_files_seen": [
      "x Japan Medical Tourism & Clinic Coordination Desk.txt"
    ],
    "content_type": "landing_page",
    "status": "pre-swept",
    "batch": "Batch 3",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 43966,
    "source_sha1_12": "adfe45a26fcf",
    "source_signals": {
      "has_centralized_slot_language": true,
      "has_inline_intake_language": false,
      "icon_card_count": 20,
      "pain_card_count": 8,
      "related_card_count": 17,
      "route_card_count": 10,
      "product_card_count": 8,
      "svg_count": 0,
      "img_count": 0,
      "intake_anchor_count": 2,
      "schema_key": "medical_clinic",
      "data_handle": "japan-medical-tourism-clinic-access-review"
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not decorate the hero unless a deliberate oversized emblem slot already exists."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems and state-aware drawers should own the interaction. Add icons only to side rails, category tabs, or expandable proof drawers, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake is centralized. Icon pass must not inject page-body icons inside the intake engine, contact transport, validation, review, receipt, or slot marker."
      },
      {
        "section_key": "primary-checkout-buttons",
        "reason": "Buttons should remain typographic. Use icons in adjacent product cards or pricing seals, not inside the main CTA unless a global CTA pattern is approved."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "yamato-companion-background": {
    "page_wing": "yamato-hidden-background",
    "narrative_role": "quiet advisory background page for Yamato private companion suitability, presence logic, boundaries, and private request routing",
    "style_mood": "warm private presence, restrained confidence, hidden support page, human readability, low-profile trust",
    "icon_strategy_summary": "Icons must whisper here. Use very few warm presence markers: shield, profile, route, scene-reading, and schedule. Never decorate the portrait/profile layer or make the hidden page feel promotional.",
    "zones": [
      {
        "section_key": "yamato-background-thesis",
        "hierarchy": "senpai",
        "visual_owner": "heading-copy",
        "icon_role": "presence-anchor",
        "preferred_treatment": "free-emblem",
        "preferred_placement": "left-anchor-large",
        "preferred_container": "none",
        "size_range": "66-82px",
        "exact_icon_needs": [
          "private companion",
          "presence",
          "discretion",
          "background",
          "trust"
        ],
        "clickable": true,
        "notes": "One quiet emblem is enough. Avoid over-symbolizing a human page.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0071",
            "label": "Key Inside Circle",
            "handle": "japansolved-key-inside-circle",
            "primary_category": "private-access",
            "rotation_group": "private-access-key-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0153",
            "label": "Visiting Japan Privately Keyhole",
            "handle": "16-js-case-library-vnext-icon-accessing-japan-privately-16",
            "primary_category": "private-japan-access",
            "rotation_group": "case-library-private-japan-16",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0048",
            "label": "Restricted Access Monoline",
            "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
            "primary_category": "privacy-discretion",
            "rotation_group": "monoline-restricted-access-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0171",
            "label": "Secret Professional 33 Tie Shield",
            "handle": "33-js-case-library-vnext-icon-discreet-professional-33",
            "primary_category": "secret-professional",
            "rotation_group": "case-library-secret-professional-33",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "yamato-background-thesis",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "heading-copy",
          "data-jsi-role": "presence-anchor",
          "data-jsi-treatment": "free-emblem",
          "data-jsi-placement": "left-anchor-large",
          "data-jsi-container": "none",
          "data-jsi-size": "66-82px",
          "data-jsi-needs": "private companion | presence | discretion | background | trust",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "advisory-profile-panels",
        "hierarchy": "mid-high",
        "visual_owner": "card-title",
        "icon_role": "profile-context-marker",
        "preferred_treatment": "top-left-free",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "none",
        "size_range": "30-40px",
        "exact_icon_needs": [
          "profile",
          "background",
          "scene reading",
          "privacy",
          "suitability"
        ],
        "clickable": true,
        "notes": "Small profile/context icons should not compete with portrait or copy.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0119",
            "label": "How It Works Layered Intelligence",
            "handle": "24-js-how-it-works-vnext-icon-human-layered-intelligence-24",
            "primary_category": "advisory-intelligence",
            "rotation_group": "how-it-works-layered-intelligence-24",
            "priority": 61
          },
          {
            "registry_id": "JSICON-0028",
            "label": "Analytical Evaluation Lens",
            "handle": "icon-10-japansolved-process-case-review-analytical-evaluation",
            "primary_category": "case-review",
            "rotation_group": "process-evaluation-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0048",
            "label": "Restricted Access Monoline",
            "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
            "primary_category": "privacy-discretion",
            "rotation_group": "monoline-restricted-access-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0055",
            "label": "Engagement Brief Shield Verification",
            "handle": "icon-01-japansolved-engagementbrief-shield-verification",
            "primary_category": "privacy-discretion",
            "rotation_group": "engagement-shield-verification-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0057",
            "label": "Engagement Brief Restricted Advisory",
            "handle": "icon-03-japansolved-engagementbrief-restricted-advisory",
            "primary_category": "advisory-intelligence",
            "rotation_group": "engagement-restricted-advisory-01",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "advisory-profile-panels",
          "data-jsi-hierarchy": "mid-high",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "profile-context-marker",
          "data-jsi-treatment": "top-left-free",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "none",
          "data-jsi-size": "30-40px",
          "data-jsi-needs": "profile | background | scene reading | privacy | suitability",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "private-rules-tags",
        "hierarchy": "support",
        "visual_owner": "tag-label",
        "icon_role": "micro-boundary-marker",
        "preferred_treatment": "micro-dot",
        "preferred_placement": "before-label",
        "preferred_container": "none",
        "size_range": "16-22px",
        "exact_icon_needs": [
          "privacy",
          "boundary",
          "lawful",
          "suitability"
        ],
        "clickable": true,
        "notes": "Tiny dots or shields only.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0048",
            "label": "Restricted Access Monoline",
            "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
            "primary_category": "privacy-discretion",
            "rotation_group": "monoline-restricted-access-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0055",
            "label": "Engagement Brief Shield Verification",
            "handle": "icon-01-japansolved-engagementbrief-shield-verification",
            "primary_category": "privacy-discretion",
            "rotation_group": "engagement-shield-verification-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0057",
            "label": "Engagement Brief Restricted Advisory",
            "handle": "icon-03-japansolved-engagementbrief-restricted-advisory",
            "primary_category": "advisory-intelligence",
            "rotation_group": "engagement-restricted-advisory-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0170",
            "label": "Secret Matter Cases 26b Discreet Eye",
            "handle": "26b-js-case-library-vnext-icon-discreet-matter-cases-26b",
            "primary_category": "secret-matter-cases",
            "rotation_group": "case-library-secret-matter-26b",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0026",
            "label": "CurrentColor Protection Shield",
            "handle": "icon-8-japansolved-solutions-discreet-sensitive-confidential-protection-currentcolor",
            "primary_category": "privacy-discretion",
            "rotation_group": "solution-protection-01",
            "priority": 67
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "private-rules-tags",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "tag-label",
          "data-jsi-role": "micro-boundary-marker",
          "data-jsi-treatment": "micro-dot",
          "data-jsi-placement": "before-label",
          "data-jsi-container": "none",
          "data-jsi-size": "16-22px",
          "data-jsi-needs": "privacy | boundary | lawful | suitability",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "route-to-review-and-companion-desk",
        "hierarchy": "support",
        "visual_owner": "route-card-title",
        "icon_role": "private-route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "Yamato review",
          "private companion",
          "travel reset",
          "discreet support"
        ],
        "clickable": true,
        "notes": "Route cards can use discreet door/route icons.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0048",
            "label": "Restricted Access Monoline",
            "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
            "primary_category": "privacy-discretion",
            "rotation_group": "monoline-restricted-access-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0205",
            "label": "Sensitive Matters Mono Line",
            "handle": "09-js-solutions-vnext-icon-private-discreet-matters-mono-line-09",
            "primary_category": "sensitive-matters",
            "rotation_group": "solutions-sensitive-matters-mono-line-09",
            "priority": 52
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          },
          {
            "registry_id": "JSICON-0163",
            "label": "Sensitive Matters Door",
            "handle": "18-js-case-library-vnext-icon-sensitive-matters-18",
            "primary_category": "sensitive-matters",
            "rotation_group": "case-library-sensitive-matters-18",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0042",
            "label": "Access Retainer Priority Key A",
            "handle": "icon-17-a-japansolved-tiers-private-access-retainer-priority",
            "primary_category": "retainer-priority",
            "rotation_group": "retainer-priority-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "route-to-review-and-companion-desk",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "route-card-title",
          "data-jsi-role": "private-route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-size": "24-32px",
          "data-jsi-needs": "Yamato review | private companion | travel reset | discreet support",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "human warmth icon",
      "scene-reading icon",
      "low-profile companion route icon"
    ],
    "title": "Yamato Companion Advisory Background",
    "content_id": "yamato-companion-background",
    "canonical_handle": "yamato-companion-background",
    "canonical_url": "https://japansolved.com/pages/yamato-companion-background",
    "source_file": "Yamato Companion Advisory Background.txt",
    "source_files_seen": [
      "Yamato Companion Advisory Background.txt"
    ],
    "content_type": "landing_page_hidden",
    "status": "pre-swept",
    "batch": "Batch 3",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 57350,
    "source_sha1_12": "397bfcb8b194",
    "source_signals": {
      "has_centralized_slot_language": true,
      "has_inline_intake_language": true,
      "icon_card_count": 8,
      "pain_card_count": 8,
      "related_card_count": 7,
      "route_card_count": 10,
      "product_card_count": 3,
      "svg_count": 0,
      "img_count": 0,
      "intake_anchor_count": 1,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not decorate the hero unless a deliberate oversized emblem slot already exists."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems and state-aware drawers should own the interaction. Add icons only to side rails, category tabs, or expandable proof drawers, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake is centralized. Icon pass must not inject page-body icons inside the intake engine, contact transport, validation, review, receipt, or slot marker."
      },
      {
        "section_key": "primary-checkout-buttons",
        "reason": "Buttons should remain typographic. Use icons in adjacent product cards or pricing seals, not inside the main CTA unless a global CTA pattern is approved."
      }
    ],
    "priority_for_rebake": "normal"
  },
  "yamato-companion-profile": {
    "page_wing": "yamato-hidden-profile",
    "narrative_role": "quiet client-facing profile page for Yamato private companion presence, portrait context, suitability, private program route, and background handoff",
    "style_mood": "portrait-first, low-profile, human presence, gentle route confidence, hidden support-page elegance",
    "icon_strategy_summary": "The portrait is the icon. All other symbols must step back. Use only micro markers for tags, private rules, and route cards. Do not add icons over or near the portrait panel unless a single very quiet profile seal is needed.",
    "zones": [
      {
        "section_key": "portrait-profile-panel",
        "hierarchy": "senpai",
        "visual_owner": "portrait-copy",
        "icon_role": "portrait-context-anchor",
        "preferred_treatment": "micro-seal",
        "preferred_placement": "copy-kicker-left",
        "preferred_container": "soft-capsule",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "profile",
          "presence",
          "private companion",
          "Yamato"
        ],
        "clickable": true,
        "notes": "The portrait remains dominant. Micro seal only if copy feels naked.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0071",
            "label": "Key Inside Circle",
            "handle": "japansolved-key-inside-circle",
            "primary_category": "private-access",
            "rotation_group": "private-access-key-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0153",
            "label": "Visiting Japan Privately Keyhole",
            "handle": "16-js-case-library-vnext-icon-accessing-japan-privately-16",
            "primary_category": "private-japan-access",
            "rotation_group": "case-library-private-japan-16",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0158",
            "label": "Travel Access Cases 24b",
            "handle": "24b-js-case-library-vnext-icon-travel-access-cases-24b",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24b",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0161",
            "label": "Travel Access Cases 24a Airplane",
            "handle": "24a-js-case-library-vnext-icon-travel-access-cases-24a",
            "primary_category": "travel-access-cases",
            "rotation_group": "case-library-travel-access-24a",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "portrait-profile-panel",
          "data-jsi-hierarchy": "senpai",
          "data-jsi-visual-owner": "portrait-copy",
          "data-jsi-role": "portrait-context-anchor",
          "data-jsi-treatment": "micro-seal",
          "data-jsi-placement": "copy-kicker-left",
          "data-jsi-container": "soft-capsule",
          "data-jsi-size": "24-32px",
          "data-jsi-needs": "profile | presence | private companion | Yamato",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "presence-corridor-cards",
        "hierarchy": "mid",
        "visual_owner": "card-title",
        "icon_role": "presence-quality-marker",
        "preferred_treatment": "top-left-free",
        "preferred_placement": "top-left-inside-card",
        "preferred_container": "none",
        "size_range": "30-40px",
        "exact_icon_needs": [
          "local context",
          "human warmth",
          "scene reading",
          "quiet support"
        ],
        "clickable": true,
        "notes": "Use gentle markers that do not turn the profile into a service menu.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0091",
            "label": "Execute Arrow",
            "handle": "10-js-icon-execute",
            "primary_category": "execution-support",
            "rotation_group": "execute-arrow-10",
            "priority": 65
          },
          {
            "registry_id": "JSICON-0021",
            "label": "Relocation Transition Move",
            "handle": "icon-3-japansolved-solutions-property-relocation-transition-move",
            "primary_category": "property-relocation",
            "rotation_group": "solution-relocation-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0030",
            "label": "Controlled Delivery Check",
            "handle": "icon-12-japansolved-process-execution-support-controlled-delivery",
            "primary_category": "execution-support",
            "rotation_group": "process-delivery-01",
            "priority": 63
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "presence-corridor-cards",
          "data-jsi-hierarchy": "mid",
          "data-jsi-visual-owner": "card-title",
          "data-jsi-role": "presence-quality-marker",
          "data-jsi-treatment": "top-left-free",
          "data-jsi-placement": "top-left-inside-card",
          "data-jsi-container": "none",
          "data-jsi-size": "30-40px",
          "data-jsi-needs": "local context | human warmth | scene reading | quiet support",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "presence-tags-and-private-rules",
        "hierarchy": "support",
        "visual_owner": "tag-label",
        "icon_role": "micro-boundary-marker",
        "preferred_treatment": "micro-dot",
        "preferred_placement": "before-label",
        "preferred_container": "none",
        "size_range": "16-22px",
        "exact_icon_needs": [
          "privacy",
          "suitability",
          "boundaries",
          "schedule"
        ],
        "clickable": true,
        "notes": "Tiny symbols only, ideally rotational dots/shields.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0057",
            "label": "Engagement Brief Restricted Advisory",
            "handle": "icon-03-japansolved-engagementbrief-restricted-advisory",
            "primary_category": "advisory-intelligence",
            "rotation_group": "engagement-restricted-advisory-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0028",
            "label": "Analytical Evaluation Lens",
            "handle": "icon-10-japansolved-process-case-review-analytical-evaluation",
            "primary_category": "case-review",
            "rotation_group": "process-evaluation-01",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0188",
            "label": "Scope Boundary Compass",
            "handle": "14-js-faq-vnext-icon-scope-boundary-compass-14",
            "primary_category": "faq-scope",
            "rotation_group": "faq-scope-boundary-compass-14",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0048",
            "label": "Restricted Access Monoline",
            "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
            "primary_category": "privacy-discretion",
            "rotation_group": "monoline-restricted-access-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0055",
            "label": "Engagement Brief Shield Verification",
            "handle": "icon-01-japansolved-engagementbrief-shield-verification",
            "primary_category": "privacy-discretion",
            "rotation_group": "engagement-shield-verification-01",
            "priority": 62
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "presence-tags-and-private-rules",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "tag-label",
          "data-jsi-role": "micro-boundary-marker",
          "data-jsi-treatment": "micro-dot",
          "data-jsi-placement": "before-label",
          "data-jsi-container": "none",
          "data-jsi-size": "16-22px",
          "data-jsi-needs": "privacy | suitability | boundaries | schedule",
          "data-jsi-strictness": "exact"
        }
      },
      {
        "section_key": "profile-background-route-cards",
        "hierarchy": "support",
        "visual_owner": "route-card-title",
        "icon_role": "private-route-marker",
        "preferred_treatment": "drawer-marker",
        "preferred_placement": "top-left-drawer",
        "preferred_container": "none",
        "size_range": "24-32px",
        "exact_icon_needs": [
          "background",
          "private companion",
          "Yamato review",
          "sabbatical reset"
        ],
        "clickable": true,
        "notes": "Route icons should quietly connect profile, background, and payment review.",
        "candidate_registry_ids": [
          {
            "registry_id": "JSICON-0205",
            "label": "Sensitive Matters Mono Line",
            "handle": "09-js-solutions-vnext-icon-private-discreet-matters-mono-line-09",
            "primary_category": "sensitive-matters",
            "rotation_group": "solutions-sensitive-matters-mono-line-09",
            "priority": 52
          },
          {
            "registry_id": "JSICON-0063",
            "label": "Discreet Operations Lens",
            "handle": "icon-16-japansolved-discreet-operations",
            "primary_category": "privacy-discretion",
            "rotation_group": "discreet-operations-01",
            "priority": 64
          },
          {
            "registry_id": "JSICON-0048",
            "label": "Restricted Access Monoline",
            "handle": "japansolved-solutions-icon-discreet-sensitive-private-observation-restricted-monoline",
            "primary_category": "privacy-discretion",
            "rotation_group": "monoline-restricted-access-01",
            "priority": 62
          },
          {
            "registry_id": "JSICON-0150",
            "label": "Acquisition Cases Box",
            "handle": "22-js-case-library-vnext-icon-sourcing-acquisition-cases-22",
            "primary_category": "acquisition-cases",
            "rotation_group": "case-library-acquisition-cases-22",
            "priority": 63
          },
          {
            "registry_id": "JSICON-0154",
            "label": "Sourcing Rare Assets Gem Box",
            "handle": "14-js-case-library-vnext-icon-sourcing-rare-assets-14",
            "primary_category": "rare-asset-sourcing",
            "rotation_group": "case-library-sourcing-rare-assets-14",
            "priority": 61
          }
        ],
        "icon_call_attribute_sketch": {
          "data-jsi-section": "profile-background-route-cards",
          "data-jsi-hierarchy": "support",
          "data-jsi-visual-owner": "route-card-title",
          "data-jsi-role": "private-route-marker",
          "data-jsi-treatment": "drawer-marker",
          "data-jsi-placement": "top-left-drawer",
          "data-jsi-container": "none",
          "data-jsi-size": "24-32px",
          "data-jsi-needs": "background | private companion | Yamato review | sabbatical reset",
          "data-jsi-strictness": "exact"
        }
      }
    ],
    "missing_icon_needs": [
      "portrait profile seal",
      "quiet human warmth icon",
      "companion suitability icon"
    ],
    "title": "Yamato Private Companion Profile",
    "content_id": "yamato-companion-profile",
    "canonical_handle": "yamato-companion-profile",
    "canonical_url": "https://japansolved.com/pages/yamato-companion-profile",
    "source_file": "Yamato Private Companion Profile.txt",
    "source_files_seen": [
      "Yamato Private Companion Profile.txt"
    ],
    "content_type": "landing_page_hidden",
    "status": "pre-swept",
    "batch": "Batch 3",
    "last_pre_swept": "2026-07-06",
    "source_size_bytes": 58916,
    "source_sha1_12": "7b652a5957de",
    "source_signals": {
      "has_centralized_slot_language": true,
      "has_inline_intake_language": true,
      "icon_card_count": 8,
      "pain_card_count": 8,
      "related_card_count": 7,
      "route_card_count": 10,
      "product_card_count": 3,
      "svg_count": 0,
      "img_count": 1,
      "intake_anchor_count": 1,
      "schema_key": null,
      "data_handle": null
    },
    "no_icon_zones": [
      {
        "section_key": "hero-title-group",
        "reason": "Hero copy and image/mask remain the emotional doorway. Do not decorate the hero unless a deliberate oversized emblem slot already exists."
      },
      {
        "section_key": "faq-core-rows",
        "reason": "FAQ number systems and state-aware drawers should own the interaction. Add icons only to side rails, category tabs, or expandable proof drawers, not every FAQ row."
      },
      {
        "section_key": "native-intake-slot",
        "reason": "Native Intake is centralized. Icon pass must not inject page-body icons inside the intake engine, contact transport, validation, review, receipt, or slot marker."
      },
      {
        "section_key": "primary-checkout-buttons",
        "reason": "Buttons should remain typographic. Use icons in adjacent product cards or pricing seals, not inside the main CTA unless a global CTA pattern is approved."
      }
    ],
    "priority_for_rebake": "normal"
  }
};
